export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ActionKey: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  /** Calendar date, canonical YYYY-MM-DD (0001–9999); no timezone conversion. */
  Date: { input: string; output: string; }
  Decimal: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  Int64: { input: number; output: number; }
  JSON: { input: any; output: any; }
  Map: { input: any; output: any; }
  Time: { input: any; output: any; }
  Uint64: { input: any; output: any; }
  join__DirectiveArguments: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  join__FieldValue: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

/**  Input for updating preferences for a preferred AI model.  */
export type AiModelPreferenceInput = {
  /**  Type of category generative AI is to be used for.  */
  category: GenerativeAiCategory;
  /**  Codes of the generative AI models that are to be used.  */
  modelCodes: Array<Scalars['String']['input']>;
  /**  Usage notes for the creative team.  */
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type AbortMultipartUploadInput = {
  /** Integration key of the file to abort the multipart upload for. */
  fileKey: Scalars['ID']['input'];
};

export type AccessControlMutation = {
  __typename?: 'AccessControlMutation';
  grants: GrantMutation;
  roles: RoleMutation;
  tenantAccessPolicies: TenantAccessPolicyMutation;
};

export type AccessControlQuery = {
  __typename?: 'AccessControlQuery';
  catalog: CatalogQuery;
  grants: GrantQuery;
  roles: RoleQuery;
  tenantAccessPolicies: TenantAccessPolicyQuery;
};

/** A single grantable action, e.g. "concept:write". */
export type Action = {
  __typename?: 'Action';
  compatibleGrantScopeKinds: Array<GrantScopeKind>;
  description?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  key: Scalars['ActionKey']['output'];
  label: Scalars['String']['output'];
};

export type ActionCheckResult = {
  __typename?: 'ActionCheckResult';
  passes: Scalars['Boolean']['output'];
};

/** Optional grouping to present actions by resource. */
export type ActionGroup = {
  __typename?: 'ActionGroup';
  actions: Array<Action>;
  name: Scalars['String']['output'];
};

/** Input for adding a new comment to a revision. */
export type AddCommentInput = {
  /** The body text of the comment. */
  message: Scalars['String']['input'];
  /** Revision ID that the comment should be associated with. */
  revisionId: Scalars['ID']['input'];
  /** Visibility tier of the comment. */
  visibility: RevisionCommentVisibility;
};

/** Result of `addComment`. */
export type AddCommentPayload = {
  __typename?: 'AddCommentPayload';
  /** The created comment. */
  comment: Comment;
  /**
   * The revisions whose rendered comment threads gained the comment, in
   * creation order. Members the viewer may not read are omitted; null when
   * no affected members remain for the viewer — whether none exist or none
   * are readable.
   */
  revisions?: Maybe<Array<Revision>>;
  /**
   * Opaque authenticated write-token for this mutation's committed write —
   * the caller's causal anchor ("a read presenting this token happens-after
   * these writes"). Its entries are subject versions (kind/key/source/
   * version), NEVER transport offsets: Kafka offsets and consumer positions
   * are private consumer bookkeeping, not contract. Present it back
   * verbatim as `atLeast` on fence-aware read surfaces
   * (`Comment.viewerOperationChecks`) to ask for read-your-writes; a
   * projection that cannot honor it serves its current answer and DISCLOSES
   * the miss in that surface's convergence meta — never an error, never a
   * null. The token is server-minted and tamper-evident: an altered or
   * constructed token is rejected as a bad request, never evaluated.
   * Minted from the committed write's post-increment row version
   * (docs/state-distribution/rywf-fence-pilot/SCOPE.md, producer slice);
   * null when the serving deployment holds no signing material or the
   * request carries no tenancy to bind the token to — treat null as "no
   * anchor available" and read unfenced.
   */
  writeToken?: Maybe<Scalars['String']['output']>;
};

export type AddDeliverableFormatToConceptInput = {
  advertKey: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliverableFormatAttributes: AdvertsDeliverableFormatInput;
};

export type AddDeliverableFormatToConceptPayload = {
  __typename?: 'AddDeliverableFormatToConceptPayload';
  advert?: Maybe<Advert>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AddVariantToConceptBriefInput = {
  /** Key of the concept brief that should show the variant. */
  conceptKey: Scalars['ID']['input'];
  /** Key of the concept variant to add to the brief. */
  variantKey: Scalars['ID']['input'];
};

export type Advert = {
  __typename?: 'Advert';
  advertsDeliverableFormats: AdvertsDeliverableFormats;
  answers: Array<Answer>;
  archivedAt?: Maybe<Scalars['BigInt']['output']>;
  audienceIntegrationKey?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use Concept.audioUrls instead */
  audioUrl?: Maybe<Scalars['String']['output']>;
  conceptVariations: Adverts;
  containsAi: Scalars['Boolean']['output'];
  designerKeys: Array<Scalars['ID']['output']>;
  integrationKey: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  languageVariationCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use audioUrl instead */
  metaAudioAssetUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numConceptVariations: Scalars['Int']['output'];
  numLanguages: Scalars['Int']['output'];
  objective?: Maybe<Objective>;
  orderKey?: Maybe<Scalars['ID']['output']>;
  originalInputType: OriginalInputType;
  productionNotes?: Maybe<Scalars['String']['output']>;
  questions: Array<Question>;
  submissionState: SubmissionState;
  totalDeliverables?: Maybe<Scalars['Int']['output']>;
  useRootAdvertAnswers: Scalars['Boolean']['output'];
};


export type AdvertAdvertsDeliverableFormatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type AdvertAnswersArgs = {
  actual?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['JSON']['input']>;
};


export type AdvertConceptVariationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type AdvertQuestionsArgs = {
  q?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type AdvertSubmissionStateArgs = {
  revalidate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdvertCreateLegacyInput = {
  advertKey: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderKey: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvertUpdateInput = {
  advertKey?: InputMaybe<Scalars['ID']['input']>;
  audienceKey?: InputMaybe<Scalars['ID']['input']>;
  designerKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  languageVariationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numConceptVariations?: InputMaybe<Scalars['Int']['input']>;
  objective?: InputMaybe<Objective>;
  productionNotes?: InputMaybe<EncodedString>;
  useRootAdvertAnswers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Adverts = {
  __typename?: 'Adverts';
  metadata: Metadata;
  nodes: Array<Advert>;
};

export type AdvertsDeliverableFormat = {
  __typename?: 'AdvertsDeliverableFormat';
  deliverableFormatKey: Scalars['ID']['output'];
  dimensionKey?: Maybe<Scalars['ID']['output']>;
  formatLength: FormatLength;
  hero: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  selectedDimension: AdvertsDeliverableFormatSelectedDimension;
};

export type AdvertsDeliverableFormatInput = {
  deliverableFormatKey: Scalars['ID']['input'];
  dimensions: Array<DeliverableFormatDimensionInput>;
};

export type AdvertsDeliverableFormatSelectedDimension = {
  __typename?: 'AdvertsDeliverableFormatSelectedDimension';
  custom: Scalars['Boolean']['output'];
  height: Scalars['Float']['output'];
  unit: MeasurementUnit;
  width: Scalars['Float']['output'];
};

export type AdvertsDeliverableFormats = {
  __typename?: 'AdvertsDeliverableFormats';
  metadata: Metadata;
  nodes: Array<AdvertsDeliverableFormat>;
};

export enum AgeRange {
  Age18To24 = 'Age18To24',
  Age25To34 = 'Age25To34',
  Age35To44 = 'Age35To44',
  Age45To54 = 'Age45To54',
  Age55To64 = 'Age55To64',
  Age65Plus = 'Age65Plus'
}

export enum AgeRangePreference {
  Age18To24 = 'Age18To24',
  Age25To34 = 'Age25To34',
  Age35To44 = 'Age35To44',
  Age45To54 = 'Age45To54',
  Age55To64 = 'Age55To64',
  Age65Plus = 'Age65Plus',
  Unspecified = 'Unspecified'
}

export type AmplifyDemoImport = {
  __typename?: 'AmplifyDemoImport';
  amplifyMultiformatTemplateComposition: Scalars['String']['output'];
  amplifyMultiformatTemplateID: Scalars['String']['output'];
  amplifyMultiformatTemplateVersion: Scalars['Int']['output'];
  bitrate?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  file?: Maybe<File>;
  fileType?: Maybe<Scalars['String']['output']>;
  framesPerSecond?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  key: Scalars['ID']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  projectKey: Scalars['ID']['output'];
  status: AmplifyDemoImportStatus;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum AmplifyDemoImportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type AmplifyDemoImports = {
  __typename?: 'AmplifyDemoImports';
  nodes: Array<AmplifyDemoImport>;
};

export type AmplifyDemoImportsFilter = {
  key?: InputMaybe<IdFilter>;
};

export type AmplifyDemoImportsParams = {
  filter?: InputMaybe<AmplifyDemoImportsFilter>;
};

export type AmplifyEditorSession = {
  __typename?: 'AmplifyEditorSession';
  amplifyEditToken: Scalars['String']['output'];
  conceptKey: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  renderSessions: Array<RenderTemplateSession>;
  variantKey?: Maybe<Scalars['ID']['output']>;
};

export type AmplifyEditorSessions = {
  __typename?: 'AmplifyEditorSessions';
  nodes: Array<AmplifyEditorSession>;
};

export type AmplifyEditorSessionsFilter = {
  key?: InputMaybe<IdFilter>;
};

export type AmplifyEditorSessionsParams = {
  filter?: InputMaybe<AmplifyEditorSessionsFilter>;
};

export type AmplifyMultiformatTemplate = {
  __typename?: 'AmplifyMultiformatTemplate';
  availableVersions: Array<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** When version is omitted, the latest available version is returned. */
  templateVersion: AmplifyMultiformatTemplateVersion;
};


export type AmplifyMultiformatTemplateTemplateVersionArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type AmplifyMultiformatTemplateVersion = {
  __typename?: 'AmplifyMultiformatTemplateVersion';
  compositions: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** The status of a single render session, keyed for the delivery UI. */
export type AmplifyRenderSessionStatus = {
  __typename?: 'AmplifyRenderSessionStatus';
  /**
   * The key of the parent Amplify editor session, present only when
   * origin = EDITOR_SESSION (lets the delivery UI route to the editor straight
   * from the frame). Null for TEMPLATE renders, which have no editor session.
   */
  editorSessionKey?: Maybe<Scalars['ID']['output']>;
  /** Which owner produced this render — point-and-shoot editor session or templated production. */
  origin: RenderOrigin;
  sessionId: Scalars['String']['output'];
  specificationKey: Scalars['ID']['output'];
  status: RenderTemplateSessionStatus;
};

/** A snapshot of render-session statuses for a set of concepts. */
export type AmplifyRenderStatus = {
  __typename?: 'AmplifyRenderStatus';
  renderSessions: Array<AmplifyRenderSessionStatus>;
};

export type AnalyticsDashboard = {
  __typename?: 'AnalyticsDashboard';
  /** The URL to embed the dashboard. */
  embedUrl: Scalars['String']['output'];
  /** The expiry time of the embed URL. */
  expiry: Scalars['Time']['output'];
};

/**
 * The account-insights dashboards, one field per governing scope. Per-field
 * authorization routes the audience: a field the caller is not authorized for
 * resolves to null, while its sibling still resolves. A field also resolves to
 * null when the caller is authorized but the lane has nothing to show (no
 * visible accounts, or the account set exceeded the embed cap) — the client
 * renders an empty state, never an error. A non-null dashboard is always a
 * signed embed.
 */
export type AnalyticsDashboards = {
  __typename?: 'AnalyticsDashboards';
  /**
   * The dashboard sliced to the organizational units the caller's analytics
   * grants reach; null when no organizational-unit plan authorizes the read,
   * when the plan reaches no accounts, or when the reachable accounts exceed
   * the embed cap.
   */
  organizationalUnitInsights?: Maybe<AnalyticsDashboard>;
  /**
   * The tenancy-wide dashboard behind a tenancy point check; null for callers
   * without tenancy-scoped analytics access.
   */
  tenancyInsights?: Maybe<AnalyticsDashboard>;
};

/** Representing a single contiguous pen stroke on the canvas. */
export type Annotation = {
  __typename?: 'Annotation';
  /** Json string containing all data needed to reconstruct an annotation */
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AnnotationInput = {
  data: Scalars['String']['input'];
};

export type Answer = {
  __typename?: 'Answer';
  files: Array<File>;
  id: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  question: Question;
  questionId: Scalars['ID']['output'];
  questionKey: Scalars['String']['output'];
  questionLabel?: Maybe<Scalars['String']['output']>;
  responseText?: Maybe<Scalars['String']['output']>;
};

export type AnswerCreateInput = {
  questionId?: InputMaybe<Scalars['ID']['input']>;
  questionKey?: InputMaybe<Scalars['String']['input']>;
  responseText?: InputMaybe<EncodedString>;
};

export type AnswerQuestionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  resource: BulkAnswersInput;
};

export type AnswerQuestionsPayload = {
  __typename?: 'AnswerQuestionsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export type ApproveUgcOrderInput = {
  key: Scalars['ID']['input'];
};

export type ArchiveAdvertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationKey: Scalars['ID']['input'];
};

export type ArchiveAdvertPayload = {
  __typename?: 'ArchiveAdvertPayload';
  advert?: Maybe<Advert>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ArchiveBrandAssetsInput = {
  keys: Array<Scalars['ID']['input']>;
};

export type ArchiveBriefingAssetsInput = {
  keys: Array<Scalars['ID']['input']>;
};

export type ArchiveBriefingAssetsPayload = {
  __typename?: 'ArchiveBriefingAssetsPayload';
  success: Scalars['Boolean']['output'];
};

export type ArchiveUgcAssetsInput = {
  /** Integration keys of the UGC Assets to archive */
  keys: Array<Scalars['ID']['input']>;
};

export type ArchiveUgcOrderInput = {
  /** Integration key of the UGC Order to archive */
  key: Scalars['ID']['input'];
};

export type ArchiveUgcDeliverablesInput = {
  /** Integration keys of the UGC Deliverables to archive */
  keys: Array<Scalars['ID']['input']>;
};

export type ArchiveUsersInput = {
  /** Integration keys of the users */
  keys: Array<Scalars['ID']['input']>;
};

export enum ArchivedFilter {
  /** Return only active records */
  False = 'FALSE',
  /** Return all records */
  Include = 'INCLUDE',
  /** Return only archived records */
  True = 'TRUE'
}

export type AssetLink = {
  __typename?: 'AssetLink';
  /** Notes of the asset. */
  note?: Maybe<Scalars['String']['output']>;
  /** URL of the asset. */
  url?: Maybe<Scalars['String']['output']>;
};

export type AssetLinkInput = {
  /** Notes of the asset. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** URL of the asset. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AssociateRenderTemplateInput = {
  amplifyTemplateId?: InputMaybe<Scalars['String']['input']>;
  conceptKey: Scalars['ID']['input'];
  projectKey: Scalars['ID']['input'];
};

export type Attachment = {
  __typename?: 'Attachment';
  file: File;
  id: Scalars['ID']['output'];
};

export type AttachmentInput = {
  fileKey: Scalars['ID']['input'];
};

/** A timestamp with independently optional actor. No timestamp means a null object. */
export type AttributedTime = {
  __typename?: 'AttributedTime';
  at: Scalars['Time']['output'];
  by?: Maybe<Principal>;
};

/** An Audience. */
export type Audience = {
  __typename?: 'Audience';
  ageRanges?: Maybe<Array<AgeRange>>;
  gender?: Maybe<TargetGender>;
  incomeLifestyle?: Maybe<Scalars['String']['output']>;
  interestsAndBehaviours?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type AudienceSubstitution = {
  __typename?: 'AudienceSubstitution';
  currentAudience?: Maybe<Audience>;
  key?: Maybe<Scalars['ID']['output']>;
};

export type Auth0User = {
  __typename?: 'Auth0User';
  /** The auth0 identifier for the user. */
  auth0Id: Scalars['String']['output'];
  /**
   * A flag indicating if this users personal details can be updated.
   * (email, name, picture etc.)
   *
   * Users who sign in using a social account (e.g. Google) will need
   * to manage their personal details via their social account instead.
   */
  canUpdatePersonalDetails: Scalars['Boolean']['output'];
};

/** Enacting approves the concept's unreviewed deliverables. The count may be zero. */
export type AutoApproveDeliverablesEffect = WorkflowTransitionEffect & {
  __typename?: 'AutoApproveDeliverablesEffect';
  /** How many deliverables would be approved if the transition were enacted now; null when the count cannot be determined right now. */
  deliverables?: Maybe<Scalars['Int']['output']>;
  kind: WorkflowTransitionEffectKind;
};

/**
 * The concept goes into production on its unproduced work. Informational:
 * enacting performs nothing for this effect. The count is specifications with
 * nothing delivered against them; product copy may call these deliverables.
 */
export type BeginProductionEffect = WorkflowTransitionEffect & {
  __typename?: 'BeginProductionEffect';
  kind: WorkflowTransitionEffectKind;
  /** How many specifications have nothing delivered against them as things stand; null when the count cannot be determined right now. */
  specifications?: Maybe<Scalars['Int']['output']>;
};

/** A brand asset attached to a Brand Profile. */
export type BrandAsset = {
  __typename?: 'BrandAsset';
  assetType?: Maybe<BrandAssetType>;
  /** Storage-backed file for this brand asset (organization-scoped). */
  file?: Maybe<File>;
  key: Scalars['ID']['output'];
  notes?: Maybe<BrandAssetNote>;
};

export type BrandAssetFilter = {
  assetType?: InputMaybe<BrandAssetType>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandAssetNote = {
  __typename?: 'BrandAssetNote';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum BrandAssetType {
  Audio = 'AUDIO',
  Brand = 'BRAND',
  BrandLogo = 'BRAND_LOGO',
  Compressed = 'COMPRESSED',
  Font = 'FONT',
  Logo = 'LOGO',
  Reference = 'REFERENCE'
}

export type BrandProfile = {
  __typename?: 'BrandProfile';
  /** The timestamp used to resolve this brand profile snapshot. */
  asOf?: Maybe<Scalars['Time']['output']>;
  assetSources: Array<Scalars['String']['output']>;
  audiences: Array<Audience>;
  brandAssets: Array<BrandAsset>;
  brandGuidelines?: Maybe<Scalars['String']['output']>;
  brandNotes?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrationKey: Scalars['ID']['output'];
  /** The market assigned to the Brand Profile */
  market?: Maybe<Market>;
  personality?: Maybe<Scalars['String']['output']>;
  productionNotes?: Maybe<Scalars['String']['output']>;
  socialChannels: Array<Scalars['String']['output']>;
};


export type BrandProfileBrandAssetsArgs = {
  filter?: InputMaybe<BrandAssetFilter>;
};

/** The concept's brief is incomplete. Does not say which parts. */
export type BriefInvalidBlocker = WorkflowTransitionBlocker & {
  __typename?: 'BriefInvalidBlocker';
  reason: WorkflowTransitionBlockedReason;
};

export type BriefingAsset = {
  __typename?: 'BriefingAsset';
  assetType: BriefingAssetType;
  file: File;
  key: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export enum BriefingAssetType {
  Audio = 'AUDIO',
  Compressed = 'COMPRESSED',
  Font = 'FONT',
  Music = 'MUSIC',
  Reference = 'REFERENCE',
  Stills = 'STILLS',
  TextField = 'TEXT_FIELD',
  Video = 'VIDEO'
}

export type BriefingAssets = {
  __typename?: 'BriefingAssets';
  nodes: Array<BriefingAsset>;
};

export type BriefingConceptFormatInput = {
  dimension: DimensionInput;
  formatKey: Scalars['ID']['input'];
  formatLength: FormatLength;
  formatName: Scalars['String']['input'];
  /** Language code to apply to this briefing specification. Defaults to the concept language when omitted. */
  languageCode?: InputMaybe<Scalars['String']['input']>;
  platform: PlatformInput;
  /** The target concept-api variant key for this briefing specification. */
  variantKey: Scalars['ID']['input'];
};

/** How updateBriefingConceptSpecifications applies the formats it is sent. */
export enum BriefingFormatsMode {
  /** The formats are added, or updated where the concept already has them; nothing is removed. */
  Add = 'ADD',
  /** The formats are the concept's complete set: a format the set no longer names is removed, and the whole update is refused when one of them may not be removed. */
  Replace = 'REPLACE'
}

export type BuiltInFile = {
  __typename?: 'BuiltInFile';
  fileName: Scalars['String']['output'];
};

export type BulkAnswersInput = {
  advertKey: Scalars['ID']['input'];
  answers: Array<AnswerCreateInput>;
  orderKey: Scalars['ID']['input'];
};

export type BulkUpdateConceptWorkflowInput = {
  /** The keys for the concepts to update. */
  keys: Array<Scalars['ID']['input']>;
  /** The new workflow stage to set for the concepts. */
  workflowStageCode?: InputMaybe<WorkflowStageCode>;
  /**
   * The new workflow step to set for the concepts.
   * If provided, step must belong to the given stage.
   * Else, moves to default step of the given stage.
   */
  workflowStepKey?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkUpdateConceptWorkflowResult = {
  __typename?: 'BulkUpdateConceptWorkflowResult';
  /** The concepts requested to be updated */
  concepts: Array<Concept>;
  /** Concepts that did not successfully update */
  failedItems: Array<ConceptError>;
};

export type CatalogQuery = {
  __typename?: 'CatalogQuery';
  actions: Array<Action>;
  grantScopeKinds: Array<GrantScopeKindMetadata>;
};

/** CES rating enumeration. */
export enum CesRating {
  /**
   * Difficult.
   * @deprecated Use `Two` instead.
   */
  Difficult = 'Difficult',
  /**
   * Easy.
   * @deprecated Use `Six` instead.
   */
  Easy = 'Easy',
  /** Somewhat easy/satisfied. */
  Five = 'Five',
  /** Neutral. */
  Four = 'Four',
  /**
   * Neither easy or difficult.
   * @deprecated Use `Four` instead.
   */
  Neutral = 'Neutral',
  /** Extremely difficult/unsatisfied. */
  One = 'One',
  /** Extremely easy/satisfied. */
  Seven = 'Seven',
  /** Easy/Satisfied. */
  Six = 'Six',
  /**
   * Somewhat difficult.
   * @deprecated Use `Three` instead.
   */
  SomewhatDifficult = 'SomewhatDifficult',
  /**
   * Somewhat easy.
   * @deprecated Use `Five` instead.
   */
  SomewhatEasy = 'SomewhatEasy',
  /** Somewhat difficult/unsatisfied. */
  Three = 'Three',
  /** Difficult/Unsatisfied. */
  Two = 'Two',
  /**
   * Very difficult.
   * @deprecated Use `One` instead.
   */
  VeryDifficult = 'VeryDifficult',
  /**
   * Very easy.
   * @deprecated Use `Seven` instead.
   */
  VeryEasy = 'VeryEasy'
}

export type ClaimInvitationInput = {
  /** Invitation claim code used to claim the invitation. */
  claimCode: Scalars['String']['input'];
};

export type ClassificationMutation = {
  __typename?: 'ClassificationMutation';
  cohorts: CohortMutation;
};

export type ClassificationQuery = {
  __typename?: 'ClassificationQuery';
  cohorts: CohortQuery;
};

/** ClientAccount represents the root node of a client hierarchy. */
export type ClientAccount = {
  __typename?: 'ClientAccount';
  /**
   * The active HubSpot deals associated with this client account.
   * Active deals are deals that can currently have new projects associated with them.
   *
   * Requires authorization and will be null without the correct permissions.
   */
  activeDeals?: Maybe<Array<HubspotDeal>>;
  /**  Determines whether generative AI is enabled for this client account.  */
  enableGenerativeAI: Scalars['Boolean']['output'];
  /**  Determines whether platform AI is enabled for this client account.  */
  enablePlatformAI: Scalars['Boolean']['output'];
  /**  Determines whether UGC ordering is enabled for this client account.  */
  enableUgcOrdering: Scalars['Boolean']['output'];
  /**  The generative AI preferences associated with this client account.  */
  generativeAIPreferences: Array<GenerativeAiPreference>;
  /**  The CreativeX integration for the client account.  */
  integrations: ClientAccountIntegrations;
  /** The organizational unit key of the client account. */
  key: Scalars['ID']['output'];
  /**
   * The organizational unit backing this client account. Nullable by contract:
   * the unit's cross-subgraph fields resolve in ORGANIZATION under the viewer's
   * `ou:read` plan, so a viewer without that grant yields null here.
   */
  organizationalUnit?: Maybe<OrganizationalUnit>;
  /**
   * Determines whether projects for this client require a HubSpot deal to be associated with them.
   * If true, projects must have a HubSpot deal associated before moving the project to production review.
   */
  requireHubspotDeals: Scalars['Boolean']['output'];
};

/**  Input for updating generative AI preferences for a client account.  */
export type ClientAccountGenerativeAiPreferencesInput = {
  /**  The organizational unit key of the client account to update.  */
  key: Scalars['ID']['input'];
  /**  The preferred models for each category of generative AI.  */
  preferredModels: Array<AiModelPreferenceInput>;
};

export type ClientAccountIntegrations = {
  __typename?: 'ClientAccountIntegrations';
  /** The organizational unit key of the client account */
  clientAccountKey: Scalars['ID']['output'];
  /** The CreativeX integration for the client account */
  creativeX?: Maybe<CreativeXIntegration>;
};

/** Centralized entity stub for ClientBrand. */
export type ClientBrand = {
  __typename?: 'ClientBrand';
  /** Account associated with the brand */
  clientAccount: ClientAccount;
  /** The assigned CreativeX brand */
  creativeXBrand?: Maybe<CreativeXBrand>;
  /** The default project visibility for projects created under this brand. */
  defaultProjectVisibility: ProjectVisibility;
  /** The organizational unit key of the client brand */
  key: Scalars['ID']['output'];
  /**
   * The organizational unit backing this client brand. Nullable by contract,
   * matching ClientAccount.organizationalUnit: Client and Brand degrade
   * together for a viewer without ou:read.
   */
  organizationalUnit?: Maybe<OrganizationalUnit>;
  /** Internal production notes for the client brand. */
  productionNotes?: Maybe<Scalars['String']['output']>;
};

/** Centralized entity stub for ClientGroup. */
export type ClientGroup = {
  __typename?: 'ClientGroup';
  /** The organizational unit key of the client group. */
  key: Scalars['ID']['output'];
  organizationalUnit: OrganizationalUnit;
};

/**
 * A cohort: a named, tenancy-scoped, operator-authored set of principals that
 * treatment bindings and domain-owned cohort references address.
 */
export type Cohort = {
  __typename?: 'Cohort';
  /** Whether the cohort is archived (bindings stop applying). */
  archived: Scalars['Boolean']['output'];
  /** The UTC timestamp when the cohort was archived. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The UTC timestamp when the cohort was created. */
  createdAt: Scalars['Time']['output'];
  /** Optional operator note on who the cohort is for. */
  description?: Maybe<Scalars['String']['output']>;
  /** The operator-authored identity of the cohort; immutable after create. */
  key: Scalars['String']['output'];
  /**
   * Membership size per source — the bounded view of sources whose row
   * counts are unbounded. One entry per source in the closed set, in
   * declaration order, reporting zero when a source has no rows. Sizes are
   * per-source ROW counts: a principal present in several sources counts
   * once per source, so the sum is NOT effective membership — that is the
   * distinct principal set, which the paginated cohortMembers query
   * exposes. Loaded on single-cohort reads; empty on list rows.
   */
  memberCounts: Array<CohortMemberSourceCount>;
  /**
   * Principals excluded from membership regardless of source — the
   * deny-wins half of the membership algebra:
   * member = (rule-match OR explicit) AND NOT excluded. Operator-curated
   * and bounded like the explicit roster (at most 1000). Loaded on
   * single-cohort reads; empty on list rows.
   */
  memberExclusions: Array<CohortMemberExclusion>;
  /**
   * The EXPLICIT membership roster — operator-authored rows only, bounded
   * by the explicit-membership cap. Compiled sources are unbounded (a rule
   * may match a whole tenancy), so they surface through memberCounts here
   * and are enumerated via the paginated cohortMembers query. Loaded on
   * single-cohort reads; empty on list rows.
   */
  members: Array<CohortMember>;
  /**
   * The rule-based membership source: a conjunction of trait predicates the
   * membership compiler materializes into provenance-tagged member rows.
   * Empty means the cohort has no rule-based source (explicit membership
   * only) — never match-everyone. Reads are tolerant: a persisted rule
   * that no longer parses against the trait catalog also reads as empty
   * (logged server-side) rather than erroring the cohort — the stored
   * document is untouched, and the compiler freezes that cohort's rule
   * lane rather than treating the drift as an authored empty rule.
   */
  membershipRule: Array<TraitPredicate>;
  /** Display name of the cohort. */
  name: Scalars['String']['output'];
  /** The cohort's treatment bindings. Loaded on single-cohort reads; empty on list rows. */
  treatmentBindings: Array<CohortTreatmentBinding>;
  /** The UTC timestamp when the cohort was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type CohortConnection = {
  __typename?: 'CohortConnection';
  nodes: Array<Cohort>;
  pageInfo: OffsetPageInfo;
};

export type CohortMember = {
  __typename?: 'CohortMember';
  /**
   * The member principal — membership rows key principals (the PrincipalGrant
   * shape). The cohort lane attaches the user/profile tier from its own
   * tenant-fenced read; other tiers resolve under the principal's own plans.
   */
  principal?: Maybe<Principal>;
  /** The membership source this row is a fact of — a principal in several sources holds a row per source. */
  source: CohortMemberSource;
};

/**
 * A principal barred from the cohort regardless of membership source.
 * Exclusions are compiler input and a write-time coherence guard (an explicit
 * membership and an exclusion cannot coexist for the same principal), so the
 * member list stays the effective set.
 */
export type CohortMemberExclusion = {
  __typename?: 'CohortMemberExclusion';
  /** The excluded principal, in the same reference shape as members. */
  principal?: Maybe<Principal>;
};

/**
 * The membership source a row is a fact of. A row is one (principal, source)
 * fact, so overlapping sources coexist as separate rows and each lane
 * converges ONLY its own source: the operator lane explicit, the compiler
 * rule. Effective membership is the distinct principal set. Future sources
 * (group expansion) extend this enum.
 */
export enum CohortMemberSource {
  /** Operator-authored explicit membership. */
  Explicit = 'EXPLICIT',
  /** Materialized by the membership compiler from the cohort's rule. */
  Rule = 'RULE'
}

/** Membership size for one source. */
export type CohortMemberSourceCount = {
  __typename?: 'CohortMemberSourceCount';
  count: Scalars['Int']['output'];
  source: CohortMemberSource;
};

/**
 * One distinct member principal of a cohort with every membership source
 * holding a fact row for it — the provenance the admin roster renders as
 * chips. Effective membership is exactly this distinct set.
 */
export type CohortMembership = {
  __typename?: 'CohortMembership';
  /** The member principal, in the same reference shape as the explicit roster. */
  principal?: Maybe<Principal>;
  /** Every source holding a fact row for this principal, in declaration order. */
  sources: Array<CohortMemberSource>;
};

export type CohortMembershipConnection = {
  __typename?: 'CohortMembershipConnection';
  nodes: Array<CohortMembership>;
  pageInfo: OffsetPageInfo;
};

export type CohortMutation = {
  __typename?: 'CohortMutation';
  /**
   * Archive a cohort: its treatment bindings stop applying and writes other
   * than restore are rejected. Idempotent.
   */
  archiveCohort: Scalars['Boolean']['output'];
  /** Author a new cohort. The key is immutable after create. */
  createCohort: Cohort;
  /** Restore an archived cohort. Idempotent. */
  restoreCohort: Cohort;
  /**
   * Update the cohort in one transaction: display fields always, membership
   * and bindings when their input fields are provided (the roles-lane shape —
   * one save, one commit, never a partially applied definition). Archived
   * cohorts reject updates.
   */
  updateCohort: Cohort;
};


export type CohortMutationArchiveCohortArgs = {
  key: Scalars['String']['input'];
};


export type CohortMutationCreateCohortArgs = {
  input: CreateCohortInput;
};


export type CohortMutationRestoreCohortArgs = {
  key: Scalars['String']['input'];
};


export type CohortMutationUpdateCohortArgs = {
  input: UpdateCohortInput;
  key: Scalars['String']['input'];
};

export type CohortQuery = {
  __typename?: 'CohortQuery';
  /** Retrieve a cohort by its authored key, with members and bindings. */
  cohort?: Maybe<Cohort>;
  /**
   * Page one cohort's membership as the DISTINCT principal set with
   * per-principal source provenance — the enumeration surface for compiled
   * sources, whose row counts are unbounded, and the effective-membership
   * view (a principal holding rows in several sources appears once, with
   * every source it holds). Ordered by principal key, stable across pages.
   * The optional source filter selects principals holding a fact in THAT
   * source; each entry still reports all of its sources.
   */
  cohortMembers: CohortMembershipConnection;
  /** Page cohort definitions. */
  cohorts: CohortConnection;
};


export type CohortQueryCohortArgs = {
  key: Scalars['String']['input'];
};


export type CohortQueryCohortMembersArgs = {
  cohortKey: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<CohortMemberSource>;
};


export type CohortQueryCohortsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<CohortSort>;
};

export enum CohortSort {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type CohortTreatmentBinding = {
  __typename?: 'CohortTreatmentBinding';
  effect: CohortTreatmentBindingEffect;
  treatment: Treatment;
};

/**
 * Binding polarity per the combination algebra
 * (effective = (default OR any confer) AND NOT any suppress): CONFER turns the
 * treatment on for members; SUPPRESS turns it off, always.
 */
export enum CohortTreatmentBindingEffect {
  Confer = 'CONFER',
  Suppress = 'SUPPRESS'
}

export type CohortTreatmentBindingInput = {
  effect: CohortTreatmentBindingEffect;
  treatment: Treatment;
};

export type CollectionMeta = {
  __typename?: 'CollectionMeta';
  recordCount: Scalars['Int']['output'];
};

/**
 * Comment associated with a revision. The `@key` publishes the comment as a
 * federated entity so the authz subgraph can extend it with the
 * operation-check entry (`viewerOperationChecks`), exactly like the sibling
 * viewer-action-check families. The key is resolvable ONLY because the authz
 * extension's `@requires(fields: "factsWatermark")` needs the owner-side
 * condition edge to compose (satisfiability is checked against key edges, not
 * against the planner's same-fetch collection of the required field); the
 * entity resolver is a key echo serving identity plus `factsWatermark` and
 * NOTHING else. Comment CONTENT still only ever enters through this
 * subgraph's own fields: no subgraph declares a field returning Comment
 * references, so no plannable query fetches content through a
 * representation — adding one would serve zero-value content from the echo
 * resolver and is forbidden, and the ban is ENFORCED at the compose gate by
 * TestSupergraphCommentContentIsolation (tests/supergraph-contracts), which
 * pins the closed set of Comment-returning fields across every subgraph AND
 * that the revision graph alone serves each of them.
 * The wire `id` VALUE is the comment's integration key
 * (docs/revision-comment-ownership/SCOPE.md Phase 3b).
 */
export type Comment = {
  __typename?: 'Comment';
  /**
   * The author of this comment, as a `Principal` reference; select `profile`
   * for display identity. Null when the comment has no author principal.
   */
  author?: Maybe<Principal>;
  /** Created at time. */
  createdAt: Scalars['Time']['output'];
  /**
   * The read-your-writes fence's @requires transport: this comment's own
   * serve-time causal anchor (an opaque write-token over the row's
   * `row_version` as served), carried by the router into sibling subgraphs'
   * fence-aware entity fields (`viewerOperationChecks`) so their projections
   * can be held at-least-as-fresh as the row the viewer is looking at —
   * with no client round-trip. Subject versions only, never transport
   * offsets. @inaccessible: router plumbing, never client-selectable.
   * Minted at serve from the row's version
   * (docs/state-distribution/rywf-fence-pilot/SCOPE.md, producer slice);
   * null when the serving deployment holds no signing material, the
   * request carries no tenancy to bind the token to, or the row predates
   * the version field — no anchor, the sibling read stays unfenced.
   */
  factsWatermark?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Is the comment a rejection of a revision. */
  isRejection: Scalars['Boolean']['output'];
  /** The body text of the comment. */
  message: Scalars['String']['output'];
  /** Last updated at time. */
  updatedAt: Scalars['Time']['output'];
  /**
   * Advisory manage answers for this comment. Nullable by contract (the
   * OrganizationalUnit viewer-action precedent): the surface is a UX guard,
   * not enforcement, so a consumer that cannot get an answer treats null as
   * not-permitted and degrades — a failed check hop must never take the
   * comment list down with it. This field is the first authz-owned hop
   * inside the revision pages' non-null comment chain; the nullable
   * declaration is what stops an authz fault from nulling the page.
   *
   * Fence-aware (the read-your-writes fence pilot,
   * docs/state-distribution/rywf-fence-pilot/SCOPE.md): the answers carry a
   * per-check `convergence` disclosure, anchored by the representation-borne
   * `factsWatermark` and/or the caller-presented `atLeast`. A convergence
   * miss is served-and-disclosed — never an error, never a null. With no
   * token anywhere the read is unfenced and behaves exactly as today.
   */
  viewerOperationChecks?: Maybe<Array<CommentOperationCheck>>;
  /** Visibility tier of the comment. */
  visibility: RevisionCommentVisibility;
};


/**
 * Comment associated with a revision. The `@key` publishes the comment as a
 * federated entity so the authz subgraph can extend it with the
 * operation-check entry (`viewerOperationChecks`), exactly like the sibling
 * viewer-action-check families. The key is resolvable ONLY because the authz
 * extension's `@requires(fields: "factsWatermark")` needs the owner-side
 * condition edge to compose (satisfiability is checked against key edges, not
 * against the planner's same-fetch collection of the required field); the
 * entity resolver is a key echo serving identity plus `factsWatermark` and
 * NOTHING else. Comment CONTENT still only ever enters through this
 * subgraph's own fields: no subgraph declares a field returning Comment
 * references, so no plannable query fetches content through a
 * representation — adding one would serve zero-value content from the echo
 * resolver and is forbidden, and the ban is ENFORCED at the compose gate by
 * TestSupergraphCommentContentIsolation (tests/supergraph-contracts), which
 * pins the closed set of Comment-returning fields across every subgraph AND
 * that the revision graph alone serves each of them.
 * The wire `id` VALUE is the comment's integration key
 * (docs/revision-comment-ownership/SCOPE.md Phase 3b).
 */
export type CommentViewerOperationChecksArgs = {
  atLeast?: InputMaybe<Scalars['String']['input']>;
  operations: Array<CommentOperation>;
};

/**
 * Semantic operations on a revision comment. Values mirror the mutation verbs
 * (`editComment` / `removeComment`), never ACL action IDs: the enforcement
 * actions are owner-or-grant-checked while the state predicates live here.
 */
export enum CommentOperation {
  Edit = 'EDIT',
  Remove = 'REMOVE'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * extends Comment with `viewerOperationChecks`); this subgraph contributes the
 * `validation` leg — the domain's registered state invariants.
 */
export type CommentOperationCheck = {
  __typename?: 'CommentOperationCheck';
  authorization: ActionCheckResult;
  commentKey: Scalars['ID']['output'];
  /**
   * Convergence disclosure for this check's `authorization` answer — the
   * third leg beside the authorization and (revision-owned) validation legs
   * (the read-your-writes fence pilot). Rendering rule: `authorization` says
   * what the projection answered; `convergence` says whether that answer is
   * known to happen-after the caller's anchor. A denying answer whose meta
   * makes no convergence claim against a token the caller presented is a
   * PENDING deny — render it provisional and re-check; staleness must never
   * be conflated with denial (the entity-denial shape ruling).
   */
  convergence: ConvergenceMeta;
  operation: CommentOperation;
  /**
   * Pure domain leg: does the comment's state admit this operation.
   * Caller-blind — archived comments admit nothing, and a rejection comment
   * refuses REMOVE for everyone (it is the durable record of the reject
   * decision; the store enforces the same invariants at the write seam).
   */
  validation: ActionCheckResult;
};

export type CompleteMultipartUploadInput = {
  /** Integration key of the file to complete the multipart upload for. */
  fileKey: Scalars['ID']['input'];
  /** The ETag of each part, in the same order as the part numbers. */
  parts: Array<MultipartUploadPartInput>;
};

/** A Concept. */
export type Concept = {
  __typename?: 'Concept';
  amplifyEditorSessions: AmplifyEditorSessions;
  /**
   * Whether the concept is archived. A concept is archived, never deleted;
   * reads serve archived concepts only when asked to (ConceptFilters).
   */
  archived: Scalars['Boolean']['output'];
  /** The time the concept was archived; null while the concept is live. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  audioUrls: Array<Scalars['String']['output']>;
  brief?: Maybe<ConceptBrief>;
  /** Indicates whether the concept can be deleted. */
  canDelete: Scalars['Boolean']['output'];
  /**
   * The list of workflow stage codes the user can update the concept to.
   * @deprecated Use Concept.workflowTransitions or Concept.workflowTransitionOffer instead.
   */
  canUpdateConceptWorkflow: Array<WorkflowStageCode>;
  containsAi: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  customProperties: Array<CustomPropertyCheckbox | CustomPropertyDate | CustomPropertyNumber | CustomPropertyRichText | CustomPropertySelect | CustomPropertyText | CustomPropertyUser>;
  /** Applicable custom property definitions for this concept. */
  customPropertyDefinitions: Array<CustomPropertyDefinition>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  firstSubmission?: Maybe<AttributedTime>;
  /** @deprecated use key instead */
  integrationKey: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  lastActivity?: Maybe<AttributedTime>;
  /**
   * The most recent transactional entry into the Approved workflow stage;
   * null until the concept has been approved. Never cleared when the concept
   * leaves Approved, so a non-null value is the durable answer to whether
   * the concept has ever been approved. Written only by a concept workflow
   * transition, in that transition's own transaction — so it is readable
   * immediately after the mutation that produced it, and an approval reached
   * through the legacy deliverable-specification flow does not set it.
   */
  lastApprovedAt?: Maybe<Scalars['Time']['output']>;
  /** @deprecated Use Concept instead. Fields to be moved to Concept. */
  legacyAdvert: Advert;
  /**
   * Proposed read-only effective members: Concept User-property principals first,
   * then additional inherited Project principals; each principal appears once.
   * A dual-route principal stays in the Concept group. Empty means known none.
   * Ordering/dedup proposal awaits final UX acceptance; no direct member editing.
   */
  members?: Maybe<Array<Principal>>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The number the concept's next variant takes: one above the highest
   * sequence the concept has ever allocated, removed variants included. A
   * (concept, sequence) slot is identity and is never reused — a removed
   * variant keeps its number — so the visible roster's last number plus one
   * can name a slot a removed variant still holds and be refused. Read this
   * before proposing or sending an explicit sequence; a createVariant
   * without a sequence allocates this same number. 1 for a concept with no
   * variants yet.
   */
  nextVariantSequence: Scalars['Int']['output'];
  /**
   * Deprecated
   * @deprecated use brief
   */
  productOrService?: Maybe<Scalars['String']['output']>;
  project: Project;
  renderTemplate?: Maybe<RenderTemplate>;
  /** Immutable project-scoped serial number for spec-facing concept identity. Historical rows may be null until the backfill has run. */
  serialNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * The Concept's physical specification rows, each row once. Omitted, null or
   * false counts the rows that are not archived, by their own status or the
   * Concept's; true counts every row, archived rows included. Null with an error
   * when the Concept is not readable.
   */
  specificationCount?: Maybe<Scalars['Int']['output']>;
  /** The list of deliverable specifications associated with the concept. */
  specifications: DeliverableSpecifications;
  ugcOrder?: Maybe<UgcOrder>;
  /**
   * The concept's variants. Present the save's writeToken as atLeast to wait
   * bounded for its variant edits before reading the roster. The disclosure
   * names variant entries that have not reached their promised prefix.
   */
  variants: Variants;
  /**
   * Advisory operation-check answers for this concept. Nullable by contract
   * (fleet rule P1, the OrganizationalUnit precedent): the surface is a UX
   * guard, not enforcement, so a consumer that cannot get an answer treats
   * null as not-permitted and degrades — a failed check hop must never take
   * the page data down with it.
   */
  viewerOperationChecks?: Maybe<Array<ConceptOperationCheck>>;
  /**
   * The workflow catalogue version the workflowStage/workflowStep labels
   * and positions were read from. Null when the concept carries no workflow state.
   */
  workflowCatalogueVersion?: Maybe<Scalars['Int']['output']>;
  /**
   * The current workflow stage of the concept.
   *
   * This will be null if concept based workflow is not enabled.
   */
  workflowStage?: Maybe<WorkflowStage>;
  /** The time the concept entered its current workflow stage. Historical rows may be null until workflow state has been initialized. */
  workflowStageStartedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The current workflow step of the concept.
   *
   * This will be null if concept based workflow is not enabled.
   */
  workflowStep?: Maybe<WorkflowStep>;
  /**
   * The one transition recommended for this concept on the given surface —
   * for example, what a surface's primary call to action enacts. Always one of
   * the entries in workflowTransitions. It may be blocked; render it with its
   * blockedReasons.
   *
   * Null when the surface has nothing to offer this concept, including when
   * the concept is already where the surface would take it.
   */
  workflowTransitionOffer?: Maybe<ConceptWorkflowTransition>;
  /**
   * The transitions that can move this concept from its current workflow
   * position, evaluated for this concept as things stand.
   *
   * Includes a transition that is currently blocked, with blockedReasons
   * saying what to fix. Omits a transition whose preconditions are not met,
   * one the viewer cannot see, and any transition that would leave the concept
   * where it is. Whether the viewer may enact an entry is answered by its
   * viewerActionChecks with the EXECUTE action.
   *
   * Ordered by each entry's position, lowest first, with position 0 last;
   * entries with the same position are ordered by destination (stage
   * position, then step position). This is a reading order, not a
   * recommendation: for the transition a surface should offer, use
   * workflowTransitionOffer. Entries landing in the same stage need not be
   * adjacent; each entry carries its destination's stage and step positions,
   * so a client can group or re-sort without reading the workflow.
   *
   * Empty when the concept has nowhere to go.
   */
  workflowTransitions: Array<ConceptWorkflowTransition>;
};


/** A Concept. */
export type ConceptAmplifyEditorSessionsArgs = {
  params?: InputMaybe<AmplifyEditorSessionsParams>;
};


/** A Concept. */
export type ConceptSpecificationCountArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Concept. */
export type ConceptSpecificationsArgs = {
  params?: InputMaybe<DeliverableSpecificationsParams>;
};


/** A Concept. */
export type ConceptVariantsArgs = {
  atLeast?: InputMaybe<Scalars['String']['input']>;
};


/** A Concept. */
export type ConceptViewerOperationChecksArgs = {
  operations: Array<ConceptOperation>;
};


/** A Concept. */
export type ConceptWorkflowTransitionOfferArgs = {
  surface: WorkflowSurface;
};

export enum ConceptApproach {
  Native = 'Native',
  NonNative = 'NonNative',
  SemiNative = 'SemiNative'
}

export type ConceptBrief = {
  __typename?: 'ConceptBrief';
  /** Asset links and notes to be associated with the concept. */
  assetLinks?: Maybe<Array<AssetLink>>;
  assets: BriefingAssets;
  audience?: Maybe<Audience>;
  /** Check whether the concept brief is valid. */
  briefValid: Scalars['Boolean']['output'];
  /** Variants associated with this concept brief. Items may be null if a referenced variant is no longer available. */
  briefVariants: Array<Maybe<Variant>>;
  /** Disclaimer for the concept. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Rich text describing the story to communicate, any creative ideas and direction, and what makes this concept different to others in the project. */
  idea?: Maybe<Scalars['String']['output']>;
  key: Scalars['ID']['output'];
  /** Detected ISO-639 language code for the concept brief. */
  languageCodeDetected?: Maybe<Scalars['String']['output']>;
  /** Optional localisation details for this concept */
  localisation?: Maybe<ConceptLocalisation>;
  /** The market assigned to the Concept */
  market?: Maybe<Market>;
  /** Product or service this concept is promoting. */
  productOrService?: Maybe<Scalars['String']['output']>;
  projectKey: Scalars['ID']['output'];
  scenes: Array<Scene>;
  /** Modular Sections that have been added to the Concept */
  sectionsV2: ConceptBriefSections;
  /** The template brief used to create this concept brief (immutable). */
  sourceTemplateBrief?: Maybe<TemplateBrief>;
};

export type ConceptBriefQuestion = {
  __typename?: 'ConceptBriefQuestion';
  answer?: Maybe<Answer>;
  conceptBriefKey: Scalars['ID']['output'];
  isFormatQuestion: Scalars['Boolean']['output'];
  question: Question;
  questionId: Scalars['ID']['output'];
  questionKey: Scalars['String']['output'];
};

export type ConceptBriefQuestions = {
  __typename?: 'ConceptBriefQuestions';
  nodes: Array<ConceptBriefQuestion>;
};

export type ConceptBriefSection = {
  __typename?: 'ConceptBriefSection';
  /** Key of the ConceptBrief this section belongs to */
  conceptBriefKey: Scalars['ID']['output'];
  questions: ConceptBriefQuestions;
  /** The template section */
  section: QuestionSectionV2;
  /** Key of the Section */
  sectionKey: Scalars['String']['output'];
  /** Indicates whether the section was manually selected for this concept brief. */
  selected: Scalars['Boolean']['output'];
};

export type ConceptBriefSections = {
  __typename?: 'ConceptBriefSections';
  nodes: Array<ConceptBriefSection>;
};

export type ConceptCountSortInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConceptDueDatePayload = {
  __typename?: 'ConceptDueDatePayload';
  changed: Scalars['Boolean']['output'];
  concept: Concept;
};

export type ConceptError = {
  __typename?: 'ConceptError';
  /** Key of the concept that failed to update */
  conceptKey: Scalars['ID']['output'];
  /** Error message */
  errorMessage: Scalars['String']['output'];
};

export type ConceptFilters = {
  /** Indicates whether archived concepts can be retrieved. Defaults to FALSE. */
  includeArchived?: InputMaybe<ArchivedFilter>;
};

/** One group of matched concepts under the requested groupBy. */
export type ConceptGroup = {
  __typename?: 'ConceptGroup';
  /** Total matched concepts in this group; may exceed the returned list. */
  conceptCount: Scalars['Int']['output'];
  /**
   * The group's matched concepts in the request's `sort` order, capped
   * at 100 per group.
   */
  concepts: Array<Concept>;
  /** The group key (PROJECT: the project key). */
  key: Scalars['ID']['output'];
  /** The group's project. Null when the project entity cannot be resolved for the caller. */
  project?: Maybe<Project>;
};

/** Interim type for concept until concept type implements field level access control */
export type ConceptLite = {
  __typename?: 'ConceptLite';
  key: Scalars['ID']['output'];
  productOrService?: Maybe<Scalars['String']['output']>;
};

export type ConceptLocalisation = {
  __typename?: 'ConceptLocalisation';
  /** Details about asset requirements */
  assetDetails?: Maybe<Scalars['String']['output']>;
  /** A list of asset links for this localisation */
  assetLinks: Array<AssetLink>;
  /** A list of assets for this localisation */
  assets: Array<File>;
  /** Details about copy requirements */
  copyDetails?: Maybe<Scalars['String']['output']>;
  /** Optional URL of any external document or spreadsheet containing translations */
  externalTranslationLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Flag indicating whether this localisation includes alternative assets */
  includesAssets: Scalars['Boolean']['output'];
  /** Flag indicating whether this localisation includes alternative copy */
  includesCopy: Scalars['Boolean']['output'];
  /** Flag indicating whether this localisation includes alternative voiceovers */
  includesVoiceovers: Scalars['Boolean']['output'];
  /** Instructions describing requirements for the localisation */
  instructions: Scalars['String']['output'];
  /** Primary target market (aka source locale) */
  primaryMarketLocale: Locale;
  /** A list of target markets required for this localisation */
  targetMarketLocales: Array<Locale>;
  /** Details about voiceover requirements */
  voiceoverDetails?: Maybe<Scalars['String']['output']>;
};

/**
 * Semantic operations on a concept. Values are user-intent affordance verbs
 * (the fleet contract, docs/viewer-operation-checks/SCOPE.md), never ACL
 * action IDs: the enforcement actions are the authz subgraph's concern —
 * documented on its declaration's value doc strings — while the state
 * predicates live here. Declared identically in both subgraphs.
 */
export enum ConceptOperation {
  /**
   * Capability to open an Amplify editor session for this concept:
   * preflights the same amplify_editor_session:create decision the
   * session-create surface enforces at the concept.
   */
  CreateEditorSession = 'CREATE_EDITOR_SESSION',
  /**
   * Capability to create a variation under this concept: preflights the
   * concept:write the variant mutations (createVariant /
   * updateVariantSpecifications) carry today.
   */
  CreateVariation = 'CREATE_VARIATION',
  /**
   * Capability to edit the concept itself (custom property values, removal):
   * preflights the same concept:write decision those mutations enforce at
   * the concept.
   */
  Edit = 'EDIT',
  /**
   * Capability to edit the concept's brief: preflights the same
   * concept:write decision the brief write surfaces enforce at the concept.
   */
  EditBrief = 'EDIT_BRIEF',
  /**
   * Capability to move the concept through its workflow: preflights the same
   * concept:workflow:write decision updateConceptWorkflow and the bulk
   * workflow mutation enforce at the concept. Concept-level by design —
   * distinct from the per-transition ConceptWorkflowTransition EXECUTE
   * check, which answers enactability of one offered transition row.
   */
  UpdateWorkflow = 'UPDATE_WORKFLOW'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * extends Concept with `viewerOperationChecks`); this subgraph contributes
 * the `validation` leg — the domain's registered state invariants.
 */
export type ConceptOperationCheck = {
  __typename?: 'ConceptOperationCheck';
  authorization: ActionCheckResult;
  conceptKey: Scalars['ID']['output'];
  operation: ConceptOperation;
  /**
   * Pure domain leg: does the concept's state admit this operation.
   * Caller-blind. No concept operation carries a domain state gate today,
   * so every predicate is trivially true (fleet rule P4 — the batch is a
   * re-keying, not a guard promotion); candidates for later promotion are
   * recorded in docs/viewer-operation-checks-concept/SCOPE.md.
   */
  validation: ActionCheckResult;
};

export type ConceptSortOptionsInput = {
  /** Archive option of the specificationCount sort. */
  specificationCount?: InputMaybe<SpecificationCountSortInput>;
};

export type ConceptStageCount = {
  __typename?: 'ConceptStageCount';
  count: Scalars['Int']['output'];
  stage: WorkflowStageCode;
};

export type ConceptStatusFilter = {
  /** Omitted/null excludes archived; true includes active and archived. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConceptStatusSummary = {
  __typename?: 'ConceptStatusSummary';
  stages: Array<ConceptStageCount>;
  total: Scalars['Int']['output'];
};

/**
 * A move available to one concept: where it goes, whether anything stands in
 * the way, and what else enacting it will do. The server evaluates the
 * workflow's rules; clients render these fields and do not need to interpret
 * the workflow themselves.
 */
export type ConceptWorkflowTransition = {
  __typename?: 'ConceptWorkflowTransition';
  /**
   * What currently prevents this transition from being enacted, as things the
   * user can fix. Empty when it can be enacted now. Each blocker is typed by
   * its reason and carries the data that reason is about, such as a count.
   *
   * A blocker whose condition cannot be checked right now is left out; if it
   * still cannot be checked when the transition is enacted, the outcome is
   * UNEVALUATED. Permission is never a blocker — see viewerActionChecks.
   */
  blockedReasons: Array<BriefInvalidBlocker | ExistingDeliverablesBlocker | NoDeliverablesBlocker | OpenRevisionsBlocker | UndeliveredSpecificationsBlocker | UnreviewedDeliverablesBlocker>;
  /** The concept this transition is evaluated for. */
  conceptKey: Scalars['ID']['output'];
  /**
   * What enacting this transition will do besides moving the concept, as the
   * user should be told it, each with the count it would act on as things
   * stand — for example, how many unreviewed deliverables will be approved.
   * Empty when there is nothing to tell the user.
   *
   * An effect is listed whenever the transition has it. A count that cannot
   * be determined right now is null; the effect is still listed.
   */
  effects: Array<AutoApproveDeliverablesEffect | BeginProductionEffect | ReviseDeliverablesEffect>;
  /**
   * Identifies the transition. The same transition has the same key on every
   * concept that offers it, and no two transitions on one concept share a
   * destination step. Pass it to transitionConceptWorkflow unchanged; treat it
   * as opaque.
   */
  key: Scalars['ID']['output'];
  /**
   * This transition's place in the order workflowTransitions returns, lowest
   * first. It orders transitions in a list; it is not a position in the
   * workflow, which toStage.position and toStep.position describe.
   *
   * 0 means the transition has no assigned place; such transitions come after
   * every transition that has one.
   *
   * It belongs to the transition, not to the concept or the surface, so a
   * transition has the same position wherever it appears, and a client
   * combining entries from several concepts can restore the intended order
   * from it. It expresses no preference and does not decide what
   * workflowTransitionOffer returns.
   */
  position: Scalars['Int']['output'];
  /** The stage the concept moves into. */
  toStage: WorkflowStage;
  /** The step the concept moves to. Every transition lands on a specific step. */
  toStep: WorkflowStep;
  /**
   * Advisory viewer-action answers for this transition. Nullable by contract
   * (the OrganizationalUnit precedent): the surface is a UX guard, not
   * enforcement, so a consumer that cannot get an answer treats null as
   * not-permitted and degrades — a failed authorization hop must never null
   * the transition entry or the concept it hangs from.
   */
  viewerActionChecks?: Maybe<Array<ConceptWorkflowTransitionViewerActionCheck>>;
};


/**
 * A move available to one concept: where it goes, whether anything stands in
 * the way, and what else enacting it will do. The server evaluates the
 * workflow's rules; clients render these fields and do not need to interpret
 * the workflow themselves.
 */
export type ConceptWorkflowTransitionViewerActionChecksArgs = {
  actions: Array<ConceptWorkflowTransitionAction>;
};

export enum ConceptWorkflowTransitionAction {
  /**
   * Capability to enact this transition on this concept: passes when the
   * viewer's grants pass transition:execute point-checked on the offer of
   * the row on the concept — a grant anchored at the tenancy, the concept's
   * organizational unit or the concept itself, with any grant conditions
   * evaluated against the row's own stage/step facts and the concept's state
   * and project facts. This is the enactment-grant axis of the commit gate —
   * whether the row is currently offered at this concept's placement is the
   * owner's evaluation concern, so a passing check does not by itself mean
   * the transitionConceptWorkflow item will apply (it can still be
   * UNAVAILABLE or BLOCKED). Advisory: renders the offer's enactability;
   * never enforcement.
   */
  Execute = 'EXECUTE'
}

export type ConceptWorkflowTransitionRequest = {
  /** The concept to move. */
  conceptKey: Scalars['ID']['input'];
  /** The transition to enact: the key of one of this concept's workflowTransitions, passed unchanged. */
  transitionKey: Scalars['ID']['input'];
};

export type ConceptWorkflowTransitionResult = {
  __typename?: 'ConceptWorkflowTransitionResult';
  /** What prevented the transition; non-empty exactly when outcome is BLOCKED. */
  blockedReasons: Array<BriefInvalidBlocker | ExistingDeliverablesBlocker | NoDeliverablesBlocker | OpenRevisionsBlocker | UndeliveredSpecificationsBlocker | UnreviewedDeliverablesBlocker>;
  /** The concept after the move. Null unless outcome is APPLIED, and null when the viewer cannot read the concept. */
  concept?: Maybe<Concept>;
  /** The concept this result is for. */
  conceptKey: Scalars['ID']['output'];
  outcome: WorkflowTransitionOutcome;
};

export type ConceptWorkflowTransitionViewerActionCheck = {
  __typename?: 'ConceptWorkflowTransitionViewerActionCheck';
  action: ConceptWorkflowTransitionAction;
  authorization: ActionCheckResult;
  conceptKey: Scalars['ID']['output'];
  transitionKey: Scalars['ID']['output'];
};

export type Concepts = {
  __typename?: 'Concepts';
  meta: CollectionMeta;
  nodes: Array<Concept>;
};

/** The approval lens vocabulary for ConceptsCollectionFilter.approval. */
export enum ConceptsApprovalFilter {
  /** Approval not required — the all-non-archived corpus. */
  Any = 'ANY',
  /** Approved concepts only (approval time present) — the absent default. */
  Approved = 'APPROVED'
}

/** The plan-scoped concepts collection behind Query.concepts. */
export type ConceptsCollection = {
  __typename?: 'ConceptsCollection';
  /**
   * Facet option lists for the collection. Selection-driven: no
   * aggregation work runs unless selected. `mode` controls option
   * membership; absent = BROAD (the shipped semantics).
   */
  facets: ConceptsFacets;
  /** Grouped mode. Selecting groups on a flat request fails with a bad-request error. */
  groups: Array<ConceptGroup>;
  meta: ConceptsCollectionMeta;
  /** Flat mode. Selecting nodes on a grouped request fails with a bad-request error. */
  nodes: Array<Concept>;
};


/** The plan-scoped concepts collection behind Query.concepts. */
export type ConceptsCollectionFacetsArgs = {
  mode?: InputMaybe<ConceptsFacetMode>;
};

export type ConceptsCollectionFilter = {
  /**
   * Approval lens. Absent = APPROVED (the library corpus: approval time
   * present). ANY = approval not required (the tracker corpus). Archived
   * concepts and deletion markers are excluded unconditionally in every
   * lens — archival and deletion are baseline invariants, not lens
   * dimensions.
   */
  approval?: InputMaybe<ConceptsApprovalFilter>;
  /** Bounds on the concept's approval time (latest variation approval). */
  approvalTime?: InputMaybe<TimeFilter>;
  /** Brand display names. Folded label predicate, as for clientNames. */
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Client account display names. Folded (case- and accent-insensitive)
   * equality against the client OU's name — a label predicate over the
   * corpus, NOT an entity selection: every client sharing the folded name
   * matches. Values need not come from the facet; unknown names match
   * nothing.
   */
  clientNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** searchVersion V2 only. */
  dueDate?: InputMaybe<DateFilter>;
  /** searchVersion V2 only. */
  firstSubmission?: InputMaybe<TimeComparisonFilter>;
  /** Specification format lengths (same-specification semantics as platforms). */
  formatLengths?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specification format names (same-specification semantics as platforms). */
  formatNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Brand industry verticals (OU resource attribute `vertical_name`). */
  industryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Concept key predicate (the enrichment key filter). */
  key?: InputMaybe<IdFilter>;
  /**
   * Free-text predicate. Never reorders results (no relevance ordering): a
   * concept matches when ANY word matches in ANY of the matched text
   * sources; the final word may match as a prefix (type-ahead);
   * case-insensitive (accent-insensitive where the underlying text is
   * folded). Matched text: concept name, project name, project serial id,
   * client account name, brand name, sales territory name, and brief
   * question responses. searchVersion V1 only.
   */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /**
   * Tracker name search, searchVersion V2 only. Terms split on whitespace and on
   * separating punctuation such as hyphens; case, Latin-script accents and
   * apostrophes inside names are ignored (the folding and its limits are stated
   * once, in the W19 query contract's "Normalization and null inputs"). Every
   * term must match a whole word, or the start of one,
   * in this Concept's name, its Project, Client or Brand name, or the Platform or
   * Format names of its non-archived specifications. Blank text removes only the
   * text restriction and is still an input. Never reorders results. Not with
   * keyword.
   */
  keyword_v2?: InputMaybe<Scalars['String']['input']>;
  /** Specification languages (same-specification semantics as platforms). */
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** searchVersion V2 only. */
  lastActivity?: InputMaybe<TimeComparisonFilter>;
  /** searchVersion V2 only. */
  members?: InputMaybe<MemberFilter>;
  /** @deprecated Use keyword_v2 with searchVersion V2. */
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Objective brief-question responses. searchVersion V1 only. */
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Specification platform names. The four specification predicates
   * (platforms, formatNames, formatLengths, languages) combine per
   * specification: a concept matches when at least ONE of its
   * specifications satisfies ALL provided specification filters.
   */
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sales territory (project region) display names. */
  salesTerritories?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Workflow stage codes (the left-nav presets). Translated onto the
   * concept's stage via the canonical concept-state vocabulary.
   */
  workflowStageCodes?: InputMaybe<Array<WorkflowStageCode>>;
  /**
   * Workflow step keys — stable per-tenant catalogue identities, the
   * step facet's option keys. Unknown keys match nothing.
   */
  workflowStepKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Page metadata for the concepts collection. Cursor-paged: infinite scroll
 * resumes with pagination.after = the previous page's endCursor.
 */
export type ConceptsCollectionMeta = {
  __typename?: 'ConceptsCollectionMeta';
  /**
   * Opaque cursor resuming the requested page stream — concepts when
   * groupBy is absent, groups when present; null when hasNextPage is
   * false. A cursor is a sort boundary, not a page number or server-side
   * context: it never expires and carries no scope authority.
   */
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  /** CONCEPT grain flat; PROJECT_GROUP grain grouped. Null in cursor mode. */
  numberedPage?: Maybe<TrackerNumberedPage>;
  /** Exact total of matching concepts, in every mode. Computed only when selected. */
  recordCount: Scalars['Int']['output'];
};

export type ConceptsCollectionParams = {
  filter?: InputMaybe<ConceptsCollectionFilter>;
  /**
   * Optional. Absent = the flat concept list (the shipped shape).
   * PROJECT = one group per project containing its matched concepts;
   * pagination operates on GROUPS. Selecting `nodes` with groupBy set,
   * or `groups` without it, fails with a bad-request error.
   */
  groupBy?: InputMaybe<ConceptsGroupBy>;
  /**
   * Group order. Grouped mode only — present without groupBy fails with
   * a bad-request error. Field vocabulary: projectCreatedAt (the absent
   * default, DESC), projectName, workflowStageStartedAt, workflowStatus.
   * The group key is appended ascending as the final tie-break. For
   * concept-grain fields the group's sort representative is the matched
   * concept that wins the requested order.
   */
  groupSort?: InputMaybe<Array<SortInput>>;
  pagination?: InputMaybe<ConceptsCursorPagination>;
  /**
   * Search implementation. Omitted or null is V1, the current path; V2 is the
   * Tracker path. An input described as one version's only is a bad request
   * under the other.
   */
  searchVersion?: InputMaybe<SearchVersion>;
  /**
   * Concept order — the result order in flat mode, the within-group
   * order in grouped mode. Field vocabulary: serialNumber, approvalTime,
   * workflowStageStartedAt (both modes), plus workflowStatus (grouped
   * mode only). searchVersion V2 adds the flat-mode fields name,
   * projectName, clientName, brandName, status, specificationCount,
   * lastActivity, firstSubmission and dueDate. Unsupported fields fail
   * with a bad-request error.
   * Absent = approvalTime DESC in flat mode, serialNumber ASC in
   * grouped mode. The server appends key ASC as a terminal tie-break in
   * every mode, so every order is total.
   */
  sort?: InputMaybe<Array<SortInput>>;
  /**
   * Sort populations, searchVersion V2 only. An option shapes its own sort,
   * never which results return; an option for a sort the request does not
   * order by is a bad request.
   */
  sortOptions?: InputMaybe<ConceptSortOptionsInput>;
};

/**
 * Forward-only cursor paging. Cursors bind the paged stream's order —
 * `sort` in flat mode, `groupBy` + `groupSort` in grouped mode: a
 * malformed token, or one replayed under a different mode or stream
 * order, fails with a bad-request error.
 */
export type ConceptsCursorPagination = {
  /** Opaque resumption cursor from a prior page's meta.endCursor. Absent = the first page. */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page size — concepts in flat mode, groups in grouped mode. Server
   * default 20; capped at 100 flat and 25 grouped (bad-request error
   * beyond the cap).
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** searchVersion V2 only. Presence selects numbered mode; omit after entirely. Requires an explicit limit. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * One facet's option list plus the completeness signal that drives the
 * client's search mode. `match` (available on every facet, uniformly):
 * case-insensitive text predicate over option values (additionally
 * accent-insensitive on the folded clientNames/brandNames facets); prefix
 * matches rank before contains matches.
 */
export type ConceptsFacet = {
  __typename?: 'ConceptsFacet';
  /**
   * True when `options` holds every distinct value for this facet under the
   * query that produced it (scope, couplings, and any `match` included);
   * false when the list was truncated at the server cap. Clients derive
   * their option-search mode from this: complete ⇒ refine locally,
   * incomplete ⇒ re-query with `match`.
   */
  isComplete: Scalars['Boolean']['output'];
  options: Array<ConceptsFacetOption>;
};

/**
 * Facet option membership. BROAD (the absent default): options from the
 * lens corpus, active filters ignored, the two ratified couplings applied
 * — the shipped semantics, unchanged. REACTIVE: disjunctive faceting —
 * each facet's options are computed under every active filter except that
 * facet's own selections, so every option shown has at least one match
 * under everything else selected.
 */
export enum ConceptsFacetMode {
  Broad = 'BROAD',
  Reactive = 'REACTIVE'
}

export type ConceptsFacetOption = {
  __typename?: 'ConceptsFacetOption';
  /**
   * Number of visible approved concepts carrying this value, evaluated
   * against every active filter EXCEPT this facet's own selections
   * (standard disjunctive faceting; couplings and the baseline corpus
   * included). Null until the backing store computes counts — renderers
   * must treat null as "no count available", never as zero.
   */
  count?: Maybe<Scalars['Int']['output']>;
  /** The facet value (for clientNames/brandNames: a representative original casing of the folded label). */
  value: Scalars['String']['output'];
};

/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacets = {
  __typename?: 'ConceptsFacets';
  /** Brand name options. Empty unless filter.clientNames is set; constrained to those clients. */
  brandNames: ConceptsFacet;
  /** Client account name options (folded label classes with a representative original casing). */
  clientNames: ConceptsFacet;
  formatLengths: ConceptsFacet;
  /** Format options. Empty unless filter.platforms is set; constrained to those platforms. */
  formatNames: ConceptsFacet;
  industryNames: ConceptsFacet;
  languages: ConceptsFacet;
  /** Objective options. searchVersion V1 only. */
  objectives: ConceptsFacet;
  platforms: ConceptsFacet;
  salesTerritories: ConceptsFacet;
  /**
   * Workflow step options — an entity-valued facet: options are keyed
   * catalogue entities, not folded labels. Corpus-derived (only steps
   * with at least one matching concept in scope appear), ordered by
   * catalogue position (stage, then step).
   */
  workflowSteps: ConceptsWorkflowStepFacet;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsBrandNamesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsClientNamesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsFormatLengthsArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsFormatNamesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsIndustryNamesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsLanguagesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsObjectivesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsPlatformsArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsSalesTerritoriesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the concepts collection, computed over the
 * viewer-scoped corpus the request's approval lens selects. Membership
 * follows the facets(mode:) argument: under BROAD (the absent default)
 * active filters are ignored except the two documented couplings
 * (brandNames ← filter.clientNames, formatNames ← filter.platforms); under
 * REACTIVE each facet is computed under every active filter except its own
 * selections. Only values carried by at least one visible in-lens concept
 * appear; value lists are ascending and capped server-side.
 */
export type ConceptsFacetsWorkflowStepsArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};

export type ConceptsFilter = {
  key?: InputMaybe<IdFilter>;
};

/** The grouping dimension. Closed vocabulary; PROJECT is the only v1 value. */
export enum ConceptsGroupBy {
  /** One group per project; the group key is the project key. */
  Project = 'PROJECT'
}

export type ConceptsParams = {
  filter?: InputMaybe<ConceptsFilter>;
  sort?: InputMaybe<Array<SortInput>>;
};

/**
 * The workflow step facet: keyed options plus the completeness signal that
 * drives the client's option-search mode.
 */
export type ConceptsWorkflowStepFacet = {
  __typename?: 'ConceptsWorkflowStepFacet';
  /** True when `options` holds every distinct step for this query; false when truncated. */
  isComplete: Scalars['Boolean']['output'];
  /** Options in catalogue order (stage position, then step position). */
  options: Array<ConceptsWorkflowStepOption>;
};

export type ConceptsWorkflowStepOption = {
  __typename?: 'ConceptsWorkflowStepOption';
  /** The workflow step key — the value for filter.workflowStepKeys. */
  key: Scalars['ID']['output'];
  /** The step's display name. */
  label: Scalars['String']['output'];
  /** The owning stage, for the drawer's grouped rendering. */
  stageCode: WorkflowStageCode;
  /** The owning stage's display name. */
  stageLabel: Scalars['String']['output'];
};

/**
 * Convergence meta for a fence-capable answer: whether the answer was
 * computed behind a presented write-token, and whether the answering
 * projections were verified to have applied the token's covered writes. A
 * convergence miss is disclosed here beside the served answer — never an
 * error, never a null. `converged` is a POSITIVE claim only: false means "no
 * convergence claim" (unfenced reads included) — it never means "stale" and
 * never means "denied". Shared value type: every fence-capable read surface
 * returns this shape.
 */
export type ConvergenceMeta = {
  __typename?: 'ConvergenceMeta';
  /**
   * True iff every covered token entry this subgraph's projections track was
   * verified applied before the answer was computed — the answer
   * happens-after the caller's anchor. Always false when `fenced` is false:
   * an unfenced answer claims nothing.
   */
  converged: Scalars['Boolean']['output'];
  /**
   * True iff a write-token was presented and evaluated against the answering
   * projections' applied positions. False = the answer carries no freshness
   * relationship to any anchor: no token was presented (neither a caller
   * `atLeast` nor a representation-borne `factsWatermark`), or the fence is
   * degraded and evaluated nothing.
   */
  fenced: Scalars['Boolean']['output'];
  /**
   * Token entries not verified applied when the answer was served, as
   * `kind/key@source`; null when nothing was left uncovered. Sources these
   * projections do not consume are not misses and are not listed.
   */
  uncovered?: Maybe<Array<Scalars['String']['output']>>;
  /** Milliseconds the fence waited before answering; null when it never waited. */
  waitedMs?: Maybe<Scalars['Int']['output']>;
};

export enum CopilotStatus {
  Completed = 'completed',
  Failed = 'failed',
  Generating = 'generating'
}

export type CopySuggestion = {
  __typename?: 'CopySuggestion';
  id: Scalars['ID']['output'];
  responses?: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['String']['output'];
};

export type CreateAdvertLegacyInput = {
  advert: AdvertCreateLegacyInput;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdvertLegacyPayload = {
  __typename?: 'CreateAdvertLegacyPayload';
  advert?: Maybe<Advert>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateAiProjectInput = {
  brandOrganizationalUnitKey: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  organizationalUnitKey: Scalars['ID']['input'];
  projectIdea: Scalars['String']['input'];
  /** The key of the template brief to use as a starting point. */
  templateBriefKey?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAmplifyDemoImportInput = {
  amplifyMultiformatTemplateComposition: Scalars['String']['input'];
  amplifyMultiformatTemplateID: Scalars['String']['input'];
  amplifyMultiformatTemplateVersion: Scalars['Int']['input'];
  projectKey: Scalars['ID']['input'];
};

export type CreateAmplifyDemoImportsInput = {
  imports: Array<CreateAmplifyDemoImportInput>;
};

export type CreateAmplifyEditorSessionInput = {
  conceptKey: Scalars['ID']['input'];
  renderSessions: Array<CreateAmplifyEditorSessionRenderSessionInput>;
  variantKey?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAmplifyEditorSessionRenderSessionInput = {
  sourceDeliverableKey: Scalars['ID']['input'];
  targetSpecificationKey: Scalars['ID']['input'];
};

export type CreateAudienceInput = {
  ageRanges?: InputMaybe<Array<AgeRange>>;
  gender?: InputMaybe<TargetGender>;
  incomeLifestyle?: InputMaybe<Scalars['String']['input']>;
  interestsAndBehaviours?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationalUnitKey: Scalars['ID']['input'];
};

export type CreateBrandAssetInput = {
  assetType: BrandAssetType;
  fileKey: Scalars['ID']['input'];
  organizationalUnitKey: Scalars['ID']['input'];
};

export type CreateBriefingAssetInput = {
  assetType: BriefingAssetType;
  conceptKey: Scalars['ID']['input'];
  fileKey: Scalars['ID']['input'];
};

export type CreateCohortInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** The immutable authored key, unique within the tenancy. */
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateConceptInput = {
  /** The name of the concept. Optional on create; if omitted, the concept is created without a name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The key of the project to create the concept in. */
  projectKey: Scalars['ID']['input'];
  /** The key of the template brief to use as a starting point. */
  templateBriefKey?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCreatorOfferInput = {
  ugcOrderKey: Scalars['ID']['input'];
};

/** Input for creating a custom property definition. */
export type CreateCustomPropertyDefinitionInput = {
  /** Configuration for this definition. */
  config: CustomPropertyConfigInput;
  /**
   * The icon to show: an https image URL or inline SVG markup. Omitted or null
   * uses the UI's default glyph for the type.
   */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Display label for this property. */
  label: Scalars['String']['input'];
  /** Options for SELECT definitions. */
  options?: InputMaybe<Array<CustomPropertyOptionInput>>;
  /** The record kind this definition can be assigned to. */
  ownerType: CustomPropertyOwnerType;
  /** Whether a PROJECT definition is displayed in the project header. */
  pinned?: Scalars['Boolean']['input'];
  /**
   * Display order for this definition; omitted appends it. Other definitions of
   * the same owner type shift to make room.
   */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Organizational unit keys where this definition applies. */
  scopes: Array<Scalars['ID']['input']>;
  /** Human-readable slug for this definition. */
  slug: Scalars['String']['input'];
  /** The value kind accepted by this definition. */
  type: CustomPropertyType;
};

/** One positional outcome of createCustomPropertyOptions. */
export type CreateCustomPropertyOptionResult = {
  __typename?: 'CreateCustomPropertyOptionResult';
  /**
   * Whether this call created the option. False when an active option already
   * carried the label (or its generated value): the existing option is returned
   * unchanged, its color included.
   */
  created: Scalars['Boolean']['output'];
  /** The matched or created option. */
  option: CustomPropertyOption;
};

/** Input for createCustomPropertyOptions. */
export type CreateCustomPropertyOptionsInput = {
  /** The SELECT definition whose vocabulary receives the options. */
  definitionKey: Scalars['ID']['input'];
  /**
   * Labels to match or create, in order. Each entry resolves to exactly one
   * result entry at the same position.
   */
  options: Array<NewCustomPropertyOptionInput>;
  /**
   * The organizational unit whose vocabulary receives the options: any unit the
   * caller may write (ou:write) and that the definition applies to. Which scoped
   * options a record can select from is the record owner's rule, not this
   * write's — a Concept selects from the global options plus those scoped at its
   * project's unit — so callers pass the unit their consumer reads.
   */
  scopeOrganizationalUnitKey: Scalars['ID']['input'];
};

/** Result of createCustomPropertyOptions, positionally aligned with the input. */
export type CreateCustomPropertyOptionsPayload = {
  __typename?: 'CreateCustomPropertyOptionsPayload';
  options: Array<CreateCustomPropertyOptionResult>;
};

export type CreateDeliverableAmplifyIntegrationInput = {
  amplifyMultiformatTemplateComposition: Scalars['String']['input'];
  amplifyMultiformatTemplateID: Scalars['String']['input'];
  amplifyMultiformatTemplateVersion: Scalars['Int']['input'];
  deliverableKey: Scalars['ID']['input'];
};

export type CreateDeliverableAmplifyIntegrationsInput = {
  integrations: Array<CreateDeliverableAmplifyIntegrationInput>;
};

export type CreateDeliverableFormatInput = {
  creativeGroup?: InputMaybe<CreativeGroup>;
  dimensionId?: InputMaybe<Scalars['ID']['input']>;
  filenameCode?: InputMaybe<Scalars['String']['input']>;
  heroPriority?: InputMaybe<Scalars['Int']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  platformCode: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  trelloLabelName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDimensionInput = {
  height: Scalars['Float']['input'];
  unit: MeasurementUnit;
  width: Scalars['Float']['input'];
};

export type CreateInvitationInput = {
  /** Audience the invitation onboards. Defaults to USER. */
  audience?: InputMaybe<InvitationAudience>;
  /** Optional email address of an invitee. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Optional first name of an invitee. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Optional last name of an invitee. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Integration key of the organisation unit this invite will grant access to.
   * DEPRECATED: use scope.
   * @deprecated Use scope
   */
  orgUnitKey?: InputMaybe<Scalars['ID']['input']>;
  /** Scope anchor for the invitation. TENANCY scope omits scopeKey. */
  scope?: InputMaybe<InvitationScopeInput>;
};

export type CreateMultipartUploadInput = {
  /** The MIME type of the file. */
  contentType: Scalars['String']['input'];
  /** The name of the file. */
  fileName: Scalars['String']['input'];
  /** The total size of the file, in bytes. */
  fileSize: Scalars['Int64']['input'];
  /** Defines the polymorphic resource that governs this file. */
  governingResource: FileGoverningResourceInput;
  /** An object of key/value pairs to set as metadata. */
  metadata?: InputMaybe<Scalars['Map']['input']>;
};

export type CreateOrUpdateBrandProfileInput = {
  assetSources?: InputMaybe<Array<Scalars['String']['input']>>;
  brandGuidelines?: InputMaybe<Scalars['String']['input']>;
  brandNotes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The market code to be assigned to the brand */
  marketCode?: InputMaybe<Scalars['String']['input']>;
  organizationalUnitKey: Scalars['ID']['input'];
  personality?: InputMaybe<Scalars['String']['input']>;
  productionNotes?: InputMaybe<Scalars['String']['input']>;
  socialChannels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOrUpdateConceptInput = {
  /** Asset links and notes to be associated with the concept. */
  assetLinks?: InputMaybe<Array<AssetLinkInput>>;
  /** Disclaimer for the concept. */
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  /** Rich text describing the story to communicate, any creative ideas and direction, and what makes this concept different to others in the project. */
  idea?: InputMaybe<Scalars['String']['input']>;
  /** Integration key of the concept to update. */
  integrationKey: Scalars['ID']['input'];
  /** The market code to be assigned to the concept */
  marketCode?: InputMaybe<Scalars['String']['input']>;
  /** Product or service this concept is promoting. */
  productOrService?: InputMaybe<Scalars['String']['input']>;
  /** Integration key of the project this concept belongs to. */
  projectIntegrationKey: Scalars['ID']['input'];
  /** Brief Sections for the Concept */
  sectionsV2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The key of the template brief to use as a starting point (immutable). */
  templateBriefKey?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrUpdateConceptLocalisationInput = {
  /** Details about asset requirements */
  assetDetails?: InputMaybe<Scalars['String']['input']>;
  /** A list of asset links for this localisation */
  assetLinks: Array<AssetLinkInput>;
  /** A list of asset file keys for this localisation */
  assets: Array<Scalars['ID']['input']>;
  /** Integration key of the concept this localisation belongs to */
  conceptKey: Scalars['ID']['input'];
  /** Details about copy requirements */
  copyDetails?: InputMaybe<Scalars['String']['input']>;
  /** Optional URL of any external document or spreadsheet containing translations */
  externalTranslationLink?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating whether this localisation includes alternative assets */
  includesAssets: Scalars['Boolean']['input'];
  /** Flag indicating whether this localisation includes alternative copy */
  includesCopy: Scalars['Boolean']['input'];
  /** Flag indicating whether this localisation includes alternative voiceovers */
  includesVoiceovers: Scalars['Boolean']['input'];
  /** Instructions describing requirements for the localisation */
  instructions: Scalars['String']['input'];
  /** Primary target market (aka source locale). Defaults to en-US */
  primaryMarketLocale?: InputMaybe<Scalars['ID']['input']>;
  /** A list of target markets required for this localisation */
  targetMarketLocales: Array<Scalars['ID']['input']>;
  /** Details about voiceover requirements */
  voiceoverDetails?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateQuestionSectionInput = {
  /** Whether the section should be a fixed part of a brief */
  fixed: Scalars['Boolean']['input'];
  /** Icon for the section */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** lower_snake_case unique identifier */
  key: Scalars['String']['input'];
  /** Position of the section in a brief */
  position: Scalars['Int']['input'];
  /** Subtitle or description of the section */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Title of the section */
  title: Scalars['String']['input'];
};

export type CreateOrUpdateSceneInput = {
  conceptIntegrationKey: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Temporary Field. Needed to create Concept just-in-time. */
  projectIntegrationKey?: InputMaybe<Scalars['ID']['input']>;
  questionKey: Scalars['String']['input'];
};

/** Input for creating or updating a template brief. */
export type CreateOrUpdateTemplateBriefInput = {
  /** The formats to include in this template. */
  defaultFormats: Array<TemplateBriefFormatInput>;
  /** The sections to include in this template. */
  defaultSections: Array<Scalars['String']['input']>;
  /** Optional description of the template brief. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key of the template brief to update. */
  key?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the template brief. */
  name: Scalars['String']['input'];
  /** Organizational unit keys that this template filter applies to (for INCLUDE/EXCLUDE modes). */
  ouFilterKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** OU filtering mode for this template. */
  ouFilterMode: OuFilterMode;
  /** Position of the template brief */
  position: Scalars['Int']['input'];
};

export type CreateOrganizationalUnitInput = {
  /** Explicit anchor governing this organizational unit. */
  anchor: OrganizationalUnitAnchorInput;
  config?: InputMaybe<OrganizationalUnitConfigInput>;
  /** Optional hero balance instruction (not persisted on the organizational unit). */
  heroBalance?: InputMaybe<Scalars['Int']['input']>;
  /** Client-provided organizational unit integration key. */
  key: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  platformCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceAttributes?: InputMaybe<Scalars['Map']['input']>;
  resourceType: OrganizationalUnitResourceType;
};

export type CreateOrganizationalUnitNodeInput = {
  config?: InputMaybe<OrganizationalUnitConfigInput>;
  /** Optional hero balance instruction (not persisted on the organizational unit). */
  heroBalance?: InputMaybe<Scalars['Int']['input']>;
  /** Client-provided organizational unit integration key. */
  key: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  /** Payload parent organizational unit key. */
  parentKey?: InputMaybe<Scalars['ID']['input']>;
  platformCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceAttributes?: InputMaybe<Scalars['Map']['input']>;
  resourceType: OrganizationalUnitResourceType;
};

export type CreateOrganizationalUnitSubtreeInput = {
  /** The explicit anchor governing this subtree. */
  anchor: OrganizationalUnitAnchorInput;
  nodes: Array<CreateOrganizationalUnitNodeInput>;
};

export type CreatePlatformInput = {
  clientFilter?: InputMaybe<PlatformClientFilter>;
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  platformTrelloLabel?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProjectInput = {
  /** Organizational unit key of the Brand/EnterpriseBrand for the order to be associated with. */
  brandOrganizationalUnitKey: Scalars['ID']['input'];
  /** Indicates that this project's brief is being ai generated. Defaults to false. */
  generatingBrief?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional organizational unit key to scope the project. */
  organizationalUnitKey: Scalars['ID']['input'];
};

/** Minimal response returned when creating a project. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  key: Scalars['ID']['output'];
};

export type CreateQuestionInput = {
  canHaveNotes: Scalars['Boolean']['input'];
  clientFilter: QuestionClientFilter;
  copilotPrompt?: InputMaybe<Scalars['String']['input']>;
  copyVariation: Scalars['Boolean']['input'];
  deliverableFormats: Array<QuestionDeliverableFormatInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  fixed: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  kind: QuestionKind;
  label?: InputMaybe<Scalars['String']['input']>;
  languageDetection: Scalars['Boolean']['input'];
  minRows?: InputMaybe<Scalars['Int']['input']>;
  options: Array<QuestionOptionInput>;
  organizationalUnitKeys: Array<Scalars['ID']['input']>;
  parentQuestionOptionKey?: InputMaybe<Scalars['ID']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  required: Scalars['Boolean']['input'];
  sectionKey?: InputMaybe<Scalars['String']['input']>;
  shortLabel?: InputMaybe<Scalars['String']['input']>;
  tooltip?: InputMaybe<Scalars['String']['input']>;
  translatable: Scalars['Boolean']['input'];
};

export type CreateRoleInput = {
  audiences?: InputMaybe<Array<RoleAudience>>;
  description?: InputMaybe<Scalars['String']['input']>;
  grantChannels?: InputMaybe<Array<RoleGrantChannel>>;
  grantScopeKinds: Array<GrantScopeKind>;
  name: Scalars['String']['input'];
  statements: Array<RoleStatementInput>;
};

export type CreateUgcAssetInput = {
  /** Integration key of the file to use for this asset */
  fileKey: Scalars['ID']['input'];
  /** Integration key of the UGC Order this asset belongs to */
  ugcOrderKey: Scalars['ID']['input'];
};

export type CreateUgcDeliverableInput = {
  fileKey: Scalars['ID']['input'];
  ugcOrderKey: Scalars['ID']['input'];
};

export type CreateVariantInput = {
  /** The key of the concept to create the variant for. */
  conceptKey: Scalars['ID']['input'];
  /** The name of the variant. */
  name: Scalars['String']['input'];
  /**
   * Optional explicit sequence number for the variant. Must be positive and unique within the concept.
   * When omitted, the next sequential number is assigned automatically.
   */
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export enum CreativeGroup {
  Banner = 'banner',
  Beta = 'beta',
  CreativeLabs = 'creative_labs',
  Interactive = 'interactive',
  Social = 'social'
}

/**
 * A CreativeX account — a tenant within the CreativeX platform, reified as a
 * governing resource. Every read of the account (the entity itself, its
 * workspace brand roster) is a creativex_account:read point check at the
 * account; the account's ACLv2 placement alone decides who that admits.
 */
export type CreativeXAccount = {
  __typename?: 'CreativeXAccount';
  /**
   * Brands in the account's CreativeX workspace. Null when the roster could not
   * be read (the vendor refused, or the workspace's credential is missing):
   * the failure is this account's alone and never withholds a sibling account
   * or a sibling field. An empty workspace is an empty list.
   */
  brands?: Maybe<Array<CreativeXBrand>>;
  /** The CreativeX account key */
  key: Scalars['ID']['output'];
  /** The account's ACLv2 placement kind: the tenancy, or a client-account organizational unit */
  scopeKind: CreativeXAccountScopeKind;
};

/** The ACLv2 placement kind of a CreativeX account */
export enum CreativeXAccountScopeKind {
  OrganizationalUnit = 'ORGANIZATIONAL_UNIT',
  Tenancy = 'TENANCY'
}

/**
 * The workspace a client account's CreativeX integration selects (SCOPE
 * §6-R2d): SHARED_WORKSPACE is the tenancy-placed account (staff reach only),
 * OWN_ACCOUNT the account placed under the client account. Enabling on either
 * is a permitted act preflighted by the client-account unit's
 * SELECT_SHARED_CREATIVE_X_ACCOUNT / SELECT_OWN_CREATIVE_X_ACCOUNT operation
 * checks.
 */
export enum CreativeXAccountSelection {
  OwnAccount = 'OWN_ACCOUNT',
  SharedWorkspace = 'SHARED_WORKSPACE'
}

/**
 * The lifecycle state of the CreativeX analysis for a deliverable. Resolved by
 * the CreativeX service from the owning account's integration and the
 * deliverable's preflight, so clients render the analysis panel from this state
 * alone — no client-account reads are required.
 */
export enum CreativeXAnalysisState {
  /** Results are available. */
  Available = 'AVAILABLE',
  /** Analysis applies and results are expected, but have not arrived yet. */
  Expected = 'EXPECTED',
  /** The analysis failed and no results will arrive for the current version. */
  Failed = 'FAILED',
  /** CreativeX is active for the owning account but cannot analyse this deliverable. */
  NotApplicable = 'NOT_APPLICABLE',
  /** The owning account has no active CreativeX integration. */
  NotExpected = 'NOT_EXPECTED'
}

export type CreativeXBrand = {
  __typename?: 'CreativeXBrand';
  /** The CreativeX brand external ID */
  externalId: Scalars['Int']['output'];
  /** The CreativeX brand name */
  name: Scalars['String']['output'];
};

export type CreativeXIntegration = {
  __typename?: 'CreativeXIntegration';
  /**
   * The CreativeX account the integration's selection points at. Null while no
   * selection has been made; reading the account itself requires
   * creativex_account:read reach on it, independently of reaching this
   * integration.
   */
  account?: Maybe<CreativeXAccount>;
  /** The client account key for this CreativeX integration (internal only) */
  clientAccountKey: Scalars['ID']['output'];
  /** Whether CreativeX operates for the client account — enablement, never access control */
  enabled: Scalars['Boolean']['output'];
  /**
   * Which workspace the integration selects: the tenant-shared workspace or
   * the client's own account. Null while no selection has been made (disabling
   * keeps the selection). The integration's own fact, readable with the
   * integration; the selected account itself is the `account` edge, gated by
   * creativex_account:read.
   */
  selection?: Maybe<CreativeXAccountSelection>;
};

export type CreativeXPreflight = {
  __typename?: 'CreativeXPreflight';
  /** The create time for the CreativeX preflight task */
  createdAt: Scalars['Time']['output'];
  /** The CreativeX preflight task error message */
  error?: Maybe<Scalars['String']['output']>;
  /** The CreativeX preflight task ID */
  id: Scalars['ID']['output'];
  /** Whether the was generated using the CreativeX Lite flow */
  isLite: Scalars['Boolean']['output'];
  /** The CreativeX preflight request ID */
  requestId: Scalars['Int']['output'];
  /** The CreativeX preflight task status */
  status: PreflightStatus;
  /** The update time for the CreativeX preflight task */
  updatedAt: Scalars['Time']['output'];
};

export type CreativeXResult = {
  __typename?: 'CreativeXResult';
  /** The CreativeX result guidelines */
  guidelines: Array<CreativeXResultGuideline>;
  /** The CreativeX result ID */
  id: Scalars['ID']['output'];
  /** The CreativeX result quality tier */
  qualityTier: Scalars['String']['output'];
  /** The CreativeX result score */
  score: Scalars['Float']['output'];
  /** The CreativeX result scorecard URL, will be nil for Lite Preflights */
  scorecardUrl?: Maybe<Scalars['String']['output']>;
};

export type CreativeXResultGuideline = {
  __typename?: 'CreativeXResultGuideline';
  /** The CreativeX guideline name */
  name: Scalars['String']['output'];
  /** Whether the CreativeX result passed for this guideline */
  passed: Scalars['Boolean']['output'];
  /** The CreativeX guideline weighting */
  weight: Scalars['Float']['output'];
};

/** Primary Creator Entity. */
export type Creator = {
  __typename?: 'Creator';
  /** Address city. */
  addressCity: Scalars['String']['output'];
  /** Address country code. */
  addressCountryCode: Scalars['String']['output'];
  /** Address line 1. */
  addressLine1: Scalars['String']['output'];
  /** Address line 2. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** Address state. */
  addressState: Scalars['String']['output'];
  /** Address zip code. */
  addressZipCode: Scalars['String']['output'];
  /** Year of birth. Null on DRAFT profiles. */
  birthYear?: Maybe<Scalars['Int']['output']>;
  /** Time the Creator Entity was created. */
  createdAt: Scalars['Time']['output'];
  /** Email. */
  email: Scalars['String']['output'];
  /** Ethnicity. */
  ethnicity: Scalars['String']['output'];
  /** First name. */
  firstName: Scalars['String']['output'];
  /** Gender. Null on DRAFT profiles. */
  gender?: Maybe<Gender>;
  /** Hobbies / Interests. */
  hobbyInterests: Array<CreatorHobbyInterest>;
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** Unique key cross services. */
  key: Scalars['ID']['output'];
  /** Languages the creator is fluent in (spoken and/or written). */
  knownLanguages: Array<Language>;
  /**
   * Language codes.
   * @deprecated Use knownLanguages instead.
   */
  languages: Array<Scalars['String']['output']>;
  /** Last name. */
  lastName: Scalars['String']['output'];
  /** Media. */
  media: Array<Media>;
  /** Full name. */
  name: Scalars['String']['output'];
  /** Additional notes about the creator. */
  notes: Scalars['String']['output'];
  /** Offers assigned to the creator. */
  offers: Array<CreatorOffer>;
  /**
   * Orders assigned to the creator.
   * @deprecated use ordersV2 instead
   */
  orders: Array<UgcOrder>;
  /** Orders assigned to the creator. */
  ordersV2: UgcOrders;
  /** Post ads answer. Null on DRAFT profiles. */
  postAds?: Maybe<CreatorPostAd>;
  /** Profile / bio. */
  profile: Scalars['String']['output'];
  /** Reliability Score */
  score?: Maybe<Scalars['Int']['output']>;
  /** Social media. */
  socialMedia: Array<CreatorSocialMedia>;
  /**
   * Social media links.
   * @deprecated Use socialMedia instead.
   */
  socialMediaLinks: Array<Scalars['String']['output']>;
  /** Specialty verticals. */
  specialtyVerticals: Array<CreatorSpecialtyVertical>;
  /** Approval status. */
  status: CreatorStatus;
  /** Tags. */
  tags?: Maybe<Array<CreatorTag>>;
};


/** Primary Creator Entity. */
export type CreatorOffersArgs = {
  filter?: InputMaybe<CreatorOffersFilter>;
};


/** Primary Creator Entity. */
export type CreatorOrdersArgs = {
  filter?: InputMaybe<CreatorOrdersFilter>;
};


/** Primary Creator Entity. */
export type CreatorOrdersV2Args = {
  filter?: InputMaybe<CreatorOrdersFilter>;
};

export type CreatorAttributes = {
  __typename?: 'CreatorAttributes';
  /** Retrieve a distinct list of countries. */
  countries: Array<Scalars['String']['output']>;
  /** Retrieve a distinct list of ethnicities. */
  ethnicities: Array<Scalars['String']['output']>;
  /** Retrieve an individual gender by id. */
  gender: Gender;
  /** Retrieve all available genders. */
  genders: Array<Gender>;
  /** Retrieve an individual hobby / interest by id. */
  hobbyInterest: CreatorHobbyInterest;
  /** Retrieve all available hobbies / interests. */
  hobbyInterests: Array<CreatorHobbyInterest>;
  /** Retrieve an individual language by code. */
  language: Language;
  /** Retrieve all available languages. */
  languages: Array<Language>;
  /** Retrieve an individual specialty vertical by id. */
  specialtyVertical: CreatorSpecialtyVertical;
  /** Retrieve all available specialty verticals. */
  specialtyVerticals: Array<CreatorSpecialtyVertical>;
  /** Retrieve an individual tag by id. */
  tag: CreatorTag;
  /** Retrieve all available tags. */
  tags: CreatorTags;
};


export type CreatorAttributesGenderArgs = {
  id: Scalars['ID']['input'];
};


export type CreatorAttributesHobbyInterestArgs = {
  id: Scalars['ID']['input'];
};


export type CreatorAttributesHobbyInterestsArgs = {
  params?: InputMaybe<QueryParams>;
};


export type CreatorAttributesLanguageArgs = {
  code: Scalars['String']['input'];
};


export type CreatorAttributesLanguagesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type CreatorAttributesSpecialtyVerticalArgs = {
  id: Scalars['ID']['input'];
};


export type CreatorAttributesSpecialtyVerticalsArgs = {
  params?: InputMaybe<QueryParams>;
};


export type CreatorAttributesTagArgs = {
  id: Scalars['ID']['input'];
};


export type CreatorAttributesTagsArgs = {
  params?: InputMaybe<QueryParams>;
};

/** Hobby / Interest (i.e. of a creator). */
export type CreatorHobbyInterest = {
  __typename?: 'CreatorHobbyInterest';
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** Human readable label for this hobby / interest. */
  label: Scalars['String']['output'];
};

/** Creator Input. */
export type CreatorInput = {
  /** Address city. */
  addressCity: Scalars['String']['input'];
  /** Address country code. */
  addressCountryCode: Scalars['String']['input'];
  /** Address line 1. */
  addressLine1: Scalars['String']['input'];
  /** Address line 2. */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Address state. */
  addressState: Scalars['String']['input'];
  /** Address zip code. */
  addressZipCode: Scalars['String']['input'];
  /** Year of birth. */
  birthYear: Scalars['Int']['input'];
  /** Email. */
  email: Scalars['String']['input'];
  /** Ethnicity. */
  ethnicity: Scalars['String']['input'];
  /** First name. */
  firstName: Scalars['String']['input'];
  /** Gender identifier. */
  genderID: Scalars['ID']['input'];
  /** Hobby / Interest identifiers. */
  hobbyInterestIDs: Array<Scalars['ID']['input']>;
  /** Unique Identifier. */
  key?: InputMaybe<Scalars['ID']['input']>;
  /** Languages. */
  languages: Array<Scalars['String']['input']>;
  /** Last name. */
  lastName: Scalars['String']['input'];
  /** Media input. */
  media: Array<MediaInput>;
  /** Additional notes about the creator. */
  notes: Scalars['String']['input'];
  /** Post ads answer. */
  postAds: CreatorPostAd;
  /** Profile / bio. */
  profile: Scalars['String']['input'];
  /** Reliability Score */
  score?: InputMaybe<Scalars['Int']['input']>;
  /** Social media links. */
  socialMediaLinks: Array<Scalars['String']['input']>;
  /** Specialty vertical identifiers. */
  specialtyVerticalIDs: Array<Scalars['ID']['input']>;
  /** Approval status. */
  status: CreatorStatus;
  /** Tag identifiers. */
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Post ads answer. */
export enum CreatorMediaType {
  Introduction = 'INTRODUCTION',
  Portfolio = 'PORTFOLIO',
  Profile = 'PROFILE'
}

export type CreatorOffer = {
  __typename?: 'CreatorOffer';
  brief?: Maybe<UgcBrief>;
  declineReason?: Maybe<Scalars['String']['output']>;
  key: Scalars['ID']['output'];
  revokeReason?: Maybe<Scalars['String']['output']>;
  state: CreatorOfferState;
};

export enum CreatorOfferState {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type CreatorOffersFilter = {
  states?: InputMaybe<Array<CreatorOfferState>>;
};

export type CreatorOrdersFilter = {
  states?: InputMaybe<Array<UgcOrderState>>;
};

/** Post ads answer. */
export enum CreatorPostAd {
  No = 'NO',
  Unsure = 'UNSURE',
  Yes = 'YES'
}

/**
 * Public read tier of an approved creator profile — exactly the fields the
 * anonymous profile page renders. Staff-only profile data (email, address
 * lines, zip code, notes, score) has no field here: the redaction is
 * structural, applied in the read model, never masked per caller.
 */
export type CreatorProfile = {
  __typename?: 'CreatorProfile';
  /** Address city. */
  addressCity: Scalars['String']['output'];
  /** Address country code. */
  addressCountryCode: Scalars['String']['output'];
  /** Address state. */
  addressState: Scalars['String']['output'];
  /** Year of birth. */
  birthYear: Scalars['Int']['output'];
  /** Ethnicity. */
  ethnicity: Scalars['String']['output'];
  /** Gender. */
  gender: Gender;
  /** Hobbies / Interests. */
  hobbyInterests: Array<CreatorHobbyInterest>;
  /** Unique key cross services. */
  key: Scalars['ID']['output'];
  /** Language codes. */
  languages: Array<Scalars['String']['output']>;
  /** Media. */
  media: Array<Media>;
  /** Display name (first name and last initial). */
  name: Scalars['String']['output'];
  /** Profile / bio. */
  profile: Scalars['String']['output'];
  /** Specialty verticals. */
  specialtyVerticals: Array<CreatorSpecialtyVertical>;
};

export type CreatorSearchFilter = {
  addressCity?: InputMaybe<StringFilter>;
  addressCountryCode?: InputMaybe<StringFilter>;
  birthYear?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<TimeFilter>;
  ethnicity?: InputMaybe<StringFilter>;
  gender?: InputMaybe<IdFilter>;
  hobbyInterests?: InputMaybe<IdArrayFilter>;
  keyword?: InputMaybe<StringFilter>;
  languages?: InputMaybe<StringArrayFilter>;
  name?: InputMaybe<StringFilter>;
  score?: InputMaybe<IntFilter>;
  specialtyVerticals?: InputMaybe<IdArrayFilter>;
  status?: InputMaybe<CreatorStatusFilter>;
  tags?: InputMaybe<IdArrayFilter>;
};

export type CreatorSearchParams = {
  /** Search query. */
  filter?: InputMaybe<CreatorSearchFilter>;
  pagination?: InputMaybe<OffsetPagination>;
  sort?: InputMaybe<SortInput>;
};

export type CreatorSearchResult = {
  __typename?: 'CreatorSearchResult';
  meta: OffsetPageInfo;
  nodes: Array<Creator>;
};

export type CreatorSocialMedia = {
  __typename?: 'CreatorSocialMedia';
  type: CreatorSocialMediaType;
  url: Scalars['String']['output'];
};

export enum CreatorSocialMediaType {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Other = 'OTHER',
  Pinterest = 'PINTEREST',
  Snapchat = 'SNAPCHAT',
  Tiktok = 'TIKTOK',
  Twitter = 'TWITTER',
  Youtube = 'YOUTUBE'
}

/** CreatorSpecialtyVertical (i.e. of a creator). */
export type CreatorSpecialtyVertical = {
  __typename?: 'CreatorSpecialtyVertical';
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** Human readable label for this specialty vertical. */
  label: Scalars['String']['output'];
};

/**
 * Creator approval status. DRAFT is a container-first stub: the profile row
 * (and its authorization scope) exists so uploads can govern to it while the
 * registration form is still in flight — creatorSignUp finalizes DRAFT →
 * PENDING, and staff finish staff-created drafts through the CRM upsert.
 */
export enum CreatorStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Pending = 'PENDING'
}

export type CreatorStatusFilter = {
  eq?: InputMaybe<CreatorStatus>;
  in?: InputMaybe<Array<CreatorStatus>>;
};

/** Tags used for internal organisation */
export type CreatorTag = {
  __typename?: 'CreatorTag';
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** Human readable label for this tag. */
  label: Scalars['String']['output'];
};

export type CreatorTags = {
  __typename?: 'CreatorTags';
  count: Scalars['Int']['output'];
  nodes: Array<CreatorTag>;
};

/** CSAT rating enumeration. */
export enum CsatRating {
  /** Completely satisfied. */
  CompletelySatisfied = 'CompletelySatisfied',
  /** Moderately satisfied. */
  ModeratelySatisfied = 'ModeratelySatisfied',
  /** Not at all satisfied. */
  NotAtAllSatisfied = 'NotAtAllSatisfied',
  /** Slightly satisfied. */
  SlightlySatisfied = 'SlightlySatisfied',
  /** Very satisfied. */
  VerySatisfied = 'VerySatisfied'
}

/**
 * A custom property value set on a record. The concrete type matches the
 * definition's type and carries the value payload for that type.
 */
export type CustomProperty = {
  /** Definition key for this value. */
  definitionKey: Scalars['ID']['output'];
};

/** Value payload for a CHECKBOX custom property. */
export type CustomPropertyCheckbox = CustomProperty & {
  __typename?: 'CustomPropertyCheckbox';
  checked?: Maybe<Scalars['Boolean']['output']>;
  definitionKey: Scalars['ID']['output'];
};

/** Configuration for CHECKBOX definitions. No fields are required. */
export type CustomPropertyCheckboxConfig = {
  __typename?: 'CustomPropertyCheckboxConfig';
  /** Reserved placeholder field. */
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Configuration input for CHECKBOX definitions. No fields are required. */
export type CustomPropertyCheckboxConfigInput = {
  /** Reserved placeholder field. */
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Configuration for a custom property definition. The returned variant matches
 * the definition's type.
 */
export type CustomPropertyConfig = CustomPropertyCheckboxConfig | CustomPropertyDateConfig | CustomPropertyNumberConfig | CustomPropertyRichTextConfig | CustomPropertySelectConfig | CustomPropertyTextConfig | CustomPropertyUserConfig;

/**
 * Configuration input for a custom property definition. Provide exactly one field,
 * matching the selected type.
 */
export type CustomPropertyConfigInput = {
  checkbox?: InputMaybe<CustomPropertyCheckboxConfigInput>;
  date?: InputMaybe<CustomPropertyDateConfigInput>;
  number?: InputMaybe<CustomPropertyNumberConfigInput>;
  richText?: InputMaybe<CustomPropertyRichTextConfigInput>;
  select?: InputMaybe<CustomPropertySelectConfigInput>;
  text?: InputMaybe<CustomPropertyTextConfigInput>;
  user?: InputMaybe<CustomPropertyUserConfigInput>;
};

/**
 * Value payload for a DATE custom property. Exactly one of date or dateTime is
 * returned.
 */
export type CustomPropertyDate = CustomProperty & {
  __typename?: 'CustomPropertyDate';
  /** Date-only value in YYYY-MM-DD format. */
  date?: Maybe<Scalars['String']['output']>;
  /** Date-time value. */
  dateTime?: Maybe<Scalars['Time']['output']>;
  definitionKey: Scalars['ID']['output'];
};

/** Configuration for DATE definitions. */
export type CustomPropertyDateConfig = {
  __typename?: 'CustomPropertyDateConfig';
  /** Whether this property stores a date-time value instead of a date-only value. */
  allowTime: Scalars['Boolean']['output'];
};

/** Configuration input for DATE definitions. */
export type CustomPropertyDateConfigInput = {
  /** Whether this property stores a date-time value instead of a date-only value. */
  allowTime?: Scalars['Boolean']['input'];
};

/** A custom property definition for a supported owner record kind. */
export type CustomPropertyDefinition = {
  __typename?: 'CustomPropertyDefinition';
  /** Whether this definition is archived. */
  archived: Scalars['Boolean']['output'];
  /** Configuration for this definition. */
  config: CustomPropertyConfig;
  /**
   * The admin-chosen icon: an https image URL or inline SVG markup. Null means
   * the UI shows its default glyph for the type.
   */
  icon?: Maybe<Scalars['String']['output']>;
  /** Stable key for this definition. */
  key: Scalars['ID']['output'];
  /** Display label for this property. */
  label: Scalars['String']['output'];
  /**
   * Options for SELECT definitions. Archived options are excluded unless
   * includeArchived is true.
   */
  options: Array<CustomPropertyOption>;
  /** The record kind this definition can be assigned to. */
  ownerType: CustomPropertyOwnerType;
  /**
   * Whether a PROJECT definition is displayed in the project header. Accepted
   * but unused for CONCEPT definitions.
   */
  pinned: Scalars['Boolean']['output'];
  /**
   * Display order among the definitions of the same owner type, starting at 1.
   * Every query returns definitions ordered by (position, slug); that order is
   * authoritative and clients render it as given.
   */
  position: Scalars['Int']['output'];
  /** Organizational unit keys where this definition applies. */
  scopes: Array<Scalars['ID']['output']>;
  /** Human-readable slug for this definition. */
  slug: Scalars['String']['output'];
  /** The value kind accepted by this definition. */
  type: CustomPropertyType;
};


/** A custom property definition for a supported owner record kind. */
export type CustomPropertyDefinitionOptionsArgs = {
  includeArchived?: Scalars['Boolean']['input'];
};

/** Scope filters for custom property definition queries. */
export type CustomPropertyDefinitionScopesInput = {
  /** Organizational unit keys whose matching definitions should be returned. */
  organizationalUnitKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Options for querying custom property definitions. */
export type CustomPropertyDefinitionsInput = {
  /** Optional definition UUID keys to return. */
  definitionKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether archived definitions should be included. */
  includeArchived?: Scalars['Boolean']['input'];
  /** Optional record kind to return definitions for. */
  ownerType?: InputMaybe<CustomPropertyOwnerType>;
  /** Scope filters used to return only definitions visible for matching records. */
  scopes?: InputMaybe<CustomPropertyDefinitionScopesInput>;
};

/** Value payload for a NUMBER custom property. */
export type CustomPropertyNumber = CustomProperty & {
  __typename?: 'CustomPropertyNumber';
  definitionKey: Scalars['ID']['output'];
  number?: Maybe<Scalars['Float']['output']>;
};

/** Configuration for NUMBER definitions. No fields are required. */
export type CustomPropertyNumberConfig = {
  __typename?: 'CustomPropertyNumberConfig';
  /** Reserved placeholder field. */
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Configuration input for NUMBER definitions. No fields are required. */
export type CustomPropertyNumberConfigInput = {
  /** Reserved placeholder field. */
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An option for a SELECT custom property. Options resolve by key for value
 * rendering regardless of archive state; archived options cannot be newly
 * selected.
 */
export type CustomPropertyOption = {
  __typename?: 'CustomPropertyOption';
  /** Whether this option is archived and therefore not selectable. */
  archived: Scalars['Boolean']['output'];
  /** Display color for this option. */
  color: CustomPropertyOptionColor;
  /** Stable key for this option. */
  key: Scalars['ID']['output'];
  /** Display label for this option. */
  label: Scalars['String']['output'];
  /** Exact scope OU for a user-created option; null for global admin options. */
  scopeOrganizationalUnitKey?: Maybe<Scalars['ID']['output']>;
  /**
   * Human-facing semantic value for this option, unique among active options in
   * the same global or OU scope. It may be renamed by a
   * key-anchored administration update — identity lives in the key, which is
   * what value assignment references.
   */
  value: Scalars['String']['output'];
};

/** The display color assigned to a select option. */
export enum CustomPropertyOptionColor {
  Amber = 'AMBER',
  Blue = 'BLUE',
  Default = 'DEFAULT',
  Green = 'GREEN',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Teal = 'TEAL',
  Violet = 'VIOLET'
}

/** Option input for create and update definition mutations. */
export type CustomPropertyOptionInput = {
  /** Display color for this option. */
  color?: CustomPropertyOptionColor;
  /**
   * Identity of an existing option to update — including a value rename — or,
   * when that option is archived, to restore. Omit to create a new option; a
   * keyless value held by a kept active option is rejected — pass its key to
   * update it.
   */
  key?: InputMaybe<Scalars['ID']['input']>;
  /** Display label for this option. */
  label: Scalars['String']['input'];
  /** Display order for this option. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Option value, unique among the definition's active options. */
  value: Scalars['String']['input'];
};

/** The record kind a custom property definition can be assigned to. */
export enum CustomPropertyOwnerType {
  Concept = 'CONCEPT',
  Project = 'PROJECT'
}

/** Value payload for a RICH_TEXT custom property. */
export type CustomPropertyRichText = CustomProperty & {
  __typename?: 'CustomPropertyRichText';
  definitionKey: Scalars['ID']['output'];
  richText?: Maybe<Scalars['JSON']['output']>;
};

/** Configuration for RICH_TEXT definitions. No fields are required. */
export type CustomPropertyRichTextConfig = {
  __typename?: 'CustomPropertyRichTextConfig';
  /** Reserved placeholder field. */
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Configuration input for RICH_TEXT definitions. No fields are required. */
export type CustomPropertyRichTextConfigInput = {
  /** Reserved placeholder field. */
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Value payload for a SELECT custom property. Single-select values are returned as
 * a one-item list.
 */
export type CustomPropertySelect = CustomProperty & {
  __typename?: 'CustomPropertySelect';
  definitionKey: Scalars['ID']['output'];
  /**
   * Stored option references, resolved to their owning options regardless of
   * archive state. Removing an option from a definition archives it rather than
   * deleting it, so a stored reference keeps resolving; an entry is null only
   * when its option predates the archive lifecycle or cannot currently be
   * resolved.
   */
  options: Array<Maybe<CustomPropertyOption>>;
};

/** Configuration for SELECT definitions. */
export type CustomPropertySelectConfig = {
  __typename?: 'CustomPropertySelectConfig';
  /** Whether users may create new options while setting a value. */
  allowUserDefinedOptions: Scalars['Boolean']['output'];
  /** Whether this property accepts multiple selected options. */
  multi: Scalars['Boolean']['output'];
};

/** Configuration input for SELECT definitions. */
export type CustomPropertySelectConfigInput = {
  /** Whether users may create new options while setting a value. */
  allowUserDefinedOptions?: Scalars['Boolean']['input'];
  /** Whether this property accepts multiple selected options. */
  multi?: Scalars['Boolean']['input'];
};

/** Value payload for a TEXT custom property. */
export type CustomPropertyText = CustomProperty & {
  __typename?: 'CustomPropertyText';
  definitionKey: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

/** Configuration for TEXT definitions. No fields are required. */
export type CustomPropertyTextConfig = {
  __typename?: 'CustomPropertyTextConfig';
  /** Reserved placeholder field. */
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Configuration input for TEXT definitions. No fields are required. */
export type CustomPropertyTextConfigInput = {
  /** Reserved placeholder field. */
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The supported value kinds for custom property definitions. */
export enum CustomPropertyType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Number = 'NUMBER',
  RichText = 'RICH_TEXT',
  Select = 'SELECT',
  Text = 'TEXT',
  User = 'USER'
}

/**
 * Value payload for a USER custom property. Single-user values are returned as a
 * one-item list of principals.
 */
export type CustomPropertyUser = CustomProperty & {
  __typename?: 'CustomPropertyUser';
  definitionKey: Scalars['ID']['output'];
  principals: Array<Principal>;
};

/** Configuration for USER definitions. */
export type CustomPropertyUserConfig = {
  __typename?: 'CustomPropertyUserConfig';
  /** Whether this property accepts multiple users. */
  multi: Scalars['Boolean']['output'];
  /** Whether assigned users should be notified when this value is set. */
  notifyOnAssign: Scalars['Boolean']['output'];
};

/** Configuration input for USER definitions. */
export type CustomPropertyUserConfigInput = {
  /** Whether this property accepts multiple users. */
  multi?: Scalars['Boolean']['input'];
  /** Whether assigned users should be notified when this value is set. */
  notifyOnAssign?: Scalars['Boolean']['input'];
};

export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
};

export type DeactivateUgcDeliverablesInput = {
  /** Integration keys of the UGC Deliverables to deactivate */
  keys: Array<Scalars['ID']['input']>;
};

export type DeclineCreatorOfferInput = {
  key: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** A Deliverable. */
export type Deliverable = {
  __typename?: 'Deliverable';
  amplifyIntegration?: Maybe<DeliverableAmplifyIntegration>;
  /**
   * When the deliverable was archived; null while it is live. Only a read by
   * key serves an archived deliverable — `Query.deliverable` and any reference
   * resolved by key, such as a variation's `sourceDeliverable` — so a page can
   * show it as archived; list reads leave archived deliverables out.
   */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The audio asset associated with the deliverable. */
  audio?: Maybe<DeliverableAudio>;
  /** The bitrate of the deliverable's asset, for video deliverables — a per-version media snapshot. */
  bitrate?: Maybe<Scalars['BigInt']['output']>;
  /** The bitrate mode of the deliverable's asset, for video deliverables — a per-version media snapshot. */
  bitrateMode?: Maybe<Scalars['String']['output']>;
  /** Check whether revisions on this deliverable can be added, edited or deleted for the specified intent. */
  canUpdateRevisions: Scalars['Boolean']['output'];
  /**
   * The key of the concept this deliverable belongs to. A variation's
   * deliverables carry the variation's own concept key.
   */
  conceptKey: Scalars['ID']['output'];
  /** Whether the deliverable contains AI-generated content. */
  containsAi: Ternary;
  /** The copy variation number of the deliverable. */
  copyVariationNumber: Scalars['Int']['output'];
  /** When the deliverable was created. */
  createTime: Scalars['Time']['output'];
  creativeX?: Maybe<DeliverableCreativeX>;
  /**
   * The duration in seconds of the deliverable's asset, for video
   * deliverables — a per-version media snapshot of the asset behind `file`.
   */
  duration: Scalars['Float']['output'];
  /** The export filename. */
  exportFilename?: Maybe<Scalars['String']['output']>;
  /**
   * The instant this version first entered client review, as the revision
   * domain observed it — null until then.
   */
  externallyDeliveredAt?: Maybe<Scalars['Time']['output']>;
  /** The file associated with the deliverable. */
  file: File;
  /** The height of the format requested. */
  formatHeight: Scalars['Float']['output'];
  /** The width of the format requested. */
  formatWidth: Scalars['Float']['output'];
  /** The frame rate of the deliverable's asset, for video deliverables — a per-version media snapshot. */
  framesPerSecond?: Maybe<Scalars['Float']['output']>;
  hasConceptRevisions: Scalars['Boolean']['output'];
  /** Whether this deliverable has reached an external review stage. */
  hasReachedReviewStage: Scalars['Boolean']['output'];
  /**
   * The actual pixel height of the deliverable's asset, extracted from the
   * file on upload — distinct from `formatHeight`, the height requested.
   */
  height?: Maybe<Scalars['Int']['output']>;
  /** Flags the deliverable as the hero deliverable of its concept. */
  hero: Scalars['Boolean']['output'];
  /**
   * Whether the deliverable is an approved hero deliverable — derived from
   * `hero` and `verdict`, never stored.
   */
  heroApproved?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The instant this version first entered internal review, as the revision
   * domain observed it on the deliverable's status stream — null until then.
   */
  internallyDeliveredAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Whether this row is its specification's head for the caller: the newest
   * delivered, unarchived version the caller's plan admits — the election
   * `DeliverableSpecification.deliverable` answers (that field's row carries its
   * own election; any other row is elected once per batch under the caller's
   * plan; docs/deliverable-status-seam/SCOPE.md, Train A item 2 as amended
   * 2026-09-14: `isHead` alone, no stored head answers a viewer question).
   * False for an archived row, a replaced version and a row placed against no
   * specification — none is ever a head — and for a version the caller may
   * read that a newer admitted version outranks. Viewer-relative: callers
   * whose plans admit different versions can disagree. A row's superseded
   * relation is derived from it, never stored: delivered, unarchived, placed
   * against a specification and not the head. A row placed against no
   * specification is neither head nor superseded — it has no lineage in which
   * a successor could exist.
   */
  isHead: Scalars['Boolean']['output'];
  /** The key of the deliverable. */
  key: Scalars['ID']['output'];
  /** The language code of the deliverable. */
  languageCode?: Maybe<Scalars['String']['output']>;
  /** The locale key of the deliverable. */
  localeKey?: Maybe<Scalars['ID']['output']>;
  /** The measurement unit the format dimensions are represented in. */
  measurementUnit: MeasurementUnit;
  /** The overlay URL for placement or safezone overlays on this deliverable. */
  overlayUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The row's placement outcome: the specification service's answer to the
   * ensure the save staged for a deliverable placed by concept
   * (docs/eventing-consumer-kafka-cutover/SCOPE.md, erratum D-RC-A; D-PL-B),
   * computed on the server from the stored facts. It says WHAT the answer
   * was, never whether this read has caught up with your save — the
   * mutation's `convergence` and the reads' `atLeast` answer that.
   */
  placement: DeliverablePlacement;
  /** The key of the project this deliverable belongs to. */
  projectKey: Scalars['ID']['output'];
  /** The quality assurance report results. */
  qualityAssuranceReport?: Maybe<QualityAssuranceReport>;
  /**
   * The revision domain's view of the deliverable's concept — the concept
   * notes and the project link. Null when the revision domain has not
   * mirrored the deliverable.
   */
  revisionConcept?: Maybe<RevisionConcept>;
  /**
   * The revisions-completed notifications raised on this version, oldest
   * first: the revision domain raises one when a version arrives whose
   * externally delivered predecessor carried revisions. Empty when none;
   * acknowledged ones stay listed with `acknowledged: true`.
   */
  revisionNotifications: Array<Notification>;
  /** Revisions for a deliverable, defaults to Corrective intent */
  revisions: Revisions;
  /**
   * The specification this deliverable fulfils, when it has been placed
   * against one. The Specification subgraph owns the format facts
   * (`specification.format`: key, name, length, dimension, platform).
   */
  specification?: Maybe<DeliverableSpecification>;
  /** The key of the specification this deliverable fulfils, when it has been placed against one. */
  specificationKey?: Maybe<Scalars['ID']['output']>;
  /** Given name of the deliverable, chosen by the production team on upload. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unit number of the deliverable, distinguishing otherwise-identical deliverables of one specification. */
  unitNumber: Scalars['Int']['output'];
  /** When the deliverable was last updated. */
  updateTime: Scalars['Time']['output'];
  /**
   * The deliverable's verdict position — the status seam's exclusive fact
   * (docs/deliverable-status-seam/SCOPE.md, Train A item 1), derived from the
   * row: IN_REVIEW from internal or client review, CHANGES_REQUESTED from
   * internal or client revision, APPROVED from approved. A version the replace
   * lane stamped superseded, before Train B-0 stopped the stamps, reads
   * IN_REVIEW, and CHANGES_REQUESTED while it holds an open corrective request
   * (D-B0-1-C (a)); that a newer version replaced it is `isHead`'s to say. A
   * stored value the mapping does not know reads IN_REVIEW — not approved, so
   * in review — rather than failing the field.
   */
  verdict: DeliverableVerdict;
  /** The external (client-facing) version number, once the deliverable has been versioned. */
  versionExternal?: Maybe<Scalars['Int']['output']>;
  /** The internal version number within the current external version, once the deliverable has been versioned. */
  versionInternal?: Maybe<Scalars['Int']['output']>;
  /**
   * Advisory operation-check answers for this deliverable. Nullable by
   * contract (fleet rule P1): the surface is a UX guard, not enforcement, so a
   * consumer that cannot get an answer treats null as not-permitted and
   * degrades — a failed check hop must never take the page data down with it.
   */
  viewerOperationChecks?: Maybe<Array<DeliverableOperationCheck>>;
  /**
   * The actual pixel width of the deliverable's asset, extracted from the
   * file on upload — distinct from `formatWidth`, the width requested.
   */
  width?: Maybe<Scalars['Int']['output']>;
};


/** A Deliverable. */
export type DeliverableCanUpdateRevisionsArgs = {
  intent: RevisionIntent;
};


/** A Deliverable. */
export type DeliverableOverlayUrlArgs = {
  type: OverlayType;
};


/** A Deliverable. */
export type DeliverableRevisionsArgs = {
  params?: InputMaybe<RevisionsParams>;
};


/** A Deliverable. */
export type DeliverableViewerOperationChecksArgs = {
  operations: Array<DeliverableOperation>;
};

export type DeliverableAmplifyIntegration = {
  __typename?: 'DeliverableAmplifyIntegration';
  amplifyMultiformatTemplateComposition: Scalars['String']['output'];
  amplifyMultiformatTemplateID: Scalars['String']['output'];
  amplifyMultiformatTemplateName: Scalars['String']['output'];
  amplifyMultiformatTemplateVersion: Scalars['Int']['output'];
  deliverableKey: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
};

/**
 * The Amplify multiformat template binding for a created deliverable. The
 * integration is created by the auto-delivery service as an asynchronous
 * command once the row exists, promised by the payload's `writeToken`.
 */
export type DeliverableAmplifyIntegrationInput = {
  amplifyMultiformatTemplateComposition: Scalars['String']['input'];
  amplifyMultiformatTemplateID: Scalars['String']['input'];
  amplifyMultiformatTemplateVersion: Scalars['Int']['input'];
};

export enum DeliverableApprovalAction {
  Approve = 'APPROVE',
  Unapprove = 'UNAPPROVE'
}

/** An audio asset. */
export type DeliverableAudio = {
  __typename?: 'DeliverableAudio';
  /** The type of the audio asset. */
  type: DeliverableAudioType;
  /** The URL of the audio asset. */
  url?: Maybe<Scalars['String']['output']>;
};

/** A container for arguments used when creating/updating an audio asset. */
export type DeliverableAudioInput = {
  /** The type of the audio asset. */
  type: DeliverableAudioType;
  /** The URL of the audio asset. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** The type of an audio asset. */
export enum DeliverableAudioType {
  ClientProvided = 'CLIENT_PROVIDED',
  CustomAudio = 'CUSTOM_AUDIO',
  NoAudio = 'NO_AUDIO'
}

export type DeliverableCreativeX = {
  __typename?: 'DeliverableCreativeX';
  /** Notes for the CreativeX preflight */
  notes?: Maybe<Scalars['String']['output']>;
  /** The CreativeX preflight task */
  preflight?: Maybe<CreativeXPreflight>;
  /** The CreativeX preflight result */
  result?: Maybe<CreativeXResult>;
  /** The lifecycle state of the CreativeX analysis for this deliverable */
  state: CreativeXAnalysisState;
};

export enum DeliverableFileType {
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Mp4 = 'MP4',
  Pdf = 'PDF',
  Png = 'PNG',
  Quicktime = 'QUICKTIME'
}

/** DeliverableFormat represents a well-known set of creative attributes for a deliverable. */
export type DeliverableFormat = {
  __typename?: 'DeliverableFormat';
  archivedAt?: Maybe<Scalars['Time']['output']>;
  creativeGroup?: Maybe<CreativeGroup>;
  dimension?: Maybe<Dimension>;
  filenameCode?: Maybe<Scalars['String']['output']>;
  formatLengths: Array<FormatLength>;
  heroPriority?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use `key` instead. */
  integrationKey: Scalars['ID']['output'];
  isCustom: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  platform: Platform;
  position: Scalars['Int']['output'];
  trelloLabelName?: Maybe<Scalars['String']['output']>;
};

export enum DeliverableFormatAvailability {
  ActiveQuestionBacked = 'ACTIVE_QUESTION_BACKED',
  All = 'ALL'
}

export type DeliverableFormatDimensionInput = {
  formatLengths: Array<FormatLength>;
  height?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<MeasurementUnit>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type DeliverableFormats = {
  __typename?: 'DeliverableFormats';
  metadata: Metadata;
  nodes: Array<DeliverableFormat>;
};

/**
 * Semantic operations on a deliverable. Values are user-intent affordance
 * verbs (the fleet contract, docs/viewer-operation-checks/SCOPE.md), never ACL
 * action IDs: the enforcement actions are the authz subgraph's concern —
 * documented on its declaration's value doc strings — while the state
 * predicates live here (APPROVE/UNAPPROVE consult the approval lifecycle,
 * REPLACE the replace lane's admit set; every other operation carries no
 * domain gate today). Declared identically in both subgraphs.
 */
export enum DeliverableOperation {
  /**
   * Capability to approve this deliverable: preflights the same
   * deliverable:approve decision updateDeliverableApproval enforces at the
   * deliverable — the one enforcement action behind both approval verbs.
   */
  Approve = 'APPROVE',
  /**
   * Capability to request a revision of this deliverable: preflights the same
   * revision:write decision the revision-request mutations enforce at the
   * deliverable.
   */
  CreateRevision = 'CREATE_REVISION',
  /**
   * Capability to reject a revision in the context of this deliverable: passes
   * when the caller's grants pass revision:review at this deliverable. The
   * RejectRevision mutation enforces that decision at both the source revision's
   * deliverable and the reject-target deliverable — preflight REJECT on both
   * keys and require both to pass (fleet rule P5: multi-target operations stay
   * per-target checks the consumer ANDs).
   */
  Reject = 'REJECT',
  /**
   * Capability to replace this deliverable with a new upload: preflights the
   * same deliverable:write decision supersedeDeliverable enforces at the
   * deliverable (the upload page's replace affordance,
   * docs/deliverable-status-seam/SCOPE.md Train A). The deliverable subgraph's
   * validation leg carries the replace lane's own admit set.
   */
  Replace = 'REPLACE',
  /**
   * Capability to unapprove this deliverable: preflights the same
   * deliverable:approve decision as APPROVE (updateDeliverableApproval
   * enforces one action for both verbs); the two operations differ in their
   * deliverable-side state predicates, never in access.
   */
  Unapprove = 'UNAPPROVE',
  /**
   * Capability to modify this deliverable: preflights the same
   * deliverable:write decision the deliverable write mutations enforce at the
   * deliverable.
   */
  Write = 'WRITE',
  /**
   * Capability to author into, and re-tier within, the limited visibility tier
   * of this deliverable's revision comments: passes when the caller's grants
   * pass revision_comment:write_limited at this deliverable. Mirrors the tier
   * half of the AddComment/EditComment check matrix — enforcement demands it
   * exactly when a mutation carries the limited tier or moves a comment out of
   * it (tiering governs reads; lifecycle verbs stay tier-blind).
   */
  WriteLimitedRevisionComments = 'WRITE_LIMITED_REVISION_COMMENTS',
  /**
   * Capability to author into this deliverable's revision comment threads: passes
   * when the caller's grants pass revision_comment:write at this deliverable —
   * the AddComment base check exactly. Renders the reply affordance; editing an
   * existing comment preflights the Comment entity's EDIT operation check
   * instead (owner-bound revision_comment:update).
   */
  WriteRevisionComments = 'WRITE_REVISION_COMMENTS'
}

/**
 * The clearable obstacles behind a refused validation. Values name domain
 * facts the caller can resolve; the status-shaped half of the admit set is
 * never disclosed this way.
 */
export enum DeliverableOperationBlocker {
  /** The deliverable has open (non-archived) corrective revisions; resolving or archiving them clears the block. */
  OpenRevisions = 'OPEN_REVISIONS'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * extends Deliverable with `viewerOperationChecks`); this subgraph contributes
 * the `validation` leg — the domain's registered state predicates — and the
 * blockers disclosure. Its resolvable key is the sanctioned hop for the
 * domain half of the two-leg check.
 */
export type DeliverableOperationCheck = {
  __typename?: 'DeliverableOperationCheck';
  authorization: ActionCheckResult;
  /**
   * Present only when the deliverable's status admits the operation but a
   * domain fact refuses it (today: OPEN_REVISIONS on APPROVE); empty when
   * validation passes or when the status itself refuses. Lets a client
   * render a blocked affordance as disabled-with-reason instead of hidden,
   * without owning any of the rule.
   */
  blockers: Array<DeliverableOperationBlocker>;
  deliverableKey: Scalars['ID']['output'];
  operation: DeliverableOperation;
  /**
   * Pure domain leg: does the deliverable's CURRENT state admit this
   * operation. Caller-blind. APPROVE and UNAPPROVE answer exactly what
   * updateDeliverableApproval enforces, read from the owner's live row —
   * APPROVE is admitted from the two review statuses when the
   * deliverable has no open corrective revisions (the lane's own
   * server-owned guard), and idempotently from approved; UNAPPROVE from
   * approved alone. REPLACE answers the upload page's presentation rule —
   * whether a drop on the row is shown in its place or beside it as a new
   * version (D-9357-C, docs/deliverable-status-seam/SCOPE.md); the save
   * writes nothing to the row either way, since the predecessor stamps
   * stopped (Train B-0 step 2): admitted from internal review, client
   * review and approved; refused from a revision status and
   * from a superseded row — the status-shaped refusal, so no blocker is
   * disclosed. Every other operation carries no
   * domain state gate today and admits trivially (fleet rule P4 — the vOC
   * cutover is a re-keying, not a guard promotion; candidates for later
   * promotion are recorded in docs/viewer-operation-checks-deliverable/SCOPE.md).
   */
  validation: ActionCheckResult;
};

/**
 * The placement outcome of a deliverable (erratum D-RC-A; D-PL-B): the
 * specification service's answer to the ensure the save staged, derived from
 * the stored facts — the attempt the row awaits or was last answered by, the
 * answer time, the refusal reason and the specification key. A domain state,
 * not a convergence claim.
 */
export type DeliverablePlacement = {
  __typename?: 'DeliverablePlacement';
  /**
   * The placement attempt the row awaits or was last answered by — the
   * `placement_attempt_integration_key` of the EnsureDeliverablePlacementCommand
   * its save staged; null when no ensure was staged for it.
   */
  attemptKey?: Maybe<Scalars['ID']['output']>;
  /** Which answer the row holds. */
  outcome: DeliverablePlacementOutcome;
  /**
   * The specification service's own reason when it refused the current
   * attempt; null otherwise. UNKNOWN renders a reason this graph does not
   * spell — the refusal stands, the reason is colour.
   */
  refusalReason?: Maybe<DeliverablePlacementRefusalReason>;
};

export enum DeliverablePlacementOutcome {
  /** The row's current attempt awaits the specification service's reply. */
  Pending = 'PENDING',
  /** The row holds its specification — the reply placed it, or it was placed by specification key at birth. */
  Placed = 'PLACED',
  /** The specification service refused the row's current attempt; `refusalReason` says why. The row keeps whatever it held; a save placed by concept asks again. */
  Refused = 'REFUSED',
  /**
   * No ensure was staged for the row and it holds no specification — the keyless shape, which no live row holds any more.
   * @deprecated The keyless shape it named (no specification, no placement attempt) left the data model, so no live row holds it (docs/deliverable-status-seam/SCOPE.md, D-B0-6-E (c); ledger row K3). Deleted in the next release train; the value is never reused.
   */
  Unplaced = 'UNPLACED'
}

/** The specification service's own refusal vocabulary, recorded verbatim and never branched on by the sender. */
export enum DeliverablePlacementRefusalReason {
  /** The attempt key is ledgered for another deliverable. */
  AttemptConflict = 'ATTEMPT_CONFLICT',
  /** The concept is archived; nothing is placed under it. */
  ConceptArchived = 'CONCEPT_ARCHIVED',
  /** The format key names no deliverable format in the product catalog. */
  FormatNotFound = 'FORMAT_NOT_FOUND',
  /** The command's project is not the concept's project. */
  IdentityMismatch = 'IDENTITY_MISMATCH',
  /** The wire was addressable but did not read as a placement identity. */
  InvalidIdentity = 'INVALID_IDENTITY',
  /** The caller was refused concept:write on the concept at apply. */
  NotPermitted = 'NOT_PERMITTED',
  /** A currently authorized operator cancelled the retained request without applying it. */
  OperatorCancelled = 'OPERATOR_CANCELLED',
  /** A reason this graph does not spell, or a refusal recorded before its reason was. */
  Unknown = 'UNKNOWN'
}

export type DeliverableSpecification = {
  __typename?: 'DeliverableSpecification';
  /**
   * When the specification was archived (removed): its own archive's time,
   * else, for a specification archived through its concept's archive, the
   * concept's; null while it is live. A specification of a live concept
   * archived before its archive time was recorded reads null here while its
   * `progressStatus` is ARCHIVED.
   */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** Check whether revisions on this specification can be added, edited or deleted. Defaults to Variation intent. Null when the answer was withheld from this viewer. */
  canUpdateRevisions?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The owning concept's key. The authz subgraph keys this entity by
   * `key conceptKey` (the ConceptWorkflowTransition shape) so its
   * viewerOperationChecks container can point-check the concept without a
   * lookup of its own: the specification subgraph resolves it in one batched
   * read per page and the router carries it in the representation.
   */
  conceptKey: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  creationType: DeliverableSpecificationCreationType;
  /** The latest deliverable for a specification, if available */
  deliverable?: Maybe<Deliverable>;
  /**
   * All deliverables for a specification. Fence-capable
   * (docs/eventing-consumer-kafka-cutover/SCOPE.md, erratum D-RC-A; D-PL-A):
   * present a save's `writeToken` as `atLeast` to ask for read-your-writes
   * over that save's placements, and the wrapper's `convergence` discloses
   * whether the read happens-after them. One `atLeast` governs the whole
   * batch the router resolves together (the page reloads with one token),
   * and every specification in it discloses the one verdict. Without a
   * token the read is unfenced and claims nothing; a token this deployment
   * cannot verify (no signing material, or a rotated-away key) degrades the
   * read to unfenced with the demotion visible — never an error and never a
   * null; a token bound outside the caller's tenancy is refused.
   */
  deliverables: Deliverables;
  /** The generated expected filename for this specification, without extension. */
  expectedFileName: Scalars['String']['output'];
  format: DeliverableSpecificationFormat;
  generativeResult?: Maybe<GenerativeSpecificationRecord>;
  /** Whether this specification has any revisions that apply to the entire concept */
  hasConceptRevisions: Scalars['Boolean']['output'];
  /**
   * Whether ANY deliverable version of this specification has reached the
   * review stage — the specification-level form of
   * `Deliverable.hasReachedReviewStage` (docs/deliverable-status-seam/SCOPE.md,
   * D-TA-3 (b)): true once a version of the lineage was delivered to the
   * client, and it never flips back when a later version is internal-only
   * (`deliverable.hasReachedReviewStage` reads the elected head alone, and
   * does). Archived versions count: the client saw them, and the latch is a
   * historical fact. Monotonic over the versions this specification HOLDS,
   * which is what the variant-level question asks — a version moved to another
   * specification takes the fact with it, so the source can answer false again
   * and the target true, exactly as the head election already moves with it.
   * Answered over the rows the caller's read plan admits like every other read;
   * a client's plan admits exactly the latched rows, which is this predicate,
   * so a client and an internal viewer read the same answer.
   */
  hasReachedReviewStage: Scalars['Boolean']['output'];
  isHero: Scalars['Boolean']['output'];
  isSourceVariation: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  language: Language;
  /** @deprecated Use language instead. */
  languageCode: Scalars['String']['output'];
  /**
   * The newest approved deliverable of the specification the caller may read
   * (docs/deliverable-status-seam/SCOPE.md, D-DSS-3 (a)): the newest
   * unarchived version with verdict APPROVED among the rows the caller's plan
   * admits, elected in the answering statement like `deliverable` — so it can
   * be older than `deliverable` when a newer version awaits a verdict, and it
   * is null when no admitted version is approved.
   */
  latestApproved?: Maybe<Deliverable>;
  locale?: Maybe<Locale>;
  /**
   * Whether this specification needs a new deliverable version; see
   * `DeliverableSpecificationNewVersion.needed`. Whether the specification
   * is being removed is not reflected here; see `removal`.
   */
  needsNewVersion: DeliverableSpecificationNewVersion;
  progressStatus: DeliverableSpecificationProgressStatus;
  /**
   * The specification service's answer to the removal a save asked for
   * through `specifications.removeKeys` (docs/specification-delivery-and-
   * removal/SCOPE.md), derived from the sender's own ledger — the newest
   * attempt: NONE when no save ever asked, PENDING while the attempt awaits
   * its answer, REMOVED once the archived-status fact landed, REFUSED with
   * the receiver's reason. A fence-capable read of its own: present the
   * save's `writeToken` as `atLeast` to read the record only after every
   * attempt the token promises — placements and removals alike — has been
   * answered or the deliverable module's budget has run out, and act on the
   * record's `convergence`; the sibling `deliverables(atLeast:)` wait does
   * not cover this field, since the two resolve concurrently. Unfenced
   * without a token, with the no-claim disclosure.
   */
  removal: DeliverableSpecificationRemoval;
  /** Revisions for a specification, defaults to Variation intent */
  revisions: Revisions;
  /** The deliverable used as creative source (for a variation) */
  sourceDeliverable?: Maybe<Deliverable>;
  /** The specification used as source (for a variation) */
  sourceSpecification?: Maybe<DeliverableSpecification>;
  unitNumber: Scalars['Int']['output'];
  /**
   * Advisory operation-check answers for this specification. Nullable by
   * contract (fleet rule P1): the surface is a UX guard, not enforcement, so
   * a consumer that cannot get an answer treats null as not-permitted and
   * degrades — a failed check hop must never take the page data down with it.
   */
  viewerOperationChecks?: Maybe<Array<DeliverableSpecificationOperationCheck>>;
};


export type DeliverableSpecificationDeliverablesArgs = {
  atLeast?: InputMaybe<Scalars['String']['input']>;
};


export type DeliverableSpecificationNeedsNewVersionArgs = {
  atLeast?: InputMaybe<Scalars['String']['input']>;
};


export type DeliverableSpecificationRemovalArgs = {
  atLeast?: InputMaybe<Scalars['String']['input']>;
};


export type DeliverableSpecificationRevisionsArgs = {
  params?: InputMaybe<RevisionsParams>;
};


export type DeliverableSpecificationViewerOperationChecksArgs = {
  operations: Array<DeliverableSpecificationOperation>;
};

export enum DeliverableSpecificationCreationType {
  AdditionalFormats = 'ADDITIONAL_FORMATS',
  Automation = 'AUTOMATION',
  Briefing = 'BRIEFING',
  Reconciliation = 'RECONCILIATION',
  Variations = 'VARIATIONS'
}

export type DeliverableSpecificationFormat = {
  __typename?: 'DeliverableSpecificationFormat';
  dimension: SpecificationDimension;
  heroPriority?: Maybe<Scalars['Int']['output']>;
  key: Scalars['ID']['output'];
  length: FormatLength;
  name: Scalars['String']['output'];
  platform: Platform;
};

/**
 * Whether a specification needs a new deliverable version, with the
 * convergence of the read that answered it.
 */
export type DeliverableSpecificationNewVersion = {
  __typename?: 'DeliverableSpecificationNewVersion';
  /**
   * Convergence disclosure of the read that produced this answer against
   * the `atLeast` token it was given (D-PL-A): `fenced` when a token was
   * verified and evaluated, `converged` when every attempt the token
   * promises was answered before the head was elected, else the promise's
   * entry in `uncovered`. The constant no-claim meta (`fenced: false`) when
   * no token was presented or it could not be verified.
   */
  convergence: ConvergenceMeta;
  /**
   * True when the specification has no current deliverable (`deliverable` is
   * null), or its current deliverable has at least one open corrective
   * revision request, raised by an internal reviewer or by the client. False
   * when the current deliverable has no open corrective revision requests.
   *
   * The current deliverable is the one `deliverable` returns for the same
   * caller, so callers who can see different versions can receive different
   * answers.
   */
  needed: Scalars['Boolean']['output'];
};

/**
 * The user-intent operations of the DeliverableSpecification operation-check
 * surface (docs/viewer-operation-checks/SCOPE.md). Declared identically in
 * the authz subgraph, which owns the container and the authorization leg;
 * this subgraph federates the validation leg and its blockers onto the check
 * entity.
 */
export enum DeliverableSpecificationOperation {
  /**
   * Capability to remove this specification — the uploader's "Delete format"
   * (docs/specification-delivery-and-removal/SCOPE.md): preflights the same
   * concept:write decision at the specification's concept that the
   * updateDeliverables save enforces before its transaction for each
   * `specifications.removeKeys` entry, and that the specification service
   * re-checks when it applies the RemoveDeliverableSpecification command.
   */
  Remove = 'REMOVE',
  /**
   * Capability to restore this removed specification — the upload page's
   * "Restore format" (docs/restore-specification-door/SCOPE.md): preflights
   * the same concept:write decision at the specification's concept that
   * restoreDeliverableSpecification enforces (whoever may remove a format may
   * restore it), and answers from the restore door's own admission in every
   * state: a live specification is blocked NOT_ARCHIVED.
   */
  Restore = 'RESTORE'
}

/**
 * The clearable obstacles behind a refused validation (fleet rule P3): each
 * names a fact the caller can resolve, rendered as the disabled item's reason.
 * The REMOVE check names the removal admission's obstacles, and ARCHIVED for a
 * specification removed already; the RESTORE check names the one reason the
 * restore door would refuse with. A specification that does not exist
 * discloses none.
 */
export enum DeliverableSpecificationOperationBlocker {
  /** The specification is archived (removed already): the REMOVE check's answer for it. Restoring it is RESTORE's. */
  Archived = 'ARCHIVED',
  /** The owning concept is archived; nothing under it is written. */
  ConceptArchived = 'CONCEPT_ARCHIVED',
  /** A deliverable row is landing on the specification — a placement the specification service answered with it whose reply the deliverable service has not applied yet — so the format cannot be removed under it, whatever the concept's stage. (Phase 1 named every row with it.) */
  HasDeliverables = 'HAS_DELIVERABLES',
  /** Live (unarchived) deliverable rows are placed against the specification, in any stage and whatever their verdict. Named by the BRIEF's removal admission only, which the briefing service asks before a brief edit drops a format: a brief edit never takes a file — the rows go by Delete format on the upload or delivery page. The REMOVE check never names it. */
  HoldsRows = 'HOLDS_ROWS',
  /** The format holds live deliverable rows, drafts included, and its concept is not in production. One obstacle with two ways out: moving the concept to production clears it, and so does deleting the format's files. */
  HoldsRowsOutsideProduction = 'HOLDS_ROWS_OUTSIDE_PRODUCTION',
  /** Another live specification of the concept has the same format identity (the format was added again since it was removed): restoring this one would duplicate it. */
  IdentityTaken = 'IDENTITY_TAKEN',
  /** The specification is not archived: there is nothing to restore. The RESTORE check's answer for a live specification. */
  NotArchived = 'NOT_ARCHIVED'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * declares DeliverableSpecification with `viewerOperationChecks`); this
 * subgraph contributes the `validation` leg — the specification service's
 * own admissions, each the ONE predicate its door reads too: the removal
 * admission for REMOVE (the RemoveDeliverableSpecification command's apply),
 * the restore door's for RESTORE — and the blockers disclosure. Its resolvable
 * key is the sanctioned hop for the domain half of the two-leg check.
 */
export type DeliverableSpecificationOperationCheck = {
  __typename?: 'DeliverableSpecificationOperationCheck';
  authorization: ActionCheckResult;
  /**
   * Present only when a fact refuses the operation; empty when validation
   * passes and when no fact is disclosed — no specification has the key, the
   * viewer may not act on it, or a fact could not be read. Lets a page render
   * the item disabled-with-reason instead of hidden, without owning any of the
   * rule.
   */
  blockers: Array<DeliverableSpecificationOperationBlocker>;
  operation: DeliverableSpecificationOperation;
  specificationKey: Scalars['ID']['output'];
  /**
   * Pure domain leg, caller-blind: does the specification's CURRENT state
   * admit the operation, read from this service's own rows (and, for REMOVE,
   * the deliverable owner's rows per concept). A specification the read
   * cannot resolve fails closed to not-admitted.
   */
  validation: ActionCheckResult;
};

export enum DeliverableSpecificationProgressStatus {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED'
}

/**
 * The sender's record of a specification removal — the shape
 * `Deliverable.placement` already has, for a slot instead of a row.
 */
export type DeliverableSpecificationRemoval = {
  __typename?: 'DeliverableSpecificationRemoval';
  /**
   * The removal attempt the save minted — the `attempt_key` of the
   * RemoveDeliverableSpecificationCommand it staged; null when no save
   * asked.
   */
  attemptKey?: Maybe<Scalars['ID']['output']>;
  /**
   * Convergence disclosure of the read that produced this record against
   * the `atLeast` token it was given (D-PL-A): `fenced` when a token was
   * verified and evaluated, `converged` when every attempt the token
   * promises was answered before the record was read, else the promise's
   * entry in `uncovered`. The constant no-claim meta (`fenced: false`) when
   * no token was presented or it could not be verified.
   */
  convergence: ConvergenceMeta;
  /** Which answer the newest attempt holds. */
  outcome: DeliverableSpecificationRemovalOutcome;
  /**
   * The specification service's own reason when it refused the newest
   * attempt; null otherwise. UNKNOWN renders a reason this graph does not
   * spell — the refusal stands, the reason is colour.
   */
  refusalReason?: Maybe<DeliverableSpecificationRemovalRefusalReason>;
};

export enum DeliverableSpecificationRemovalOutcome {
  /** No save ever asked to remove the specification. */
  None = 'NONE',
  /** The newest attempt awaits the specification service's answer. */
  Pending = 'PENDING',
  /** The specification service refused the newest attempt; `refusalReason` says why. */
  Refused = 'REFUSED',
  /** The specification service archived the slot. */
  Removed = 'REMOVED'
}

/**
 * Why a removal was refused: the specification service's own reason, and every
 * obstacle the caller can clear and ask again about. `blockers` is empty when
 * nothing the caller does clears the refusal (`UNKNOWN`).
 */
export type DeliverableSpecificationRemovalRefusal = {
  __typename?: 'DeliverableSpecificationRemovalRefusal';
  blockers: Array<DeliverableSpecificationOperationBlocker>;
  reason: DeliverableSpecificationRemovalRefusalReason;
};

/** The specification service's own refusal vocabulary for removals, recorded verbatim and never branched on by the sender. */
export enum DeliverableSpecificationRemovalRefusalReason {
  /** The attempt key is ledgered for another specification. */
  AttemptConflict = 'ATTEMPT_CONFLICT',
  /** The concept is archived; nothing under it is written. */
  ConceptArchived = 'CONCEPT_ARCHIVED',
  /** Declared for a refusal of a delivered slot. The specification service's admission does not refuse on delivery, so no refusal it answers carries this reason. */
  Delivered = 'DELIVERED',
  /** A deliverable row was landing on the slot — a placement the specification service had answered with it whose reply the deliverable service had not applied yet. (Until phase 2 of the removal it named any row against the slot, removed versions included; a record from then reads the same value.) */
  HasDeliverables = 'HAS_DELIVERABLES',
  /** The slot held live deliverable rows, drafts included, and its concept was not in production: moving the concept to production, or deleting the slot's files, clears it. */
  HoldsRowsOutsideProduction = 'HOLDS_ROWS_OUTSIDE_PRODUCTION',
  /** No specification exists under the coordinates the command named. */
  NotFound = 'NOT_FOUND',
  /** The caller was refused concept:write on the concept at apply. */
  NotPermitted = 'NOT_PERMITTED',
  /** A currently authorized operator cancelled the retained request without applying it. */
  OperatorCancelled = 'OPERATOR_CANCELLED',
  /** A reason this graph does not spell, or a refusal recorded before its reason was. */
  Unknown = 'UNKNOWN'
}

/** Why a restore was refused: the specification service's own reason. */
export type DeliverableSpecificationRestoreRefusal = {
  __typename?: 'DeliverableSpecificationRestoreRefusal';
  reason: DeliverableSpecificationRestoreRefusalReason;
};

/** The specification service's refusal vocabulary for restores. */
export enum DeliverableSpecificationRestoreRefusalReason {
  /** The concept is archived; nothing under it is written. */
  ConceptArchived = 'CONCEPT_ARCHIVED',
  /** Another live specification of the concept has the same format identity (the format was added again since it was removed): restoring this one would duplicate it. */
  IdentityTaken = 'IDENTITY_TAKEN',
  /** The specification is not archived: there is nothing to restore. */
  NotArchived = 'NOT_ARCHIVED'
}

export type DeliverableSpecifications = {
  __typename?: 'DeliverableSpecifications';
  meta: OffsetPageInfo;
  nodes: Array<DeliverableSpecification>;
};

export type DeliverableSpecificationsFilter = {
  /**
   * The specifications served by archive state: the live ones (FALSE, the
   * default), the archived ones (TRUE), or both (INCLUDE). An archived
   * specification reads `progressStatus` ARCHIVED and carries its
   * `archivedAt`.
   */
  includeArchived?: InputMaybe<ArchivedFilter>;
  isHero?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<IdFilter>;
};

export type DeliverableSpecificationsParams = {
  filter?: InputMaybe<DeliverableSpecificationsFilter>;
  pagination?: InputMaybe<OffsetPagination>;
};

/**
 * The verdict position of a deliverable — the one mutually exclusive axis of
 * its lifecycle (docs/deliverable-status-seam/SCOPE.md): awaiting a verdict,
 * changes requested, approved. The audience reached is
 * `hasReachedReviewStage`; replacement is a relation derived per viewer.
 */
export enum DeliverableVerdict {
  /** Approved. */
  Approved = 'APPROVED',
  /** A verdict of changes requested; remediation is a new version. */
  ChangesRequested = 'CHANGES_REQUESTED',
  /** Delivered and awaiting a verdict, whichever audience has reached it. */
  InReview = 'IN_REVIEW'
}

export type Deliverables = {
  __typename?: 'Deliverables';
  /**
   * Convergence disclosure of the read that produced this page against the
   * `atLeast` token it was given (D-PL-A): `fenced` when a token was
   * verified and evaluated, `converged` when every placement the token
   * promises was answered before the rows were read, else the promise's
   * entry in `uncovered`. The constant no-claim meta (`fenced: false`) when
   * no token was presented, when it could not be verified, or on a read
   * surface that is not fence-capable yet (`Project.deliverables`).
   */
  convergence: ConvergenceMeta;
  meta: OffsetPageInfo;
  nodes: Array<Deliverable>;
};

/** The plan-scoped deliverables collection behind Query.deliverables. */
export type DeliverablesCollection = {
  __typename?: 'DeliverablesCollection';
  /**
   * Facet option lists for the collection. Selection-driven: no
   * aggregation work runs unless selected. `mode` controls option
   * membership; absent = BROAD (the shipped filter-panel semantics). One
   * mode per query: aliased facets selections under different modes fail
   * with a bad-request error.
   */
  facets: DeliverablesFacets;
  meta: DeliverablesCollectionMeta;
  /** The matched deliverables in the fixed order. Computed only when selected. */
  nodes: Array<Deliverable>;
};


/** The plan-scoped deliverables collection behind Query.deliverables. */
export type DeliverablesCollectionFacetsArgs = {
  mode?: InputMaybe<DeliverablesFacetMode>;
};

/**
 * The collection predicate vocabulary. Values within one list OR, distinct
 * fields AND. Archived deliverables are excluded unconditionally — archival
 * is a baseline invariant, not a filter dimension. There is no hidden verdict
 * default: the retired template excluded replaced versions when its status
 * exclusion was absent, this contract does not — `latestVersionOnly` reads
 * each lineage's latest version.
 */
export type DeliverablesCollectionFilter = {
  conceptNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Format length facet values (the FormatLength spellings, e.g. LESS_15S). */
  formatLengths?: InputMaybe<Array<Scalars['String']['input']>>;
  formatNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Revision-carriage predicate: `true` selects deliverables carrying at least
   * one revision (deliverable-level or concept-level rounds), `false` selects
   * those carrying none — a `has_revisions:false` term, not "no predicate".
   * Omit the field for no predicate.
   */
  hasRevisions?: InputMaybe<Scalars['Boolean']['input']>;
  languageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Only each lineage's latest version, composed per authorization lane: a
   * review-stage-fenced lane follows the lineage's reviewed head (the
   * newest version that has reached the review stage); every other lane,
   * and an unrestricted plan, follows its overall head. Lane conditions
   * conjoin with the lane's head ("latest AND approved", never "latest
   * among approved"), so a caller may reach the overall head, the reviewed
   * head, both, or neither, purely per their grants. Which head applies is
   * plan-derived and never caller-addressable beyond this boolean — "latest
   * I can view" is computed per query, not a document property.
   */
  latestVersionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  platformNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The project whose deliverables are read. Required — the collection is project-fenced. */
  projectKey: Scalars['ID']['input'];
  /** Deliverable type facet values — the closed vocabulary HERO, UNIT, ADDITIONAL_FORMAT, VARIATION. */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Variation name facet values (a root concept's deliverables carry the label `Original creative`). */
  variationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Verdict membership predicate (docs/deliverable-status-seam/SCOPE.md,
   * Train A): values OR, against each deliverable's own `verdict` — so a
   * version stored superseded is selected by IN_REVIEW, or by
   * CHANGES_REQUESTED while it holds an open corrective request (D-B0-1-C
   * (a)). Conjoins with every other field.
   */
  verdicts?: InputMaybe<Array<DeliverableVerdict>>;
};

export type DeliverablesCollectionMeta = {
  __typename?: 'DeliverablesCollectionMeta';
  /** Exact total of matching deliverables. Computed only when selected. */
  recordCount: Scalars['Int']['output'];
};

export type DeliverablesCollectionParams = {
  filter: DeliverablesCollectionFilter;
  /**
   * Page size. Server default and hard cap 1000 (a bad-request error
   * beyond the cap) — ample for the project-fenced corpus; the collection
   * is single-page by contract.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** One facet's option list plus the completeness signal. */
export type DeliverablesFacet = {
  __typename?: 'DeliverablesFacet';
  /**
   * True when `options` holds every distinct value for this facet under the
   * query that produced it; false when the list was truncated at the server
   * cap. Clients derive their option-search behaviour from this.
   */
  isComplete: Scalars['Boolean']['output'];
  options: Array<DeliverablesFacetOption>;
};

/**
 * Facet option membership. BROAD (the absent default): options computed over
 * the viewer-scoped BASELINE corpus — the project and latestVersionOnly — with
 * active facet selections ignored, matching the retired aggregation template. REACTIVE: disjunctive faceting — each facet's
 * options are computed under every active filter except that facet's own
 * selections, so every option shown has at least one match under everything
 * else selected.
 */
export enum DeliverablesFacetMode {
  Broad = 'BROAD',
  Reactive = 'REACTIVE'
}

export type DeliverablesFacetOption = {
  __typename?: 'DeliverablesFacetOption';
  /**
   * Number of visible deliverables carrying this value under the facet's
   * membership mode. Null means "no count available", never zero.
   */
  count?: Maybe<Scalars['Int']['output']>;
  /** The facet value. */
  value: Scalars['String']['output'];
};

/**
 * Facet option lists over the deliverables collection. Membership follows
 * the facets(mode:) argument. Only values carried by at least one visible
 * in-corpus deliverable appear; value lists are ascending and capped
 * server-side.
 */
export type DeliverablesFacets = {
  __typename?: 'DeliverablesFacets';
  conceptNames: DeliverablesFacet;
  formatLengths: DeliverablesFacet;
  formatNames: DeliverablesFacet;
  languageNames: DeliverablesFacet;
  platformNames: DeliverablesFacet;
  /**
   * The fixed review rollup: READY_TO_REVIEW (a verdict of IN_REVIEW or
   * CHANGES_REQUESTED), APPROVED (a verdict of APPROVED), HAS_REVISIONS.
   * Options appear only with at least one match.
   */
  reviewStatuses: DeliverablesFacet;
  types: DeliverablesFacet;
  variationNames: DeliverablesFacet;
  /**
   * The verdict rollup (docs/deliverable-status-seam/SCOPE.md, Train A):
   * IN_REVIEW, CHANGES_REQUESTED, APPROVED — the values
   * `filter.verdicts` takes, in that fixed order. Options appear only with
   * at least one match.
   */
  verdicts: DeliverablesFacet;
};

export type DeliverablesFilter = {
  /** Restrict to deliverables of the given concepts (variations carry their own concept key). */
  conceptKey?: InputMaybe<IdFilter>;
  key?: InputMaybe<IdFilter>;
  /**
   * Restrict to each specification's current version for the viewer: the head
   * `Deliverable.isHead` and `DeliverableSpecification.deliverable` elect — the
   * newest unarchived delivered version among the rows the caller's plan
   * admits (a version stored superseded never qualifies) —
   * elected in the answering statement, so two viewers whose plans admit
   * different versions are answered different heads (docs/deliverable-status-
   * seam/SCOPE.md, Train B-0 step 1). Composes with the other members as an
   * AND on the elected head: `verdicts` and `key` narrow the heads, never
   * elect among the rows that match them — a key naming a version its slot's
   * head outranks selects nothing. A row placed against no specification has
   * no lineage to head and is never selected. Omitted or false: every
   * version.
   */
  latestOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restrict to deliverables whose placement outcome is one of the given
   * values (values OR). A row still awaiting placement — one whose current
   * attempt is unanswered or was refused, and which holds no specification —
   * is served by no read that does not name its outcome here
   * (docs/deliverable-status-seam/SCOPE.md, D-B0-6-D (a)): the upload page
   * names PENDING to show a row its save just parked, and REFUSED to ask
   * again for one the specification service refused. Omitted: every placed
   * row, no row awaiting placement. Under `latestOnly` it narrows the elected
   * heads and never elects: a slot whose head the processing task placed
   * under an attempt still unanswered answers that head to PENDING and
   * nothing to PLACED.
   */
  placementOutcomes?: InputMaybe<Array<DeliverablePlacementOutcome>>;
  /** Restrict to deliverables of the given specifications. */
  specificationKey?: InputMaybe<IdFilter>;
  /**
   * Restrict to deliverables whose verdict is one of the given values (values
   * OR; docs/deliverable-status-seam/SCOPE.md, Train A): the value each row's
   * `verdict` answers, so a version stored superseded is selected by
   * IN_REVIEW, or by CHANGES_REQUESTED while it holds an open corrective
   * request (D-B0-1-C (a)).
   */
  verdicts?: InputMaybe<Array<DeliverableVerdict>>;
};

export type DeliverablesParams = {
  filter?: InputMaybe<DeliverablesFilter>;
  pagination?: InputMaybe<OffsetPagination>;
};

export type Dimension = {
  __typename?: 'Dimension';
  /** @deprecated Use deliverable_format.is_custom instead */
  custom: Scalars['Boolean']['output'];
  height: Scalars['Float']['output'];
  humanizedRatio: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  ratio: Scalars['Float']['output'];
  unit: MeasurementUnit;
  width: Scalars['Float']['output'];
};

export type DimensionInput = {
  custom: Scalars['Boolean']['input'];
  height: Scalars['Float']['input'];
  unit: MeasurementUnit;
  width: Scalars['Float']['input'];
};

export type Dimensions = {
  __typename?: 'Dimensions';
  nodes: Array<Dimension>;
};

export type DiscardOrderInput = {
  order: OrderDiscardInput;
};

export type DiscardWorkingFileInput = {
  key: Scalars['ID']['input'];
};

export type DuplicateConceptV2Input = {
  /** The key of the concept to duplicate. */
  key: Scalars['ID']['input'];
};

export type DuplicateProjectV2Input = {
  /**
   * Organizational unit key of the brand to associate the new project with.
   * This destination brand must be explicit for duplicate consistency.
   *
   * When `copyAnswers` is true, the brand must belong to the same organization as the original brand.
   */
  brandOrganizationalUnitKey: Scalars['ID']['input'];
  /**
   * Flag indicating whether briefed assets and answers should be copied or not.
   *
   * When false, only the number of concepts and the formats ordered for each concept will be copied.
   *
   * When true, a like-for-like copy of the project will be created, including all concepts
   * along with their names and any briefed assets and answers.
   */
  copyAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key of the project to duplicate. */
  key: Scalars['ID']['input'];
  /**
   * Name to use for the new project.
   *
   * Defaults to "Copy of ..." when `copyAnswers` is true, otherwise defaults to "Untitled Project".
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Organizational unit key to scope the duplicated project.
   * This destination scope must be explicit for duplicate authorization.
   */
  organizationalUnitKey: Scalars['ID']['input'];
};

/** Input for editing an existing revision comment. */
export type EditCommentInput = {
  /** Comment ID of the comment to be updated. */
  id: Scalars['ID']['input'];
  /** The body text of the comment. */
  message: Scalars['String']['input'];
  /** Visibility tier of the comment. */
  visibility: RevisionCommentVisibility;
};

/** Result of `editComment`. */
export type EditCommentPayload = {
  __typename?: 'EditCommentPayload';
  /** The edited comment. */
  comment: Comment;
  /**
   * The revisions whose rendered comment threads carry the comment, in
   * creation order. Members the viewer may not read are omitted; null when
   * no affected members remain for the viewer — whether none exist or none
   * are readable.
   */
  revisions?: Maybe<Array<Revision>>;
  /**
   * Opaque authenticated write-token for this edit's committed write — the
   * same contract, mint provenance, and null semantics as
   * `AddCommentPayload.writeToken`. The edit is the mutation that MOVES
   * the projected fact fenced reads derive from (a limited↔everyone
   * re-tier changes `Comment.viewerOperationChecks` answers), so this
   * token is the re-reading editor's causal anchor over the row's
   * post-increment version
   * (docs/state-distribution/rywf-fence-pilot/SCOPE.md, the edit-arm
   * reshape).
   */
  writeToken?: Maybe<Scalars['String']['output']>;
};

export type EditRevisionInput = {
  addAnnotations?: InputMaybe<Array<AnnotationInput>>;
  addAttachments?: InputMaybe<Array<AttachmentInput>>;
  appliesToConcept: Scalars['Boolean']['input'];
  category: RevisionCategory;
  comment: Scalars['String']['input'];
  hasAnnotation: Scalars['Boolean']['input'];
  /** @deprecated Will be ignored. To be removed in a future release. */
  hasFullFrame?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Will be ignored. To be removed in a future release. */
  hasThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  removeAttachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  subCategory?: InputMaybe<RevisionSubCategory>;
  /** Apply revision on a video format to a specific point in time. Also used to track the primary frame for annotations. */
  timestamp?: InputMaybe<Scalars['Float']['input']>;
  /** End point in time for applying a time range to a revision. */
  timestampEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Starting point in time for applying a time range to a revision. */
  timestampStart?: InputMaybe<Scalars['Float']['input']>;
  /** Type of the timestamp that is applied to a revision. */
  timestampType: TimestampType;
};

export type EncodedString = {
  data: Scalars['String']['input'];
  encoding: StringEncoding;
};

export type EnsureDeliverableSpecificationInput = {
  conceptKey: Scalars['ID']['input'];
  dimension: DimensionInput;
  formatKey: Scalars['ID']['input'];
  formatLength: FormatLength;
  formatName: Scalars['String']['input'];
  heroPriority?: InputMaybe<Scalars['Int']['input']>;
  isHero: Scalars['Boolean']['input'];
  languageCode: Scalars['String']['input'];
  localeKey?: InputMaybe<Scalars['ID']['input']>;
  platformCode: Scalars['String']['input'];
  platformName: Scalars['String']['input'];
  unitNumber: Scalars['Int']['input'];
  variantKey: Scalars['ID']['input'];
};

export type EnsureDeliverableSpecificationsInput = {
  specifications: Array<EnsureDeliverableSpecificationInput>;
};

export type EnsureDeliverableSpecificationsPayload = {
  __typename?: 'EnsureDeliverableSpecificationsPayload';
  specifications: Array<DeliverableSpecification>;
};

export type EnsurePrincipalInput = {
  auth0UserId: Scalars['String']['input'];
  kind: PrincipalKind;
  user?: InputMaybe<EnsureUserPrincipalInput>;
};

export type EnsurePrincipalPayload = {
  __typename?: 'EnsurePrincipalPayload';
  principal: Principal;
  tenancy: Tenancy;
  user?: Maybe<User>;
};

export type EnsureUserPrincipalInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
};

/** Possible error codes returned by APIs. */
export enum ErrorCode {
  /** Record has already been processed. */
  AlreadyProcessed = 'ALREADY_PROCESSED',
  /** Has been archived. */
  Archived = 'ARCHIVED',
  /** Duplicate record found. */
  Duplicate = 'DUPLICATE',
  /** An argument was invalid (e.g. failed validation etc.). */
  InvalidArgument = 'INVALID_ARGUMENT',
  /** Data was in an invalid state. */
  InvalidState = 'INVALID_STATE',
  /** Client was not authorised to perform this action. */
  NotAuthorised = 'NOT_AUTHORISED',
  /** No record found. */
  NotFound = 'NOT_FOUND',
  /** Client was not authorised to perform this action. */
  Unauthorised = 'UNAUTHORISED',
  /** Unhandled error. */
  Unhandled = 'UNHANDLED',
  /** Unknown error. */
  Unknown = 'UNKNOWN',
  /** Business/domain validation failed. */
  Validation = 'VALIDATION',
  /** Dimension ratio is not unique. */
  DimensionRatioNotUnique = 'dimension_ratio_not_unique',
  /** User does not match. */
  UserNotMatch = 'user_not_match'
}

/**
 * The concept has deliverables, and this transition requires it to have none.
 * Archived deliverables do not count.
 */
export type ExistingDeliverablesBlocker = WorkflowTransitionBlocker & {
  __typename?: 'ExistingDeliverablesBlocker';
  /** How many current deliverables the concept has (the latest version of each, excluding archived ones). */
  deliverables: Scalars['Int']['output'];
  reason: WorkflowTransitionBlockedReason;
};

/** Centralized entity stub for File. */
export type File = {
  __typename?: 'File';
  contentType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use contentType instead */
  extension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  key: Scalars['ID']['output'];
  /** @deprecated Use previews(params: ...) and request a single result instead. */
  preview?: Maybe<FilePreview>;
  /** Resolve preview artifacts for this file. */
  previews: FilePreviewConnection;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key: Scalars['String']['output'];
  /** @deprecated Use s3Key instead */
  s3Path: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
  /** Returns the total number of indexed units for the file when applicable. */
  totalUnits?: Maybe<Scalars['Int']['output']>;
  /** The unit used for indexing the file when applicable. Null when the file is not meaningfully indexable. */
  unit?: Maybe<FileIndexingUnit>;
  uploadedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};


/** Centralized entity stub for File. */
export type FilePreviewArgs = {
  options?: InputMaybe<FilePreviewOptions>;
};


/** Centralized entity stub for File. */
export type FilePreviewsArgs = {
  params: FilePreviewsParams;
};

export type FileGoverningResourceInput = {
  key: Scalars['ID']['input'];
  kind: FileGoverningResourceKind;
};

export enum FileGoverningResourceKind {
  Concept = 'CONCEPT',
  Creator = 'CREATOR',
  Organization = 'ORGANIZATION',
  Project = 'PROJECT',
  UgcOrder = 'UGC_ORDER'
}

export enum FileIndexingUnit {
  /** A frame index for frame-addressable media. */
  Frame = 'FRAME',
  /** For use in temporal media when the client does not know the fps. */
  Millisecond = 'MILLISECOND',
  /** The default zero-based indexing unit for the file. */
  Native = 'NATIVE',
  /** A page index for page-addressable files. */
  Page = 'PAGE'
}

export type FilePreview = {
  __typename?: 'FilePreview';
  /** The resulting content/mime type of the transformed file */
  contentType: Scalars['String']['output'];
  /**
   * The zero-based starting index represented by this preview relative to the original file,
   * using the same unit as the request. For example, a preview for units 2-4 returns 2.
   * Null when the preview was not derived from an indexed source.
   */
  currentIndex?: Maybe<Scalars['Int']['output']>;
  /**
   * The frame rate of the returned preview when relevant to temporal media. Null for
   * content types where playback rate has no meaning.
   */
  fps?: Maybe<Scalars['Float']['output']>;
  /** The height of the transformed file when available */
  height?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of indexed units contained in the returned preview artifact.
   * For example, a single-unit preview returns 1 and a three-unit preview returns 3.
   * Null when the preview is not meaningfully indexable, such as a standalone image.
   */
  totalUnits?: Maybe<Scalars['Int']['output']>;
  /** The unit used for indexing the preview when applicable. Null when the preview is not meaningfully indexable. */
  unit?: Maybe<FileIndexingUnit>;
  /** The URL to the transformed file */
  url: Scalars['String']['output'];
  /** The width of the transformed file when available */
  width?: Maybe<Scalars['Int']['output']>;
};

export type FilePreviewConnection = {
  __typename?: 'FilePreviewConnection';
  nodes: Array<FilePreview>;
  pageInfo: OffsetPageInfo;
};

/** Request the first valid preview matching the supplied output priority list. */
export type FilePreviewOptions = {
  /**
   * Limit the file type(s) of the preview to those supported by your platform, or a
   * specific type (i.e. passing only IMAGE_PNG to get PNG thumbnail urls).
   */
  accept?: InputMaybe<Array<FilePreviewType>>;
  /**
   * The desired height of the preview.
   * Can be omitted to retain the original height (or aspect ratio if width is provided)
   * @deprecated Use quality instead
   */
  height?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The desired quality of the preview, defaults to UNSCALED.
   * If the quality is not supported for given file and accept param, then a preview will not be returned.
   */
  quality?: InputMaybe<FilePreviewPreset>;
  /**
   * Optimise the preview for use as a thumbnail
   * @deprecated Use quality instead
   */
  thumbnail?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The desired width of the preview.
   * Can be omitted to retain the original width (or aspect ratio if height is provided)
   * @deprecated Use quality instead
   */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum FilePreviewPreset {
  Scaled_240P = 'SCALED_240P',
  Unscaled = 'UNSCALED'
}

/**
 * Indexed selection relative to the original file. Omit maxUnits to select from startIndex
 * through the end of the file.
 */
export type FilePreviewSelectionInput = {
  /**
   * The maximum number of source units to include in the selection.
   * Omit to continue the selection through the end of the file.
   */
  maxUnits?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The zero-based index of the first unit to include from the source file.
   * Omit to begin at the start of the file.
   */
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Slice the selected region into sequential preview requests.
 * A final partial slice may be returned when the remaining units are fewer than unitsPerSlice.
 */
export type FilePreviewSlicesInput = {
  /**
   * The number of indexed units to skip between the end of one slice and the start of
   * the next slice. Defaults to 0 for adjacent slices.
   */
  gapUnits?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The maximum number of slices to create from the selection.
   * Omit to continue slicing until the selected region is exhausted.
   */
  maxSlices?: InputMaybe<Scalars['Int']['input']>;
  /** The number of indexed units to include in each generated slice. */
  unitsPerSlice: Scalars['Int']['input'];
};

export enum FilePreviewType {
  AudioMp3 = 'AUDIO_MP3',
  ImageGif = 'IMAGE_GIF',
  ImageJpeg = 'IMAGE_JPEG',
  ImagePng = 'IMAGE_PNG',
  ImageSvg = 'IMAGE_SVG',
  ImageWebp = 'IMAGE_WEBP',
  Pdf = 'PDF',
  VideoMov = 'VIDEO_MOV',
  VideoMp4 = 'VIDEO_MP4',
  Zip = 'ZIP'
}

/** Request preview artifacts matching the supplied output priority list. */
export type FilePreviewsOptions = {
  /** Ordered list of acceptable output targets. Each returned preview uses the first valid target. */
  accept?: InputMaybe<Array<FilePreviewType>>;
  /**
   * The desired quality of the preview, defaults to UNSCALED.
   * If the quality is not supported for given file and accept param, then a preview will not be returned.
   */
  quality?: InputMaybe<FilePreviewPreset>;
  /**
   * Select an indexed subsection of the source file to transform or extract.
   * Omit to transform/extract the entire file.
   * Use maxUnits: 1 when requesting a single indexed unit such as one page or one video frame.
   */
  selection?: InputMaybe<FilePreviewSelectionInput>;
  /**
   * Defines how to divide the selection into multiple preview artifacts.
   * When omitted, at most one preview for the selected region is returned.
   */
  slices?: InputMaybe<FilePreviewSlicesInput>;
  /**
   * The unit used to interpret selection and slicing values. Defaults to NATIVE.
   * Requests using a unit the file does not support return no previews.
   */
  unit?: InputMaybe<FileIndexingUnit>;
};

/** Parameters for requesting preview artifacts for a file. */
export type FilePreviewsParams = {
  options: FilePreviewsOptions;
  pagination?: InputMaybe<OffsetPagination>;
};

export type FormatInput = {
  dimension: DimensionInput;
  formatKey: Scalars['ID']['input'];
  formatLengths: Array<FormatLength>;
  formatName: Scalars['String']['input'];
  platform: PlatformInput;
};

export enum FormatLength {
  Animated = 'ANIMATED',
  Custom = 'CUSTOM',
  Less_6S = 'LESS_6S',
  Less_10S = 'LESS_10S',
  Less_15S = 'LESS_15S',
  Less_30S = 'LESS_30S',
  Static = 'STATIC'
}

/** Gender (i.e. of a creator). */
export type Gender = {
  __typename?: 'Gender';
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** Human readable label for this gender. */
  label: Scalars['String']['output'];
};

export enum GenderPreference {
  Female = 'Female',
  Male = 'Male',
  Unspecified = 'Unspecified'
}

export enum GenerativeAiCategory {
  Image = 'IMAGE',
  Music = 'MUSIC',
  Video = 'VIDEO',
  Voice = 'VOICE'
}

export type GenerativeAiModel = {
  __typename?: 'GenerativeAIModel';
  /**  Code of the generative AI model.  */
  code: Scalars['String']['output'];
  /**  Whether this generative AI model is the default in its category.  */
  default: Scalars['Boolean']['output'];
  /**  Icon which the generative AI model is to be identified with.  */
  iconUrl: Scalars['String']['output'];
  /**  Name of the generative AI model.  */
  name: Scalars['String']['output'];
  /**  Terms and conditions for the generative AI model.  */
  termsUrl: Scalars['String']['output'];
};

export type GenerativeAiModelOptions = {
  __typename?: 'GenerativeAIModelOptions';
  category: GenerativeAiCategory;
  models: Array<GenerativeAiModel>;
};

export type GenerativeAiPreference = {
  __typename?: 'GenerativeAIPreference';
  /**  Type of category generative AI is to be used for.  */
  category: GenerativeAiCategory;
  /**  The generative AI models that are to be used.  */
  models: Array<GenerativeAiModel>;
  /**  Usage notes for the creative team.  */
  notes?: Maybe<Scalars['String']['output']>;
};

export type GenerativeEditResult = {
  __typename?: 'GenerativeEditResult';
  attachment?: Maybe<File>;
  file?: Maybe<File>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['ID']['output'];
  prompt: Scalars['String']['output'];
  status: GenerativeEditResultStatus;
};

export enum GenerativeEditResultStatus {
  Error = 'Error',
  Pending = 'Pending',
  Success = 'Success'
}

export type GenerativeEditResultsForDeliverableInput = {
  deliverableKey: Scalars['ID']['input'];
};

export type GenerativeSpecificationRecord = {
  __typename?: 'GenerativeSpecificationRecord';
  deliverableKey?: Maybe<Scalars['ID']['output']>;
  generativeEditKey: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  projectKey: Scalars['ID']['output'];
  specificationKey: Scalars['ID']['output'];
  status: GenerativeSpecificationRecordStatus;
};

export enum GenerativeSpecificationRecordStatus {
  Error = 'Error',
  Pending = 'Pending',
  Success = 'Success'
}

/** Roles to apply at a scope for a principal. */
export type GrantAssignmentInput = {
  roleKeys: Array<Scalars['ID']['input']>;
  scope: GrantScopeInput;
};

export type GrantMutation = {
  __typename?: 'GrantMutation';
  /** Grant a role to a principal at the provided scope. */
  grantRoleToPrincipal: PrincipalGrant;
  /** Plan role assignments for an invitation. */
  planInvitationGrants: Scalars['Boolean']['output'];
  /** Revoke a role from a principal within the provided scope. */
  revokeRoleFromPrincipal: Scalars['Boolean']['output'];
  /**
   * Replace the principal's roles at the provided scope with the supplied set and
   * return the resulting grants.
   */
  setPrincipalRoles: Array<PrincipalGrant>;
};


export type GrantMutationGrantRoleToPrincipalArgs = {
  input: GrantRoleInput;
};


export type GrantMutationPlanInvitationGrantsArgs = {
  input: PlanInvitationGrantsInput;
};


export type GrantMutationRevokeRoleFromPrincipalArgs = {
  input: RevokeRoleInput;
};


export type GrantMutationSetPrincipalRolesArgs = {
  input: SetPrincipalRolesInput;
};

export type GrantQuery = {
  __typename?: 'GrantQuery';
  /** List grants for a principal. Optionally filter by one or more scopes. */
  grantsByPrincipal: PrincipalGrantConnection;
  /** List grants anchored at a specific scope. Optionally filter by principals. */
  grantsByScope: PrincipalGrantConnection;
};


export type GrantQueryGrantsByPrincipalArgs = {
  atScopes?: InputMaybe<Array<GrantScopeInput>>;
  pagination?: InputMaybe<OffsetPagination>;
  principalKey: Scalars['ID']['input'];
  statuses?: InputMaybe<Array<GrantStatus>>;
};


export type GrantQueryGrantsByScopeArgs = {
  forPrincipals?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<OffsetPagination>;
  selector: GrantScopeSelector;
  statuses?: InputMaybe<Array<GrantStatus>>;
};

/** Mutation payload for grantRoleToPrincipal. */
export type GrantRoleInput = {
  principalKey: Scalars['ID']['input'];
  roleKey: Scalars['ID']['input'];
  scope: GrantScopeInput;
};

/** Scope anchor supplied when assigning or planning grants. */
export type GrantScopeInput = {
  kind: GrantScopeKind;
  scopeKey?: InputMaybe<Scalars['ID']['input']>;
};

/** Kinds of scopes grants can target. */
export enum GrantScopeKind {
  Concept = 'concept',
  Creator = 'creator',
  OrganizationalUnit = 'organizational_unit',
  Tenancy = 'tenancy',
  UgcOrder = 'ugc_order'
}

/** Current role-authoring and grant-assignment availability for a grant scope kind. */
export type GrantScopeKindMetadata = {
  __typename?: 'GrantScopeKindMetadata';
  grantAssignable: Scalars['Boolean']['output'];
  kind: GrantScopeKind;
  label: Scalars['String']['output'];
  roleConfigurable: Scalars['Boolean']['output'];
};

/** Selector used when querying for grants at a scope. */
export type GrantScopeSelector = {
  includeDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  scope: GrantScopeInput;
};

export enum GrantSource {
  CreatorProfile = 'CREATOR_PROFILE',
  DirectAssignment = 'DIRECT_ASSIGNMENT',
  Invitation = 'INVITATION',
  UgcOffer = 'UGC_OFFER',
  UgcOfferAudience = 'UGC_OFFER_AUDIENCE'
}

export enum GrantStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED',
  Superseded = 'SUPERSEDED'
}

export type GrantTenant = {
  __typename?: 'GrantTenant';
  key: Scalars['ID']['output'];
};

/** A HubSpot deal. */
export type HubspotDeal = {
  __typename?: 'HubspotDeal';
  /** The amount of the deal in the currency of the deal. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The close date of the deal, this is set at a date level of granularity. */
  closeDate: Scalars['Time']['output'];
  /** The code of the currency of the deal, e.g. NZD. */
  currencyCode: Scalars['String']['output'];
  /** The ID of the deal in HubSpot. */
  id: Scalars['String']['output'];
  /** The name of the deal. */
  name: Scalars['String']['output'];
  /** The URL of the deal in HubSpot. */
  url?: Maybe<Scalars['String']['output']>;
};

/** The HubSpot deal selection for a project. */
export type HubspotDealSelection = HubspotDeal | NoHubspotDeal;

export type IdArrayFilter = {
  /** return match if all the provided values match */
  all?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** return match if any of the provided values on the record */
  any?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IdFilter = {
  /** return match if the provided value matches the record */
  eq?: InputMaybe<Scalars['ID']['input']>;
  /** return match if record in provided values */
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IdentityRegistrationPayload = {
  __typename?: 'IdentityRegistrationPayload';
  principal?: Maybe<Principal>;
  principalAllocationEnabled: Scalars['Boolean']['output'];
  tenancy: Tenancy;
  user?: Maybe<User>;
};

/** Local/effective values plus inheritance metadata for a boolean. */
export type InheritedBool = {
  __typename?: 'InheritedBool';
  effective: Scalars['Boolean']['output'];
  inherited: Scalars['Boolean']['output'];
  local?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<OrganizationalUnit>;
};

/** Local/effective values plus inheritance metadata for a list of platforms. */
export type InheritedPlatforms = {
  __typename?: 'InheritedPlatforms';
  effective: Array<Platform>;
  inherited: Scalars['Boolean']['output'];
  local?: Maybe<Array<Platform>>;
  source?: Maybe<OrganizationalUnit>;
};

export type IntArrayFilter = {
  /** return match if all the provided values match */
  all?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** return match if any of the provided values on the record */
  any?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  /** The UTC timestamp when the invitation was accepted */
  acceptedAt?: Maybe<Scalars['Time']['output']>;
  /** Who the invitation onboards: a tenancy user or an external creator */
  audience: InvitationAudience;
  /** Claim code used by the end-user invite flow */
  claimCode: Scalars['String']['output'];
  /** The UTC timestamp when the invitation was created */
  createdAt: Scalars['Time']['output'];
  /** Optional email address of an invitee */
  email?: Maybe<Scalars['String']['output']>;
  /** The UTC timestamp when the invitation last emailed */
  emailedAt?: Maybe<Scalars['Time']['output']>;
  /** The UTC timestamp when the invitation expired */
  expiredAt?: Maybe<Scalars['Time']['output']>;
  /** Optional first name of an invitee */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Optional full name of an invitee */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the invitation */
  key: Scalars['String']['output'];
  /** Optional last name of an invitee */
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * Back-compat: the single OU this invite grants access to.
   * Deprecated in favor of authz-service planned grants.
   * @deprecated Use authz-service planned grants
   */
  organizationalUnit?: Maybe<OrganizationalUnit>;
  plannedGrants: Array<PrincipalGrant>;
  /** The UTC timestamp when the invitation was revoked */
  revokedAt?: Maybe<Scalars['Time']['output']>;
  /** The current status of the invitation */
  status: InvitationStatus;
  /** URL to accept the invitation */
  url: Scalars['String']['output'];
};

/**
 * The audience an invitation onboards. USER invitations grant tenancy access
 * at claim; CREATOR invitations only attach the claimant's principal to a
 * creator profile — offers and the profile lifecycle carry the privileges.
 */
export enum InvitationAudience {
  Creator = 'CREATOR',
  User = 'USER'
}

export type InvitationParams = {
  __typename?: 'InvitationParams';
  /** Audience of the invitation: the claim page picks its post-claim landing from it. */
  audience: InvitationAudience;
  loginHint?: Maybe<Scalars['String']['output']>;
  screenHint?: Maybe<Scalars['String']['output']>;
};

export type InvitationScopeInput = {
  kind: InvitationScopeKind;
  scopeKey?: InputMaybe<Scalars['ID']['input']>;
};

export enum InvitationScopeKind {
  Concept = 'CONCEPT',
  OrganizationalUnit = 'ORGANIZATIONAL_UNIT',
  Tenancy = 'TENANCY'
}

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type InvitationStatusFilter = {
  in?: InputMaybe<Array<InvitationStatus>>;
};

export type Invitations = {
  __typename?: 'Invitations';
  meta: OffsetPageInfo;
  nodes: Array<Invitation>;
};

export type InvitationsFilter = {
  key?: InputMaybe<StringFilter>;
  /** Substring search over email and name */
  keyword?: InputMaybe<Scalars['String']['input']>;
  orgUnitKey?: InputMaybe<IdFilter>;
  status?: InputMaybe<InvitationStatusFilter>;
};

export type InvitationsParams = {
  filter?: InputMaybe<InvitationsFilter>;
  pagination?: InputMaybe<OffsetPagination>;
  sort?: InputMaybe<SortInput>;
};

/** A language in SRC's reference set — used for creative language targeting and for the languages a creator speaks. */
export type Language = {
  __typename?: 'Language';
  /** The time this language was archived, or null */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** A foreign key used to uniquely identify this language within SRC */
  code: Scalars['String']['output'];
  /** A (mostly) ISO-639 code used by the Google Translate API (see https://cloud.google.com/translate/docs/languages) */
  googleCode?: Maybe<Scalars['String']['output']>;
  /** A human-readable english name for the language */
  name: Scalars['String']['output'];
};

export type Locale = {
  __typename?: 'Locale';
  /** Integration key to track locales across domains (may be extended later to include 'custom' locales) */
  key: Scalars['ID']['output'];
  /** Human-readable english name for the language */
  language: Scalars['String']['output'];
  /** A human-readable english name for the locale */
  name: Scalars['String']['output'];
  /** Human-readable english name for the region */
  region?: Maybe<Scalars['String']['output']>;
  /** Human-readable english name for the script */
  script?: Maybe<Scalars['String']['output']>;
  /** BCP 47 subtags uniquely identifying this locale */
  tag: Scalars['String']['output'];
};

export type LocaleInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type Locales = {
  __typename?: 'Locales';
  nodes: Array<Locale>;
};

export type Market = {
  __typename?: 'Market';
  /** The shorthand code for the Market */
  code: Scalars['String']['output'];
  /** The full name of the Market */
  label: Scalars['String']['output'];
};

export type Me = {
  __typename?: 'Me';
  creator?: Maybe<Creator>;
  key: Scalars['ID']['output'];
  /** Aggregated access to organizational units for the current user. */
  organizationalUnitAccess: OrganizationalUnitAccess;
  /**
   * The viewer's own settings in this tenant; null for a viewer that is not a
   * user principal. Nullable: a client sends no analytics while it is null, so
   * a failed read never turns analytics on.
   */
  preferences?: Maybe<PrincipalPreferences>;
  principal?: Maybe<Principal>;
  /**
   * The viewer's effective treatment set, evaluated server-side:
   * effective(treatment) = (default OR any confer among the viewer's
   * cohorts) AND NOT (any suppress). No client-side derivation.
   */
  treatments: Array<Treatment>;
  user?: Maybe<User>;
  /**
   * Advisory operation answers for the viewer. Nullable by contract (the
   * fleet rule): the surface is a UX guard, not enforcement, so a consumer
   * that cannot get an answer treats null as not-permitted and degrades — a
   * failed check hop must never take the page down with it.
   */
  viewerOperationChecks?: Maybe<Array<MeOperationCheck>>;
};


export type MeViewerOperationChecksArgs = {
  operations: Array<MeOperation>;
};

/**
 * Semantic operations on the viewer's own tenant-level surface. Values are
 * user-intent affordance verbs, never ACL action IDs.
 */
export enum MeOperation {
  /**
   * Capability to create an organizational-unit tree at the tenancy root (the
   * New Client flow): preflights the same ou:create_subtree decision the
   * createOrganizationalUnitSubtree mutation enforces for a TENANCY anchor — a
   * create target at the tenant boundary. Deliberately a point check, not a
   * grant-existence sweep: an OU-anchored create_subtree grant cannot create at
   * the tenancy anchor and must fail.
   */
  CreateOrganizationalUnitTree = 'CREATE_ORGANIZATIONAL_UNIT_TREE',
  /**
   * Capability to open the admin panel: preflights the same ui:admin-panel
   * decision at the tenancy that the admin surface enforces.
   */
  OpenAdminPanel = 'OPEN_ADMIN_PANEL',
  /**
   * Capability to open Account Insights: the caller holds analytics:read at
   * tenancy or at any organizational unit (or is tenancy admin). Deliberately a
   * grant-existence check, not a tenancy point check — client admins hold the
   * action at OU anchors and must pass.
   */
  ViewAccountInsights = 'VIEW_ACCOUNT_INSIGHTS'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * extends Me with `viewerOperationChecks`); this subgraph contributes the
 * `validation` leg — the domain's registered state invariants.
 */
export type MeOperationCheck = {
  __typename?: 'MeOperationCheck';
  authorization: ActionCheckResult;
  meKey: Scalars['ID']['output'];
  operation: MeOperation;
  /**
   * Pure domain leg: does the viewer's state admit this operation. No Me
   * operation carries a domain gate today, so every registered operation
   * answers trivially true (the fleet contract's P4 staging) — the leg
   * exists so future guards land here as server-owned predicates, never as
   * FE-owned rules.
   */
  validation: ActionCheckResult;
};

export enum MeasurementUnit {
  Centimeters = 'CENTIMETERS',
  Inches = 'INCHES',
  Meters = 'METERS',
  Millimeters = 'MILLIMETERS',
  Pixels = 'PIXELS'
}

/** Media (i.e. of a creator). */
export type Media = {
  __typename?: 'Media';
  /** The media file. */
  file: File;
  /** Unique identifier. */
  id: Scalars['ID']['output'];
  /** The type of media attached to the creator */
  type: CreatorMediaType;
};

/** Media Input. */
export type MediaInput = {
  /** File key */
  fileKey: Scalars['ID']['input'];
  /** Media type */
  mediaType: CreatorMediaType;
};

export type MemberFilter = {
  anyOf?: InputMaybe<Array<Scalars['ID']['input']>>;
  me?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Assignment retaining a member; never requires fetching all assigned principals. */
export type MemberPropertyAssignment = {
  __typename?: 'MemberPropertyAssignment';
  definition: CustomPropertyDefinition;
  owner: MemberPropertyOwner;
};

export type MemberPropertyOwner = Concept | Project;

/** Pagination metadata for paginated content */
export type Metadata = {
  __typename?: 'Metadata';
  /** The current page number */
  currentPage: Scalars['Int']['output'];
  /** The number of results returned on the current page */
  currentResults: Scalars['Int']['output'];
  /** Whether or not there are more pages to be fetched */
  hasMore: Scalars['Boolean']['output'];
  /** The total number of pages */
  numPages: Scalars['Int']['output'];
  /** The total number of results */
  numResults: Scalars['Int']['output'];
  /** The maximum number of results returned per page */
  perPage: Scalars['Int']['output'];
};

export type MoveOrganizationalUnitInput = {
  /** Explicit anchor governing this organizational unit after the move. */
  anchor: OrganizationalUnitAnchorInput;
  /** Organizational unit integration key. */
  key: Scalars['ID']['input'];
};

export type MoveOrganizationalUnitPayload = {
  __typename?: 'MoveOrganizationalUnitPayload';
  /** True when the organizational unit moved to a new parent. */
  moved: Scalars['Boolean']['output'];
};

export type MultipartUpload = {
  __typename?: 'MultipartUpload';
  /** Integration key of the file these parts belong to. */
  fileKey: Scalars['ID']['output'];
  /** Details of the parts that have been uploaded so far. */
  parts: Array<MultipartUploadPart>;
};

export type MultipartUploadPart = {
  __typename?: 'MultipartUploadPart';
  /** The ETag of this part. */
  eTag?: Maybe<Scalars['String']['output']>;
  /** The index of this part. This is a positive integer between 1 and 10,000. */
  partNumber: Scalars['Int']['output'];
  /** The size of this part in bytes. */
  size: Scalars['Int64']['output'];
};

export type MultipartUploadPartInput = {
  /** The ETag of this part. */
  eTag: Scalars['String']['input'];
  /** The index of this part. This is a positive integer between 1 and 10,000. */
  partNumber: Scalars['Int']['input'];
};

export type MultipartUploadUrlParams = {
  /** Integration key of file this part belongs to. */
  fileKey: Scalars['ID']['input'];
  /** The part number to sign. Must be a positive integer between 1 and 10,000. */
  partNumber: Scalars['Int']['input'];
};

export type MultipartUploadUrlResponse = {
  __typename?: 'MultipartUploadURLResponse';
  /** The number of seconds until the presigned URL expires. */
  expiresIn: Scalars['Int']['output'];
  /** The index of this part. This is a positive integer between 1 and 10,000. */
  partNumber: Scalars['Int']['output'];
  /** The URL to upload to, including signed query parameters. */
  presignedUrl: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Aborts a multipart upload, deleting any parts that have already been uploaded. */
  abortMultipartUpload: Scalars['Boolean']['output'];
  acceptCreatorOffer: UgcOrder;
  accessControl: AccessControlMutation;
  acknowledgeNotification: Notification;
  /**
   * Associate collaborators with a Project.
   * Requires authorization.
   */
  addCollaboratorsToProject: Project;
  /** Add a new comment to a revision. */
  addComment: AddCommentPayload;
  addDeliverableFormatToConcept?: Maybe<AddDeliverableFormatToConceptPayload>;
  addVariantToConceptBrief: ConceptBrief;
  answerQuestions?: Maybe<AnswerQuestionsPayload>;
  /** Approve a ugcOrder. Returns true on success; re-read the order for its new state. */
  approveUgcOrder: Scalars['Boolean']['output'];
  /** @deprecated To support new `removeConcept` mutation. Will be removed in the future. */
  archiveAdvert?: Maybe<ArchiveAdvertPayload>;
  archiveAudience?: Maybe<Audience>;
  archiveBrandAssets: Scalars['Boolean']['output'];
  archiveBriefingAssets: ArchiveBriefingAssetsPayload;
  /** Archive a custom property definition so it no longer appears on records. */
  archiveCustomPropertyDefinition: CustomPropertyDefinition;
  archiveDeliverableFormat: DeliverableFormat;
  archivePlatform: Platform;
  archiveQuestion: Scalars['Boolean']['output'];
  archiveRevision: Scalars['Boolean']['output'];
  archiveTemplateBrief: Scalars['Boolean']['output'];
  /** Archive UGC assets. Returns true on success. */
  archiveUgcAssets: Scalars['Boolean']['output'];
  /** @deprecated Use deactivateUgcDeliverables instead */
  archiveUgcDeliverables: Scalars['Boolean']['output'];
  /** Archive a ugcOrder. Returns true on success. */
  archiveUgcOrder: Scalars['Boolean']['output'];
  /** Archive users. */
  archiveUsers: Array<User>;
  associateRenderTemplate: RenderTemplate;
  /**
   * Update the workflow stage and step of multiple concepts.
   * @deprecated Use transitionConceptWorkflow instead (its input takes batch requests); pick transitions from Concept.workflowTransitions or Concept.workflowTransitionOffer.
   */
  bulkUpdateConceptWorkflow: BulkUpdateConceptWorkflowResult;
  /** Claim an invitation. */
  claimInvitation: Scalars['Boolean']['output'];
  /** Classification administration (cohorts & treatments). */
  classification: ClassificationMutation;
  clearConceptCustomPropertyValue: Scalars['Boolean']['output'];
  /**
   * Clear a custom property value on a project. Requires project:write at the
   * project. Clearing an absent value is a no-op that returns true.
   */
  clearProjectCustomPropertyValue: Scalars['Boolean']['output'];
  /** Completes a multipart upload, combining all the parts into a single object in the S3 bucket. */
  completeMultipartUpload: File;
  /** @deprecated To support new `createConcept` mutation. Will be removed in the future. */
  createAdvertLegacy?: Maybe<CreateAdvertLegacyPayload>;
  createAiProject: Scalars['ID']['output'];
  createAmplifyDemoImports: Array<AmplifyDemoImport>;
  createAmplifyEditorSession: AmplifyEditorSession;
  createAudience?: Maybe<Audience>;
  createBrandAsset: BrandAsset;
  createBriefingAsset: BriefingAsset;
  /** Create a new concept within a project. */
  createConcept: Concept;
  /**
   * Create a bare DRAFT creator profile (staff lane). The profile row and its
   * authorization scope exist immediately, so media uploads can govern to the
   * returned key before the CRM form is saved; finish the profile through
   * createOrUpdateCreator.
   */
  createCreatorDraft: Scalars['ID']['output'];
  /** Create a creator offer for the order. Returns true on success. */
  createCreatorOffer: Scalars['Boolean']['output'];
  /** Create a custom property definition for the selected record kind. */
  createCustomPropertyDefinition: CustomPropertyDefinition;
  /**
   * Match or create user-defined options on a SELECT definition, in the
   * vocabulary of one organizational unit. Idempotent by label: an entry whose
   * trimmed, case-insensitive label (or generated value) names an active option
   * in that vocabulary returns the option unchanged — a global administrator
   * option is preferred over a unit-owned one — and every other entry creates a
   * unit-owned option attributed to the caller. The definition must apply to the
   * unit and allow user-defined options. Authorized as ou:write at the
   * organizational unit.
   */
  createCustomPropertyOptions: CreateCustomPropertyOptionsPayload;
  createDeliverableAmplifyIntegrations: Array<DeliverableAmplifyIntegration>;
  createDeliverableFormat: DeliverableFormat;
  createDimension: Dimension;
  /** Create a new invitation. */
  createInvitation: Invitation;
  /** Creates an S3 multipart upload. With this, files can be uploaded in chunks of 5MB+ each. */
  createMultipartUpload: File;
  createOrUpdateBrandProfile: BrandProfile;
  createOrUpdateConcept: Concept;
  createOrUpdateConceptLocalisation: ConceptLocalisation;
  /** Create or update a creator. Returns the creator key; re-read the creator for its details. */
  createOrUpdateCreator: Scalars['ID']['output'];
  /** Create or update a hobby / interest. */
  createOrUpdateCreatorHobbyInterest: CreatorHobbyInterest;
  /** Create or update a specialty vertical. */
  createOrUpdateCreatorSpecialtyVertical: CreatorSpecialtyVertical;
  /** Create or update a tag. */
  createOrUpdateCreatorTag: CreatorTag;
  createOrUpdateQuestionSection: QuestionSectionV2;
  createOrUpdateScene: Scene;
  createOrUpdateTemplateBrief: TemplateBrief;
  /** Create or update a ugcOrder. Returns the order key; re-read the order for its details. */
  createOrUpdateUgcOrder?: Maybe<UgcOrder>;
  /** Create a single organizational unit */
  createOrganizationalUnit: OrganizationalUnit;
  /** Create a single organizational unit tree in a single request */
  createOrganizationalUnitSubtree: OrganizationalUnitNodes;
  createPlatform: Platform;
  /** Creates a new Project within a brand. */
  createProject: CreateProjectPayload;
  createQuestion: QuestionDefinition;
  /** Attach a brand asset to the order's brief. Returns the asset key. */
  createUgcBrandAsset: Scalars['ID']['output'];
  createUgcDeliverable: UgcDeliverable;
  /** Attach a reference asset to the order's brief. Returns the asset key. */
  createUgcReferenceAsset: Scalars['ID']['output'];
  /** Create a new variant for a concept. */
  createVariant: Variant;
  /** Finalize the caller's DRAFT profile with the registration form data and submit it for review (DRAFT → PENDING). */
  creatorSignUp: Scalars['ID']['output'];
  /**
   * Mark one or more UGC deliverables as inactive.
   * These will remain visible to the creator.
   */
  deactivateUgcDeliverables: Scalars['Boolean']['output'];
  declineCreatorOffer: Scalars['Boolean']['output'];
  /** Delete a creator. Returns true on success. */
  deleteCreator: Scalars['Boolean']['output'];
  /** Delete a hobby / interest. */
  deleteCreatorHobbyInterest: CreatorHobbyInterest;
  /** Delete a specialty vertical. */
  deleteCreatorSpecialtyVertical: CreatorSpecialtyVertical;
  /** Delete a tag. */
  deleteCreatorTag: Scalars['ID']['output'];
  deleteUgcDeliverables: Scalars['Boolean']['output'];
  discardOrder: Scalars['Boolean']['output'];
  discardWorkingFile: Scalars['Boolean']['output'];
  /** Duplicates the given concept. */
  duplicateConceptV2: Concept;
  /** Duplicates a project, creating a new project with the same details as the original. */
  duplicateProjectV2: Project;
  /** Edit an existing revision comment. */
  editComment: EditCommentPayload;
  editRevision: Revision;
  /**
   * Ensure the calling principal's creator profile exists, creating a DRAFT
   * bound to the caller when none does. Idempotent — returns the caller's
   * live profile key whatever its status. The draft's authorization scope
   * registers with this mutation, so uploads can govern to the returned key
   * immediately; creatorSignUp finalizes the draft.
   */
  ensureCreatorDraft: Scalars['ID']['output'];
  /** Create or return existing deliverable specifications for the supplied identities. */
  ensureDeliverableSpecifications: EnsureDeliverableSpecificationsPayload;
  /** Ensure a principal (user or service). For users, provide user-specific details in the nested user input. */
  ensurePrincipal: EnsurePrincipalPayload;
  /** Invite the creator to claim their profile. Mints a CREATOR-audience identity invitation emailed to the profile's address; re-inviting revokes and replaces the previous invitation. Returns the invitation key. */
  inviteCreator: Scalars['ID']['output'];
  /** Move a single organizational unit to a new parent */
  moveOrganizationalUnit: MoveOrganizationalUnitPayload;
  promoteDimension: Dimension;
  /** Register an identity/profile; principal may be absent when legacy allocation is disabled. */
  registerIdentity: IdentityRegistrationPayload;
  /** Reject an existing revision with a comment. */
  rejectRevision: Revision;
  /**
   * Remove collaborators from a Project.
   *
   * Requires authorization.
   */
  removeCollaboratorsFromProject: Project;
  /** Remove an existing revision comment by ID. */
  removeComment: RemoveCommentPayload;
  /** Removes a concept with the given key. */
  removeConcept: Scalars['Boolean']['output'];
  removeConceptLocalisation: Scalars['Boolean']['output'];
  /** Remove the CreativeX brand for a client brand */
  removeCreativeXBrand: ClientBrand;
  removeDeliverable: Scalars['Boolean']['output'];
  removeDeliverableFormatsFromConcept?: Maybe<RemoveDeliverableFormatsFromConceptPayload>;
  /**
   * Remove a specification — the delivery page's "Delete format"
   * (docs/specification-delivery-and-removal/SCOPE.md; REMOVAL-CORE.md,
   * D-RR-1 (a)). Synchronous: the specification service decides on its own
   * facts, the deliverable owner's and the concept's stage, through the ONE
   * admission the REMOVE operation check serves and the save's
   * `specifications.removeKeys` member is decided by — a specification is
   * removable when its concept is in production, whatever it holds, or when
   * it holds no live deliverable row, whatever the stage (D-R4-8) — and
   * archives it in this call; its deliverables are archived with it by the
   * deliverable service, asynchronously, when the archived fact is applied.
   * Requires concept:write on the specification's concept. A REFUSAL IS AN
   * ANSWER, not an error: read `removed` and `refusal`. The call fails only
   * when the service could not decide (the deliverable owner or the concept
   * service could not be asked) or could not write.
   */
  removeDeliverableSpecification: RemoveDeliverableSpecificationPayload;
  removeGenerativeEdit?: Maybe<Scalars['Boolean']['output']>;
  removeQuestionSection: Scalars['Boolean']['output'];
  /**
   * Remove a draft specification. Returns the specification ID.
   *
   * Deprecated (D-RR-4 (c), docs/specification-delivery-and-removal/
   * REMOVAL-CORE.md): `removeDeliverableSpecification` is the removal door —
   * it admits what "Delete format" admits, not drafts alone, and answers a
   * refusal as a fact in its payload where this field can only fail. This
   * field keeps its draft-only rule for one train after its last caller
   * moved, then leaves the graph.
   * @deprecated Use removeDeliverableSpecification(key), which admits what Delete format admits and answers a refusal in its payload.
   */
  removeSpecification: Scalars['ID']['output'];
  /** Remove an existing variant. */
  removeVariant: Scalars['Boolean']['output'];
  /** Renew an invitation. */
  renewInvitation: Invitation;
  reorderQuestions: Scalars['Boolean']['output'];
  /** Request that the user's account be deleted. */
  requestAccountDeletion: Scalars['Boolean']['output'];
  /** Request a revision */
  requestRevisionV2: Revision;
  restoreDeliverableFormat: DeliverableFormat;
  /**
   * Restore a removed (archived) specification — the way back from
   * `removeDeliverableSpecification`
   * (docs/restore-specification-door/SCOPE.md). The specification comes
   * back as the slot it was: its key, unit number, variant and language
   * kept, the status it had when it was removed, never the concept's hero.
   * Requires concept:write on the specification's concept, exactly as
   * `removeDeliverableSpecification` does. A REFUSAL IS AN ANSWER, not an
   * error: read `restored` and `refusal`. The call fails only when the
   * service could not decide or could not write.
   */
  restoreDeliverableSpecification: RestoreDeliverableSpecificationPayload;
  restorePlatform: Platform;
  restoreQuestion: Scalars['Boolean']['output'];
  revokeCreatorOffer: Scalars['Boolean']['output'];
  /** Revoke invitations. */
  revokeInvitations: Array<Invitation>;
  /** Select (or clear) the order's creator. Returns true on success. */
  selectCreator: Scalars['Boolean']['output'];
  /** Send an invitation email. */
  sendInvitationEmail: Invitation;
  setBrandAssetNote: BrandAssetNote;
  setBriefingAssetNote: BriefingAsset;
  setConceptCustomPropertyValue: CustomPropertyCheckbox | CustomPropertyDate | CustomPropertyNumber | CustomPropertyRichText | CustomPropertySelect | CustomPropertyText | CustomPropertyUser;
  setConceptDueDate?: Maybe<ConceptDueDatePayload>;
  setConceptLanguage: Concept;
  /** Set the order's creator shortlist. Returns true on success. */
  setCreatorShortlist: Scalars['Boolean']['output'];
  /**
   * Set a deal for a project.
   *
   * Requires authorization.
   */
  setDealForProject: Project;
  /**
   * Set the access settings of a Project.
   *
   * Requires authorization.
   */
  setProjectAccess: ProjectAccessSettings;
  /**
   * Set a custom property value on a project. Requires project:write at the
   * project. SELECT options are created through createCustomPropertyOptions on
   * the custom-properties subgraph and referenced here by `optionKeys`.
   */
  setProjectCustomPropertyValue: CustomPropertyCheckbox | CustomPropertyDate | CustomPropertyNumber | CustomPropertyRichText | CustomPropertySelect | CustomPropertyText | CustomPropertyUser;
  setProjectDueDate?: Maybe<ProjectDueDatePayload>;
  /** Set the external URL associated with a Project. Requires authorization. */
  setProjectExternalUrl: Project;
  /** Set a UGC asset's note. Returns true on success. */
  setUgcAssetNote: Scalars['Boolean']['output'];
  submitGenerativeEditDeliverable?: Maybe<Scalars['ID']['output']>;
  submitGenerativeEditRequest?: Maybe<Scalars['ID']['output']>;
  submitGenerativeVariationRequest?: Maybe<Scalars['ID']['output']>;
  /** Submit a CES rating for a project. */
  submitProjectCes: Scalars['Boolean']['output'];
  /** Submit a CSAT rating for a project. */
  submitProjectCsat: Scalars['Boolean']['output'];
  submitProjectForTemplatedProduction: Scalars['Boolean']['output'];
  submitProjectFormats: Project;
  /** Submit the given UGC order's pending UGC deliverables for review */
  submitUgcDeliverables: Scalars['Boolean']['output'];
  /**
   * Enacts workflow transitions on a set of concepts, one transition per
   * concept. Each request gets its own outcome, so a call can return any mix
   * of APPLIED, BLOCKED, UNAVAILABLE and UNEVALUATED. If the request as a
   * whole fails, nothing is applied. At most 500 requests per call.
   */
  transitionConceptWorkflow: TransitionConceptWorkflowResult;
  /** Un-archive users. */
  unArchiveUsers: Array<User>;
  /** Restore an archived custom property definition. */
  unarchiveCustomPropertyDefinition: CustomPropertyDefinition;
  unarchiveRevision: Scalars['Boolean']['output'];
  unarchiveTemplateBrief: Scalars['Boolean']['output'];
  updateAdvert?: Maybe<UpdateAdvertPayload>;
  updateAudience?: Maybe<Audience>;
  /**
   * Update the concept's briefing specifications from a set of briefing
   * formats: by default the set replaces them, and with mode ADD the formats
   * are added and nothing is removed.
   */
  updateBriefingConceptSpecifications: Concept;
  /**
   * Update a client account.
   *
   * Requires authorization.
   */
  updateClientAccount: ClientAccount;
  /**
   * Update generative AI preferences for a client account.
   *
   * Requires authorization.
   */
  updateClientAccountGenerativeAIPreferences: ClientAccount;
  /**
   * Update a client brand.
   *
   * Requires authorization.
   */
  updateClientBrand: ClientBrand;
  updateConceptNotes: RevisionConcept;
  /**
   * Update the workflow stage and step of a concept.
   *
   * If provided, step must belong to the given stage.
   * Else, moves to default step of the given stage.
   * @deprecated Use transitionConceptWorkflow instead; pick the transition from Concept.workflowTransitions or Concept.workflowTransitionOffer.
   */
  updateConceptWorkflow: Concept;
  /** Update the CreativeX brand for a client brand */
  updateCreativeXBrand: ClientBrand;
  /** Update the CreativeX integration for a client account */
  updateCreativeXIntegration: ClientAccountIntegrations;
  updateCreativeXNotes?: Maybe<DeliverableCreativeX>;
  updateCsReviewNotes: ProjectBrief;
  /** Update a custom property definition. Omitted input fields are left unchanged. */
  updateCustomPropertyDefinition: CustomPropertyDefinition;
  /**
   * Rename and/or recolor one active user-created option while preserving its
   * identity and exact organizational-unit scope. Authorized as ou:write at the
   * option's persisted scope OU. Global, archived, and unknown options are not
   * editable through this mutation.
   */
  updateCustomPropertyOption: CustomPropertyOption;
  updateDeliverableApproval: Array<Deliverable>;
  updateDeliverableFormat: DeliverableFormat;
  /**
   * The uploader's save: every deliverable-side change the page's Save button
   * carries, in one call. Creates and updates commit in one transaction, and a
   * create placed against a specification lands beside the specification's
   * live version — nothing is written to a predecessor when a successor
   * arrives, and the head election decides which version is the slot's
   * current one (docs/deliverable-status-seam/SCOPE.md, Train B-0 step 2,
   * D-B0-2 (a)); the batch's `removeKeys`, `variants` and
   * `workingFiles`, an item's `variantName` and its `amplifyIntegration`, are
   * the single-save contract (docs/uploader-single-save-mutation/SCOPE.md):
   * PROPOSED, painted here so the shape can be reviewed, and REFUSED as a bad
   * request until the build that honours them lands — a caller that sets one
   * today gets an error, never a silently ignored field. Once built, the
   * cross-service parts (a slot's specification and variant, the working
   * files, the Amplify integration) run as asynchronous commands after the
   * commit; the payload's `writeToken` promises them and `convergence`
   * discloses whether they landed inside the mutation's bounded wait. Every
   * member carries the authorization check its standalone mutation carries
   * today, named on each field; a refused check refuses the whole batch before
   * any write.
   */
  updateDeliverables: UpdateDeliverablesResponse;
  updateDimension: Dimension;
  updateOrder: Scalars['Boolean']['output'];
  /** Update a single organizational unit */
  updateOrganizationalUnit: OrganizationalUnit;
  updatePlatform: Platform;
  /** Update the viewer's own settings in this tenant. Users only: refuses impersonation and service or group callers. */
  updatePrincipalPreferences: PrincipalPreferences;
  updateQuestion: QuestionDefinition;
  updateRenderTemplateSpecificationMappings: Array<RenderTemplateSpecificationMapping>;
  /** Update a ugcOrder's brief. Returns true on success; re-read the brief for its details. */
  updateUgcBrief: Scalars['Boolean']['output'];
  updateUgcDeliverable: UgcDeliverable;
  /** Update a user. */
  updateUser: User;
  /**
   * Update the details of an existing variant.
   *
   * If a field is omitted in the input, it will not be changed.
   */
  updateVariant: Variant;
  /**
   * Update the specifications for a variant.
   * Currently, only variant type VARIATION is supported.
   */
  updateVariantSpecifications: Variant;
  updateWorkingFiles: Scalars['Boolean']['output'];
};


export type MutationAbortMultipartUploadArgs = {
  input: AbortMultipartUploadInput;
};


export type MutationAcceptCreatorOfferArgs = {
  key: Scalars['ID']['input'];
};


export type MutationAcknowledgeNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddCollaboratorsToProjectArgs = {
  integrationKey: Scalars['ID']['input'];
  userIntegrationKeys: Array<Scalars['ID']['input']>;
};


export type MutationAddCommentArgs = {
  input: AddCommentInput;
};


export type MutationAddDeliverableFormatToConceptArgs = {
  input: AddDeliverableFormatToConceptInput;
};


export type MutationAddVariantToConceptBriefArgs = {
  input: AddVariantToConceptBriefInput;
};


export type MutationAnswerQuestionsArgs = {
  input: AnswerQuestionsInput;
};


export type MutationApproveUgcOrderArgs = {
  input: ApproveUgcOrderInput;
};


export type MutationArchiveAdvertArgs = {
  input: ArchiveAdvertInput;
};


export type MutationArchiveAudienceArgs = {
  key: Scalars['ID']['input'];
};


export type MutationArchiveBrandAssetsArgs = {
  input: ArchiveBrandAssetsInput;
};


export type MutationArchiveBriefingAssetsArgs = {
  input: ArchiveBriefingAssetsInput;
};


export type MutationArchiveCustomPropertyDefinitionArgs = {
  key: Scalars['ID']['input'];
};


export type MutationArchiveDeliverableFormatArgs = {
  key: Scalars['ID']['input'];
};


export type MutationArchivePlatformArgs = {
  code: Scalars['String']['input'];
};


export type MutationArchiveQuestionArgs = {
  key: Scalars['String']['input'];
};


export type MutationArchiveRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveTemplateBriefArgs = {
  key: Scalars['ID']['input'];
};


export type MutationArchiveUgcAssetsArgs = {
  input: ArchiveUgcAssetsInput;
};


export type MutationArchiveUgcDeliverablesArgs = {
  input: ArchiveUgcDeliverablesInput;
};


export type MutationArchiveUgcOrderArgs = {
  input: ArchiveUgcOrderInput;
};


export type MutationArchiveUsersArgs = {
  input: ArchiveUsersInput;
};


export type MutationAssociateRenderTemplateArgs = {
  input: AssociateRenderTemplateInput;
};


export type MutationBulkUpdateConceptWorkflowArgs = {
  input: BulkUpdateConceptWorkflowInput;
};


export type MutationClaimInvitationArgs = {
  input: ClaimInvitationInput;
};


export type MutationClearConceptCustomPropertyValueArgs = {
  definitionKey: Scalars['ID']['input'];
  ownerKey: Scalars['ID']['input'];
};


export type MutationClearProjectCustomPropertyValueArgs = {
  definitionKey: Scalars['ID']['input'];
  ownerKey: Scalars['ID']['input'];
};


export type MutationCompleteMultipartUploadArgs = {
  input: CompleteMultipartUploadInput;
};


export type MutationCreateAdvertLegacyArgs = {
  input: CreateAdvertLegacyInput;
};


export type MutationCreateAiProjectArgs = {
  input: CreateAiProjectInput;
};


export type MutationCreateAmplifyDemoImportsArgs = {
  input: CreateAmplifyDemoImportsInput;
};


export type MutationCreateAmplifyEditorSessionArgs = {
  input: CreateAmplifyEditorSessionInput;
};


export type MutationCreateAudienceArgs = {
  input: CreateAudienceInput;
};


export type MutationCreateBrandAssetArgs = {
  input: CreateBrandAssetInput;
};


export type MutationCreateBriefingAssetArgs = {
  input: CreateBriefingAssetInput;
};


export type MutationCreateConceptArgs = {
  input: CreateConceptInput;
};


export type MutationCreateCreatorOfferArgs = {
  input: CreateCreatorOfferInput;
};


export type MutationCreateCustomPropertyDefinitionArgs = {
  input: CreateCustomPropertyDefinitionInput;
};


export type MutationCreateCustomPropertyOptionsArgs = {
  input: CreateCustomPropertyOptionsInput;
};


export type MutationCreateDeliverableAmplifyIntegrationsArgs = {
  input: CreateDeliverableAmplifyIntegrationsInput;
};


export type MutationCreateDeliverableFormatArgs = {
  input: CreateDeliverableFormatInput;
};


export type MutationCreateDimensionArgs = {
  input: CreateDimensionInput;
};


export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


export type MutationCreateMultipartUploadArgs = {
  input: CreateMultipartUploadInput;
};


export type MutationCreateOrUpdateBrandProfileArgs = {
  input: CreateOrUpdateBrandProfileInput;
};


export type MutationCreateOrUpdateConceptArgs = {
  input: CreateOrUpdateConceptInput;
};


export type MutationCreateOrUpdateConceptLocalisationArgs = {
  input: CreateOrUpdateConceptLocalisationInput;
};


export type MutationCreateOrUpdateCreatorArgs = {
  input: CreatorInput;
};


export type MutationCreateOrUpdateCreatorHobbyInterestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};


export type MutationCreateOrUpdateCreatorSpecialtyVerticalArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};


export type MutationCreateOrUpdateCreatorTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};


export type MutationCreateOrUpdateQuestionSectionArgs = {
  input?: InputMaybe<CreateOrUpdateQuestionSectionInput>;
};


export type MutationCreateOrUpdateSceneArgs = {
  input: CreateOrUpdateSceneInput;
};


export type MutationCreateOrUpdateTemplateBriefArgs = {
  input: CreateOrUpdateTemplateBriefInput;
};


export type MutationCreateOrUpdateUgcOrderArgs = {
  input: UgcOrderInput;
};


export type MutationCreateOrganizationalUnitArgs = {
  input: CreateOrganizationalUnitInput;
};


export type MutationCreateOrganizationalUnitSubtreeArgs = {
  input: CreateOrganizationalUnitSubtreeInput;
};


export type MutationCreatePlatformArgs = {
  input: CreatePlatformInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type MutationCreateUgcBrandAssetArgs = {
  input: CreateUgcAssetInput;
};


export type MutationCreateUgcDeliverableArgs = {
  input: CreateUgcDeliverableInput;
};


export type MutationCreateUgcReferenceAssetArgs = {
  input: CreateUgcAssetInput;
};


export type MutationCreateVariantArgs = {
  input: CreateVariantInput;
};


export type MutationCreatorSignUpArgs = {
  input: SubmitCreatorRegistrationInput;
};


export type MutationDeactivateUgcDeliverablesArgs = {
  input: DeactivateUgcDeliverablesInput;
};


export type MutationDeclineCreatorOfferArgs = {
  input: DeclineCreatorOfferInput;
};


export type MutationDeleteCreatorArgs = {
  key: Scalars['ID']['input'];
};


export type MutationDeleteCreatorHobbyInterestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCreatorSpecialtyVerticalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCreatorTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUgcDeliverablesArgs = {
  input: ArchiveUgcDeliverablesInput;
};


export type MutationDiscardOrderArgs = {
  input: DiscardOrderInput;
};


export type MutationDiscardWorkingFileArgs = {
  input: DiscardWorkingFileInput;
};


export type MutationDuplicateConceptV2Args = {
  input: DuplicateConceptV2Input;
};


export type MutationDuplicateProjectV2Args = {
  input: DuplicateProjectV2Input;
};


export type MutationEditCommentArgs = {
  input: EditCommentInput;
};


export type MutationEditRevisionArgs = {
  input: EditRevisionInput;
};


export type MutationEnsureDeliverableSpecificationsArgs = {
  input: EnsureDeliverableSpecificationsInput;
};


export type MutationEnsurePrincipalArgs = {
  input: EnsurePrincipalInput;
};


export type MutationInviteCreatorArgs = {
  key: Scalars['ID']['input'];
};


export type MutationMoveOrganizationalUnitArgs = {
  input: MoveOrganizationalUnitInput;
};


export type MutationPromoteDimensionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterIdentityArgs = {
  input: EnsurePrincipalInput;
};


export type MutationRejectRevisionArgs = {
  input: RejectRevisionInput;
};


export type MutationRemoveCollaboratorsFromProjectArgs = {
  integrationKey: Scalars['ID']['input'];
  userIntegrationKeys: Array<Scalars['ID']['input']>;
};


export type MutationRemoveCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveConceptArgs = {
  key: Scalars['ID']['input'];
};


export type MutationRemoveConceptLocalisationArgs = {
  input: RemoveConceptLocalisationInput;
};


export type MutationRemoveCreativeXBrandArgs = {
  clientBrandKey: Scalars['ID']['input'];
};


export type MutationRemoveDeliverableArgs = {
  key: Scalars['ID']['input'];
};


export type MutationRemoveDeliverableFormatsFromConceptArgs = {
  input: RemoveDeliverableFormatsFromConceptInput;
};


export type MutationRemoveDeliverableSpecificationArgs = {
  key: Scalars['ID']['input'];
};


export type MutationRemoveGenerativeEditArgs = {
  key: Scalars['ID']['input'];
};


export type MutationRemoveQuestionSectionArgs = {
  key: Scalars['String']['input'];
};


export type MutationRemoveSpecificationArgs = {
  key: Scalars['ID']['input'];
};


export type MutationRemoveVariantArgs = {
  key: Scalars['ID']['input'];
};


export type MutationRenewInvitationArgs = {
  input: RenewInvitationInput;
};


export type MutationReorderQuestionsArgs = {
  input: Array<QuestionReorderInput>;
};


export type MutationRequestRevisionV2Args = {
  input: RevisionInputV2;
};


export type MutationRestoreDeliverableFormatArgs = {
  key: Scalars['ID']['input'];
};


export type MutationRestoreDeliverableSpecificationArgs = {
  key: Scalars['ID']['input'];
};


export type MutationRestorePlatformArgs = {
  code: Scalars['String']['input'];
};


export type MutationRestoreQuestionArgs = {
  key: Scalars['String']['input'];
};


export type MutationRevokeCreatorOfferArgs = {
  input: RevokeCreatorOfferInput;
};


export type MutationRevokeInvitationsArgs = {
  input: RevokeInvitationsInput;
};


export type MutationSelectCreatorArgs = {
  creatorKey?: InputMaybe<Scalars['ID']['input']>;
  ugcOrderKey: Scalars['ID']['input'];
};


export type MutationSendInvitationEmailArgs = {
  input: SendInvitationEmailInput;
};


export type MutationSetBrandAssetNoteArgs = {
  assetKey: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type MutationSetBriefingAssetNoteArgs = {
  input: SetBriefingAssetNoteInput;
};


export type MutationSetConceptCustomPropertyValueArgs = {
  input: SetCustomPropertyValueInput;
};


export type MutationSetConceptDueDateArgs = {
  input: SetConceptDueDateInput;
};


export type MutationSetConceptLanguageArgs = {
  input: SetConceptLanguageInput;
};


export type MutationSetCreatorShortlistArgs = {
  creatorKeys: Array<Scalars['ID']['input']>;
  ugcOrderKey: Scalars['ID']['input'];
};


export type MutationSetDealForProjectArgs = {
  input: SetDealForProjectInput;
};


export type MutationSetProjectAccessArgs = {
  input: SetProjectAccessInput;
};


export type MutationSetProjectCustomPropertyValueArgs = {
  input: SetCustomPropertyValueInput;
};


export type MutationSetProjectDueDateArgs = {
  input: SetProjectDueDateInput;
};


export type MutationSetProjectExternalUrlArgs = {
  input: SetProjectExternalUrlInput;
};


export type MutationSetUgcAssetNoteArgs = {
  input: SetUgcAssetNoteInput;
};


export type MutationSubmitGenerativeEditDeliverableArgs = {
  input: SubmitGenerativeEditDeliverableInput;
};


export type MutationSubmitGenerativeEditRequestArgs = {
  input: SubmitGenerativeEditRequestInput;
};


export type MutationSubmitGenerativeVariationRequestArgs = {
  input: SubmitGenerativeVariationRequestInput;
};


export type MutationSubmitProjectCesArgs = {
  input: ProjectCesInput;
};


export type MutationSubmitProjectCsatArgs = {
  input: ProjectCsatInput;
};


export type MutationSubmitProjectForTemplatedProductionArgs = {
  input: SubmitProjectForTemplatedProductionInput;
};


export type MutationSubmitProjectFormatsArgs = {
  projectKey: Scalars['ID']['input'];
};


export type MutationSubmitUgcDeliverablesArgs = {
  input: SubmitUgcDeliverablesInput;
};


export type MutationTransitionConceptWorkflowArgs = {
  input: TransitionConceptWorkflowInput;
};


export type MutationUnArchiveUsersArgs = {
  input: ArchiveUsersInput;
};


export type MutationUnarchiveCustomPropertyDefinitionArgs = {
  key: Scalars['ID']['input'];
};


export type MutationUnarchiveRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveTemplateBriefArgs = {
  key: Scalars['ID']['input'];
};


export type MutationUpdateAdvertArgs = {
  input: UpdateAdvertInput;
};


export type MutationUpdateAudienceArgs = {
  input: UpdateAudienceInput;
};


export type MutationUpdateBriefingConceptSpecificationsArgs = {
  input: UpdateBriefingConceptSpecificationsInput;
};


export type MutationUpdateClientAccountArgs = {
  input: UpdateClientAccountInput;
};


export type MutationUpdateClientAccountGenerativeAiPreferencesArgs = {
  input: ClientAccountGenerativeAiPreferencesInput;
};


export type MutationUpdateClientBrandArgs = {
  input: UpdateClientBrandInput;
};


export type MutationUpdateConceptNotesArgs = {
  input: UpdateConceptNotesInput;
};


export type MutationUpdateConceptWorkflowArgs = {
  input: UpdateConceptWorkflowInput;
};


export type MutationUpdateCreativeXBrandArgs = {
  input: UpdateCreativeXBrandInput;
};


export type MutationUpdateCreativeXIntegrationArgs = {
  input: UpdateCreativeXIntegrationInput;
};


export type MutationUpdateCreativeXNotesArgs = {
  input: UpdateCreativeXNotesInput;
};


export type MutationUpdateCsReviewNotesArgs = {
  input: UpdateCsReviewNotesInput;
};


export type MutationUpdateCustomPropertyDefinitionArgs = {
  input: UpdateCustomPropertyDefinitionInput;
  key: Scalars['ID']['input'];
};


export type MutationUpdateCustomPropertyOptionArgs = {
  input: UpdateCustomPropertyOptionInput;
};


export type MutationUpdateDeliverableApprovalArgs = {
  input: UpdateDeliverableApprovalInput;
};


export type MutationUpdateDeliverableFormatArgs = {
  input: UpdateDeliverableFormatInput;
  key: Scalars['ID']['input'];
};


export type MutationUpdateDeliverablesArgs = {
  input: UpdateDeliverablesInput;
};


export type MutationUpdateDimensionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDimensionInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdateOrganizationalUnitArgs = {
  input: UpdateOrganizationalUnitInput;
};


export type MutationUpdatePlatformArgs = {
  code: Scalars['String']['input'];
  input: UpdatePlatformInput;
};


export type MutationUpdatePrincipalPreferencesArgs = {
  input: UpdatePrincipalPreferencesInput;
};


export type MutationUpdateQuestionArgs = {
  input: UpdateQuestionInput;
};


export type MutationUpdateRenderTemplateSpecificationMappingsArgs = {
  input: UpdateRenderTemplateSpecificationMappingsInput;
};


export type MutationUpdateUgcBriefArgs = {
  input: UpdateUgcBriefInput;
};


export type MutationUpdateUgcDeliverableArgs = {
  input: UpdateUgcDeliverableInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateVariantArgs = {
  input: UpdateVariantInput;
};


export type MutationUpdateVariantSpecificationsArgs = {
  input: UpdateVariantSpecificationsInput;
};


export type MutationUpdateWorkingFilesArgs = {
  input: UpdateWorkingFilesInput;
};

/**
 * Label and color for a SELECT custom property option to create. A label that
 * already names an active option in the target vocabulary matches that option
 * instead of creating one (see createCustomPropertyOptions).
 */
export type NewCustomPropertyOptionInput = {
  /** Display color for the new option. */
  color?: CustomPropertyOptionColor;
  /** Display label for the new option. */
  label: Scalars['String']['input'];
};

/**
 * Nothing has been delivered for this concept yet: it has no current
 * deliverables (the latest version of each deliverable, excluding archived
 * ones). Carries no count.
 */
export type NoDeliverablesBlocker = WorkflowTransitionBlocker & {
  __typename?: 'NoDeliverablesBlocker';
  reason: WorkflowTransitionBlockedReason;
};

/** No HubSpotDeal was selected using the no deal assigned option. */
export type NoHubspotDeal = {
  __typename?: 'NoHubspotDeal';
  /** Selection of reasons for why no HubSpot deal is assigned. */
  option: NoHubspotDealOptions;
};

/** Category of the reason why no HubSpot deal is assigned. */
export enum NoHubspotDealOptions {
  DealNotFound = 'DealNotFound',
  InternalUse = 'InternalUse',
  /** @deprecated Only present for support of migrated Projects, one of the above options should be used for new updates. */
  Legacy = 'Legacy',
  NonCommercial = 'NonCommercial'
}

export type Notification = {
  __typename?: 'Notification';
  acknowledged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: NotificationType;
};

export enum NotificationType {
  RevisionsCompleted = 'RevisionsCompleted',
  Unknown = 'Unknown'
}

export enum Objective {
  BrandAwareness = 'brand_awareness',
  Consideration = 'consideration',
  DirectResponse = 'direct_response',
  FullFunnel = 'full_funnel',
  Unknown = 'unknown'
}

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  pageCount: Scalars['Int']['output'];
  pageIndex: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  recordCount: Scalars['Int']['output'];
};

export type OffsetPagination = {
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

/** Some of the concept's deliverables have open revision requests. */
export type OpenRevisionsBlocker = WorkflowTransitionBlocker & {
  __typename?: 'OpenRevisionsBlocker';
  /** How many deliverables have open revision requests. Counts deliverables, not revision requests. */
  deliverables: Scalars['Int']['output'];
  reason: WorkflowTransitionBlockedReason;
};

/** An order. */
export type Order = {
  __typename?: 'Order';
  /** @deprecated Constant for every live order. */
  activeProject?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  advertKeys: Array<Scalars['ID']['output']>;
  artDirectorPrincipalKey?: Maybe<Scalars['ID']['output']>;
  assetsZipUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Constant for every live order. */
  briefApprovedAt?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Constant for every live order. */
  canAddDeliverables?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canApprove?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canBeCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canBeConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canBeContinued?: Maybe<Scalars['Boolean']['output']>;
  canBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canBeDelivered?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canEditBrief?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canEditBriefFormats?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canHaveRevisionLimitAdjusted?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canReject?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canRevise?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canSubmitBrief?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canUnapprove?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canUpdateDeliveryTurnaround: Scalars['Boolean']['output'];
  /** @deprecated Constant for every live order. */
  canViewDeliverables?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canViewProductionBrief?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  canViewSummaryBrief?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Constant for every live order. */
  clientSequenceNumber: Scalars['Int']['output'];
  combinedZipUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Constant for every live order. */
  completedAt?: Maybe<Scalars['BigInt']['output']>;
  copilotStatus?: Maybe<CopilotStatus>;
  createdAt: Scalars['BigInt']['output'];
  /** @deprecated Constant for every live order. */
  currentStep?: Maybe<OrderWorkflowStep>;
  /** @deprecated Constant for every live order. */
  currentStepId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Constant for every live order. */
  deliverablePlatformCodes: Array<Scalars['String']['output']>;
  deliverablesZipUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Constant for every live order. */
  deliveryAdjustedReason?: Maybe<Scalars['String']['output']>;
  /** @deprecated Constant for every live order. */
  deliveryAdjustedTime?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Constant for every live order. */
  deliveryDeliveredAt?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Use delivery_turnaround instead. */
  deliveryDueAt?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Constant for every live order. */
  deliveryExpectedTime?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Constant for every live order. */
  deliveryOriginalTime?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Constant for every live order. */
  deliveryTurnaroundKey?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Constant for every live order. */
  effectiveState: OrderState;
  /** @deprecated Constant for every live order. */
  googleDriveUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Constant for every live order. */
  hasConceptWorkflow: Scalars['Boolean']['output'];
  /** @deprecated Constant for every live order. */
  hubspotId?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Constant for every live order. */
  isExpress: Scalars['Boolean']['output'];
  /** @deprecated Constant for every live order. */
  isFinalStep: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  /** @deprecated Constant for every live order. */
  license: Scalars['Boolean']['output'];
  /** @deprecated Constant for every live order. */
  licensePlus: Scalars['Boolean']['output'];
  /** @deprecated Constant for every live order. */
  maxNumRevisions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationalUnitKey?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Constant for every live order. */
  productionNotes?: Maybe<Scalars['String']['output']>;
  serialId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** @deprecated Constant for every live order. */
  state: OrderState;
  /** @deprecated Constant for every live order. */
  submissionState: SubmissionState;
  /** @deprecated Constant for every live order. */
  submittedAt?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated Constant for every live order. */
  subscription: Scalars['Boolean']['output'];
  /** @deprecated Constant for every live order. */
  totalDeliverablesOrdered?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Constant for every live order. */
  version: Scalars['Int']['output'];
  workingFileKeys: Array<Scalars['ID']['output']>;
  workingFilesZipUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * The concept keys that matched one returned order under the query's
 * conceptWorkflow argument, ascending — sourced from the same mirror predicate
 * that included the order. Response-scoped by design: which concepts matched
 * varies with the query's filter, so the matches ride the collection result,
 * never the Order entity (a normalized entity field would bleed across
 * differently-filtered reads in normalizing caches).
 */
export type OrderConceptWorkflowMatch = {
  __typename?: 'OrderConceptWorkflowMatch';
  conceptKeys: Array<Scalars['ID']['output']>;
  orderKey: Scalars['ID']['output'];
};

export type OrderDiscardInput = {
  key: Scalars['ID']['input'];
};

export enum OrderState {
  AssetProduction = 'asset_production',
  ClientReview = 'client_review',
  ClientRevision = 'client_revision',
  ConceptWorkflow = 'concept_workflow',
  CsReview = 'cs_review',
  DraftBrief = 'draft_brief',
  FinishingStep = 'finishing_step',
  InProgress = 'in_progress',
  InternalReview = 'internal_review',
  InternalRevision = 'internal_revision',
  ProductionReview = 'production_review',
  ProductionSetup = 'production_setup',
  ProjectComplete = 'project_complete',
  UgcIdeation = 'ugc_ideation'
}

export type OrderUpdateInput = {
  artDirectorPrincipalKey?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Ignored: production notes are no longer stored. */
  productionNotes?: InputMaybe<EncodedString>;
};

export type OrderWorkflowContext = {
  __typename?: 'OrderWorkflowContext';
  nextStep?: Maybe<OrderWorkflowStep>;
  nextStepId?: Maybe<Scalars['ID']['output']>;
  selectedStepIds: Array<Scalars['ID']['output']>;
  selectedSteps: Array<OrderWorkflowStep>;
};

export type OrderWorkflowStep = {
  __typename?: 'OrderWorkflowStep';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Orders = {
  __typename?: 'Orders';
  /**
   * Per-order matched concept keys for a conceptWorkflow-filtered read: one
   * entry per returned order, in node order. Null when the query carries no
   * conceptWorkflow argument (an empty filter is equivalent to an absent one).
   * Under concurrent mirror updates between the page read and the key read an
   * included order can transiently lack an entry — consumers treat a missing
   * entry as no-match-information, the same accepted lag class as the mirror
   * itself (stage-filters DESIGN §4.2).
   */
  conceptWorkflowMatches?: Maybe<Array<OrderConceptWorkflowMatch>>;
  metadata: Metadata;
  nodes: Array<Order>;
};

/**
 * Concept Workflow position filter for the orders search. Any-match: an
 * order qualifies when at least one of its non-archived concepts satisfies
 * the predicate. stepKeys and stageCodes constrain the same concept
 * conjunctively; values within each list combine as IN (concept in any
 * selected value). The filter ANDs with every other orders predicate —
 * organizational units, states, region, keyword — and leaves sort,
 * pagination, and result metadata untouched.
 */
export type OrdersConceptWorkflowFilter = {
  /** Concept Workflow stage codes — the left-nav presets. */
  stageCodes?: InputMaybe<Array<WorkflowStageCode>>;
  /** Concept Workflow step (substage) keys — the filter drawer's selections. Stable keys from Query.workflowStages. */
  stepKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrdersOrganizationalUnitFilter = {
  allOf?: InputMaybe<Array<OrdersOrganizationalUnitSet>>;
};

export type OrdersOrganizationalUnitScope = {
  includeDescendants?: Scalars['Boolean']['input'];
  key: Scalars['ID']['input'];
};

export type OrdersOrganizationalUnitSet = {
  anyOf: Array<OrdersOrganizationalUnitScope>;
};

/**
 * Organizational units are used to represent a hierarchy of resources within the system.
 *
 * These hierarchies are recursive and can be of variable depth. We do not expose this recursion
 * directly on the graph (i.e. no children/parent fields on the OrganizationalUnit type) to
 * avoid having to define a set depth of recursion on the client.
 *
 * Use `organizationalUnits` with the `organization` filter when you already know the
 * organizational unit key.
 *
 * **Denial shape.** The representation ALWAYS resolves for a tenant member: a key
 * the viewer may not read yields a key-only stub, never a null entity. Null on the
 * always-present content fields — `ancestryDepth`, `fullName`, `name`, `platforms`,
 * `config` — therefore means WITHHELD, never "no value"; the accompanying
 * object-level error at that representation's path carries `extensions.code:
 * FORBIDDEN` with a deliberately neutral message that never distinguishes "absent"
 * from "refused". Those five fields are nullable for exactly this reason: non-null
 * content is what forces the executor to null the PARENT, which would take the
 * fields other subgraphs contribute to this object (`viewerOperationChecks`,
 * `grants`) down with it and leave a viewer unable to ask whether they may read
 * this unit at all. Do NOT restore `!` on them, and do NOT read the genuinely
 * tri-state fields (`archivedAt`, `parentKey`, `resourceKey`, `resourceType`,
 * `resource`, `resourceAttributes`) as a denial signal — they are nullable on
 * their own terms.
 */
export type OrganizationalUnit = {
  __typename?: 'OrganizationalUnit';
  /**
   * A zero based depth of the organizational unit in the hierarchy.
   * (e.g. 0 = root, 1 = child of root, 2 = child of child of root etc.)
   *
   * Null means withheld — see the denial shape on this type.
   */
  ancestryDepth?: Maybe<Scalars['Int']['output']>;
  /** The UTC timestamp when the organizational unit was archived. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** Direct children of this organizational unit. */
  children: Array<OrganizationalUnit>;
  /**
   * Configuration flags for this organizational unit.
   *
   * Null means withheld — see the denial shape on this type.
   */
  config?: Maybe<OrganizationalUnitConfig>;
  /**
   * A delimited full name of the organizational unit, including all ancestors.
   * (e.g. "Account name : Group name : Brand name")
   *
   * Null means withheld — see the denial shape on this type.
   */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Grants anchored to this organizational unit scope. */
  grants: Array<PrincipalGrant>;
  /** Unique identifier of the organizational unit */
  key: Scalars['ID']['output'];
  /**
   * The name of just this organizational unit. (e.g. My Brand)
   *
   * Null means withheld — see the denial shape on this type.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** Parent organizational unit, if any. */
  parent?: Maybe<OrganizationalUnit>;
  /** The key of the parent organizational unit. Can be used to construct the hierarchy */
  parentKey?: Maybe<Scalars['ID']['output']>;
  /**
   * Effective platforms available to this organizational unit with inheritance metadata.
   *
   * Null means withheld — see the denial shape on this type.
   */
  platforms?: Maybe<InheritedPlatforms>;
  /**
   * Projects scoped to this organizational unit. When includeDescendants is true, projects attached to descendant
   * organizational units are also returned.
   */
  projects: Projects;
  /** The resource this organizational unit represents. */
  resource?: Maybe<OrganizationalUnitResource>;
  /**
   * Per-attribute inheritance metadata for the backing resource (e.g. region_key).
   * Each entry is an object: { local, effective, inherited, sourceKey }.
   */
  resourceAttributes?: Maybe<Scalars['Map']['output']>;
  /** An opaque key to identify the resource this organizational unit represents. */
  resourceKey?: Maybe<Scalars['ID']['output']>;
  /** An opaque tag/label to identify the type of resource this organizational unit represents. */
  resourceType?: Maybe<OrganizationalUnitResourceType>;
  /** Root ancestor of this organizational unit. */
  root?: Maybe<OrganizationalUnit>;
  /**
   * Advisory operation answers for this unit. Nullable by contract: the
   * surface is a UX guard, not enforcement, so a consumer that cannot get an
   * answer treats null as not-permitted and degrades — a failed check hop
   * must never take the page data down with it.
   */
  viewerOperationChecks?: Maybe<Array<OrganizationalUnitOperationCheck>>;
};


/**
 * Organizational units are used to represent a hierarchy of resources within the system.
 *
 * These hierarchies are recursive and can be of variable depth. We do not expose this recursion
 * directly on the graph (i.e. no children/parent fields on the OrganizationalUnit type) to
 * avoid having to define a set depth of recursion on the client.
 *
 * Use `organizationalUnits` with the `organization` filter when you already know the
 * organizational unit key.
 *
 * **Denial shape.** The representation ALWAYS resolves for a tenant member: a key
 * the viewer may not read yields a key-only stub, never a null entity. Null on the
 * always-present content fields — `ancestryDepth`, `fullName`, `name`, `platforms`,
 * `config` — therefore means WITHHELD, never "no value"; the accompanying
 * object-level error at that representation's path carries `extensions.code:
 * FORBIDDEN` with a deliberately neutral message that never distinguishes "absent"
 * from "refused". Those five fields are nullable for exactly this reason: non-null
 * content is what forces the executor to null the PARENT, which would take the
 * fields other subgraphs contribute to this object (`viewerOperationChecks`,
 * `grants`) down with it and leave a viewer unable to ask whether they may read
 * this unit at all. Do NOT restore `!` on them, and do NOT read the genuinely
 * tri-state fields (`archivedAt`, `parentKey`, `resourceKey`, `resourceType`,
 * `resource`, `resourceAttributes`) as a denial signal — they are nullable on
 * their own terms.
 */
export type OrganizationalUnitChildrenArgs = {
  filter?: InputMaybe<OrganizationalUnitsFilter>;
  sort?: InputMaybe<Array<OrganizationalUnitSortInput>>;
};


/**
 * Organizational units are used to represent a hierarchy of resources within the system.
 *
 * These hierarchies are recursive and can be of variable depth. We do not expose this recursion
 * directly on the graph (i.e. no children/parent fields on the OrganizationalUnit type) to
 * avoid having to define a set depth of recursion on the client.
 *
 * Use `organizationalUnits` with the `organization` filter when you already know the
 * organizational unit key.
 *
 * **Denial shape.** The representation ALWAYS resolves for a tenant member: a key
 * the viewer may not read yields a key-only stub, never a null entity. Null on the
 * always-present content fields — `ancestryDepth`, `fullName`, `name`, `platforms`,
 * `config` — therefore means WITHHELD, never "no value"; the accompanying
 * object-level error at that representation's path carries `extensions.code:
 * FORBIDDEN` with a deliberately neutral message that never distinguishes "absent"
 * from "refused". Those five fields are nullable for exactly this reason: non-null
 * content is what forces the executor to null the PARENT, which would take the
 * fields other subgraphs contribute to this object (`viewerOperationChecks`,
 * `grants`) down with it and leave a viewer unable to ask whether they may read
 * this unit at all. Do NOT restore `!` on them, and do NOT read the genuinely
 * tri-state fields (`archivedAt`, `parentKey`, `resourceKey`, `resourceType`,
 * `resource`, `resourceAttributes`) as a denial signal — they are nullable on
 * their own terms.
 */
export type OrganizationalUnitProjectsArgs = {
  includeDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  params?: InputMaybe<ProjectsParams>;
};


/**
 * Organizational units are used to represent a hierarchy of resources within the system.
 *
 * These hierarchies are recursive and can be of variable depth. We do not expose this recursion
 * directly on the graph (i.e. no children/parent fields on the OrganizationalUnit type) to
 * avoid having to define a set depth of recursion on the client.
 *
 * Use `organizationalUnits` with the `organization` filter when you already know the
 * organizational unit key.
 *
 * **Denial shape.** The representation ALWAYS resolves for a tenant member: a key
 * the viewer may not read yields a key-only stub, never a null entity. Null on the
 * always-present content fields — `ancestryDepth`, `fullName`, `name`, `platforms`,
 * `config` — therefore means WITHHELD, never "no value"; the accompanying
 * object-level error at that representation's path carries `extensions.code:
 * FORBIDDEN` with a deliberately neutral message that never distinguishes "absent"
 * from "refused". Those five fields are nullable for exactly this reason: non-null
 * content is what forces the executor to null the PARENT, which would take the
 * fields other subgraphs contribute to this object (`viewerOperationChecks`,
 * `grants`) down with it and leave a viewer unable to ask whether they may read
 * this unit at all. Do NOT restore `!` on them, and do NOT read the genuinely
 * tri-state fields (`archivedAt`, `parentKey`, `resourceKey`, `resourceType`,
 * `resource`, `resourceAttributes`) as a denial signal — they are nullable on
 * their own terms.
 */
export type OrganizationalUnitViewerOperationChecksArgs = {
  operations: Array<OrganizationalUnitOperation>;
};

/** Aggregated access to organizational units for a user. */
export type OrganizationalUnitAccess = {
  __typename?: 'OrganizationalUnitAccess';
  /** The single leaf organizational unit available to the user, when only one exists. */
  defaultLeafOrgUnit?: Maybe<OrganizationalUnit>;
  /** The single root organizational unit available to the user, when only one exists. */
  defaultRootOrgUnit?: Maybe<OrganizationalUnit>;
  /** True if the user has access to multiple leaf organizational units (client brands). */
  hasMultipleLeafUnits: Scalars['Boolean']['output'];
  /** True if the user has access to multiple root organizational units (client accounts). */
  hasMultipleRootUnits: Scalars['Boolean']['output'];
};

export type OrganizationalUnitAnchorInput = {
  /** Required when kind=ORGANIZATION_UNIT. Must be omitted when kind=TENANCY. */
  key?: InputMaybe<Scalars['ID']['input']>;
  kind: OrganizationalUnitAnchorKind;
};

export enum OrganizationalUnitAnchorKind {
  OrganizationUnit = 'ORGANIZATION_UNIT',
  Tenancy = 'TENANCY'
}

/** Configuration flags for an organizational unit. */
export type OrganizationalUnitConfig = {
  __typename?: 'OrganizationalUnitConfig';
  /** Whether concept-based workflow is enabled. */
  enableConceptBasedWorkflow: InheritedBool;
  /** Whether logged-out downloading is allowed. */
  loggedOutDownloading: InheritedBool;
  /** Whether pre-approval downloading is allowed. */
  preApprovalDownloading: InheritedBool;
};

export type OrganizationalUnitConfigInput = {
  /** Whether concept-based workflow is enabled. */
  enableConceptBasedWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether logged-out downloading is allowed. */
  loggedOutDownloading?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether pre-approval downloading is allowed. */
  preApprovalDownloading?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationalUnitNodes = {
  __typename?: 'OrganizationalUnitNodes';
  nodes: Array<OrganizationalUnit>;
};

/**
 * Semantic operations on an organizational unit. Values are user-intent
 * affordance verbs, never ACL action IDs.
 */
export enum OrganizationalUnitOperation {
  /**
   * Capability to archive or unarchive the unit: preflights the same ou:write
   * decision the UpdateOrganizationalUnit mutation enforces at the unit —
   * archiving rides that mutation, and both toggle directions ride the same
   * contract. The archived-state branch (archive vs unarchive affordance) is
   * the consumer's; this answer is the permission alone.
   */
  Archive = 'ARCHIVE',
  Attach = 'ATTACH',
  /**
   * Capability to create a child unit — a group or a brand — under this unit:
   * preflights the same ou:write decision the CreateOrganizationalUnit
   * mutation enforces, an organizational-unit create in this (parent) unit's
   * container. Not the point check WRITE answers at the unit itself: its own
   * operation so the check carries the mutation's create-in target exactly.
   * Which parent the new unit lands in (the selected group, or the default
   * when no selector is shown) is the consumer's; this answer is the
   * permission alone.
   */
  CreateChildOrganizationalUnit = 'CREATE_CHILD_ORGANIZATIONAL_UNIT',
  /**
   * Capability to create user-defined SELECT custom-property options in this
   * unit's vocabulary: preflights the same ou:write decision the
   * createCustomPropertyOptions mutation enforces at the unit
   * (docs/custom-properties/create-options/SCOPE.md). Its own operation rather
   * than WRITE so a future narrowing of that write to a dedicated action moves
   * this answer without touching consumers. The definition-level
   * allowUserDefinedOptions flag is the consumer's; this answer is the
   * permission alone.
   */
  CreateCustomPropertyOption = 'CREATE_CUSTOM_PROPERTY_OPTION',
  CreateInvitation = 'CREATE_INVITATION',
  Detach = 'DETACH',
  /**
   * Capability to read the unit: answers the same ou:read check the
   * OrganizationalUnit entity read enforces at the unit — the decision that
   * serves a unit the viewer may not read as a key-only stub beside a FORBIDDEN
   * error. Selected beside `key` alone it preflights readability without
   * fetching any unit content (the check plans to this subgraph only), so a
   * consumer gates on `passes` instead of inferring denial from null content.
   */
  Read = 'READ',
  /**
   * Capability to enable the client account's CreativeX integration on the
   * client's own account: ou:write at this unit AND creativex_account:read as a
   * create under this unit — the account is placed here when first selected.
   */
  SelectOwnCreativeXAccount = 'SELECT_OWN_CREATIVE_X_ACCOUNT',
  /**
   * Capability to enable the client account's CreativeX integration on the
   * tenant-shared workspace: preflights the same pair updateCreativeXIntegration
   * enforces for that selection — ou:write at this (client-account) unit AND
   * creativex_account:read tenancy-wide, the shared workspace's audience being
   * the tenancy by definition. Disabling needs WRITE alone.
   */
  SelectSharedCreativeXAccount = 'SELECT_SHARED_CREATIVE_X_ACCOUNT',
  /**
   * Capability to update an active user-created SELECT custom-property option in
   * this unit's vocabulary: preflights the same ou:write decision the
   * updateCustomPropertyOption mutation enforces at the option's persisted OU.
   * Its own operation keeps this affordance independent from option creation if
   * either contract narrows later.
   */
  UpdateCustomPropertyOption = 'UPDATE_CUSTOM_PROPERTY_OPTION',
  Write = 'WRITE',
  /**
   * Capability to create, edit or archive the unit's audience records from any
   * surface that lists them (the brand's audience library, the concept brief's
   * audience picker): preflights the same ou:write decision the createAudience,
   * updateAudience and archiveAudience mutations enforce at this (brand) unit —
   * the unit the records belong to, the one the brief passes as
   * organizationalUnitKey. Its own operation because the intent is the audience
   * records, not the unit: WRITE answers Brand Profile's whole-unit posture, this
   * answers the picker's New / Edit affordance (ARCHIVE and the custom-property
   * members are the precedent). Which audience a concept selects is the
   * concept's EDIT_BRIEF; this answer is the record-write permission alone.
   */
  WriteAudiences = 'WRITE_AUDIENCES',
  /**
   * Capability to manage the client brand's CreativeX brand mapping: preflights
   * the same conjunction the UpdateCreativeXBrand / RemoveCreativeXBrand
   * mutations enforce — ou:write at this (brand) unit AND creativex_account:read
   * at the CreativeX account the unit's client-account integration selects. A
   * unit whose client account has no integration, or one that has never selected
   * a workspace, answers false, mirroring the mutations' fail-closed refusal;
   * disabling an integration keeps its selection, so a disabled one still answers
   * over the account it selected.
   */
  WriteCreativeXBrand = 'WRITE_CREATIVE_X_BRAND'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * extends OrganizationalUnit with `viewerOperationChecks`); this subgraph
 * contributes the `validation` leg — the domain's registered state
 * invariants.
 */
export type OrganizationalUnitOperationCheck = {
  __typename?: 'OrganizationalUnitOperationCheck';
  authorization: ActionCheckResult;
  operation: OrganizationalUnitOperation;
  organizationalUnitKey: Scalars['ID']['output'];
  /**
   * Pure domain leg: does the unit's state admit this operation. No OU
   * operation carries a domain gate today, so every registered operation
   * answers trivially true (the fleet contract's P4 staging) — the leg
   * exists so future guards land here as server-owned predicates, never as
   * FE-owned rules.
   */
  validation: ActionCheckResult;
};

/** Resources associated with organizational units. */
export type OrganizationalUnitResource = ClientAccount | ClientBrand | ClientGroup;

/** Predicate for matching a resource attribute by key. */
export type OrganizationalUnitResourceAttributePredicate = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  key: Scalars['String']['input'];
};

export type OrganizationalUnitResourceFilter = {
  /** Resource-type-specific filters. */
  attributes?: InputMaybe<Array<OrganizationalUnitResourceAttributePredicate>>;
  /**
   * Nth occurrence of the given resource type in the ancestry (including self).
   * Example: occurrence.eq = 1 means the first matching ancestor/self of that type.
   */
  occurrence?: InputMaybe<IntFilter>;
  type: OrganizationalUnitResourceTypeFilter;
};

export type OrganizationalUnitResourceInput = {
  /** Key of the resource represented by the organizational unit. */
  key: Scalars['ID']['input'];
  /** Type of the resource represented by the organizational unit. */
  type?: InputMaybe<OrganizationalUnitResourceType>;
};

/** The resource types we map organizational units to. */
export enum OrganizationalUnitResourceType {
  ClientAccount = 'CLIENT_ACCOUNT',
  ClientBrand = 'CLIENT_BRAND',
  ClientGroup = 'CLIENT_GROUP'
}

export type OrganizationalUnitResourceTypeFilter = {
  eq?: InputMaybe<OrganizationalUnitResourceType>;
  in?: InputMaybe<Array<OrganizationalUnitResourceType>>;
  notIn?: InputMaybe<Array<OrganizationalUnitResourceType>>;
};

/** Sort fields supported for organizational units. */
export enum OrganizationalUnitSortFieldEnum {
  Ancestry = 'ANCESTRY',
  FullName = 'FULL_NAME',
  Name = 'NAME',
  RegionName = 'REGION_NAME'
}

/** Sort options for organizational units. */
export type OrganizationalUnitSortInput = {
  /** Field to sort results by. */
  field: OrganizationalUnitSortFieldEnum;
  /** Direction to sort results. */
  order: SortOrder;
};

export type OrganizationalUnits = {
  __typename?: 'OrganizationalUnits';
  meta: OffsetPageInfo;
  nodes: Array<OrganizationalUnit>;
};

export type OrganizationalUnitsFilter = {
  /**
   * Filter organizational units by their depth in the hierarchy.
   * Depth 0 represents the root client account, depth 1 represents the first
   * level of descendants (e.g. regions), and so on.
   */
  ancestryDepth?: InputMaybe<IntFilter>;
  /**
   * Filter to active/archived records, or both
   * Default: FALSE
   */
  archived?: InputMaybe<ArchivedFilter>;
  fullName?: InputMaybe<StringFilter>;
  key?: InputMaybe<IdFilter>;
  /** Filter organizational units by their name. */
  name?: InputMaybe<StringFilter>;
  /**
   * Return an organization hierarchy, starting from the given key (e.g. the
   * organizational unit that matches the given key plus all of its children)
   */
  organization?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Filter organizational units by resource type and an optional depth within that type.
   * Depth is evaluated relative to the root of the selected organization, counting only
   * ancestors (including self) whose resource type matches the provided type filter.
   */
  resource?: InputMaybe<OrganizationalUnitResourceFilter>;
  resourceKey?: InputMaybe<IdFilter>;
  resourceType?: InputMaybe<OrganizationalUnitResourceTypeFilter>;
};

export type OrganizationalUnitsParams = {
  filter?: InputMaybe<OrganizationalUnitsFilter>;
  pagination?: InputMaybe<OffsetPagination>;
  /**
   * Sort the results by the given fields.
   *
   * Supported fields:
   * - ANCESTRY
   * - FULL_NAME
   * - NAME
   * - REGION_NAME
   *
   * Default: [{ field: NAME, order: ASC }]
   */
  sort?: InputMaybe<Array<OrganizationalUnitSortInput>>;
};

export enum OriginalInputType {
  ImagesOnly = 'images_only',
  Unknown = 'unknown',
  VideoAndImages = 'video_and_images',
  VideoOnly = 'video_only'
}

/** OU filtering modes for template briefs. */
export enum OuFilterMode {
  /** Template is available to all organizational units by default. */
  Default = 'DEFAULT',
  /** Template is available to all organizational units except specifically excluded ones. */
  Exclude = 'EXCLUDE',
  /** Template is only available to specifically included organizational units. */
  Include = 'INCLUDE'
}

export enum OverlayType {
  Placement = 'Placement',
  Safezone = 'Safezone'
}

export enum PendingBriefAction {
  /** There is currently no action to be taken on this brief. */
  None = 'NONE',
  /** The brief is waiting to be submitted for asset production by a UGC creator. */
  SubmitForAssetProduction = 'SUBMIT_FOR_ASSET_PRODUCTION',
  /** The brief is waiting to be submitted for review by a Creative Specialist. */
  SubmitForCsReview = 'SUBMIT_FOR_CS_REVIEW',
  /** The brief is waiting to be submitted for review by the production team. */
  SubmitForProductionReview = 'SUBMIT_FOR_PRODUCTION_REVIEW',
  /** The brief is waiting to be submitted for UGC ideation. */
  SubmitForUgcIdeation = 'SUBMIT_FOR_UGC_IDEATION',
  /** NOT A REAL ACTION, DO NOT USE. */
  Unspecified = 'UNSPECIFIED'
}

/** Mutation payload for planInvitationGrants. */
export type PlanInvitationGrantsInput = {
  invitationKey: Scalars['String']['input'];
  plannedGrants: Array<GrantAssignmentInput>;
};

/** A Platform */
export type Platform = {
  __typename?: 'Platform';
  archivedAt?: Maybe<Scalars['Time']['output']>;
  clientFilter: PlatformClientFilter;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  platformTrelloLabel?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

export enum PlatformAvailability {
  ActiveQuestionBacked = 'ACTIVE_QUESTION_BACKED',
  All = 'ALL'
}

export enum PlatformClientFilter {
  Disabled = 'disabled',
  Excluded = 'excluded',
  Included = 'included'
}

export type PlatformInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum PreflightStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

/**
 * A reference to an actor in the system. The entity itself carries no facts:
 * resolving a reference discloses nothing, and each tier hangs off its own
 * action-governed field.
 */
export type Principal = {
  __typename?: 'Principal';
  grants: PrincipalGrantConnection;
  key: Scalars['ID']['output'];
  /** Governance facts about the principal record; resolves under the viewer's principal:read plan. */
  metadata?: Maybe<PrincipalMetadata>;
  /** Display identity for the principal's user; null for principals without a user or viewers without profile:read. */
  profile?: Maybe<Profile>;
  /** The full user record; resolves under the viewer's principal:read plan. */
  user?: Maybe<User>;
};


/**
 * A reference to an actor in the system. The entity itself carries no facts:
 * resolving a reference discloses nothing, and each tier hangs off its own
 * action-governed field.
 */
export type PrincipalGrantsArgs = {
  input?: InputMaybe<PrincipalGrantParams>;
};

/** A grant binds a principal to a role within a specific scope. */
export type PrincipalGrant = {
  __typename?: 'PrincipalGrant';
  activatedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  invitation?: Maybe<Invitation>;
  key: Scalars['ID']['output'];
  principal?: Maybe<Principal>;
  revokedAt?: Maybe<Scalars['Time']['output']>;
  role: Role;
  scope: PrincipalGrantScope;
  source: GrantSource;
  status: GrantStatus;
  updatedAt: Scalars['Time']['output'];
};

export type PrincipalGrantConnection = {
  __typename?: 'PrincipalGrantConnection';
  nodes: Array<PrincipalGrant>;
  pageInfo: OffsetPageInfo;
};

export type PrincipalGrantFilter = {
  atScopes?: InputMaybe<Array<GrantScopeInput>>;
};

export type PrincipalGrantParams = {
  filter?: InputMaybe<PrincipalGrantFilter>;
  pagination?: InputMaybe<OffsetPagination>;
};

/**
 * Structured scope anchor for a principal grant. Consumers can hydrate the
 * appropriate reference based on `kind`.
 */
export type PrincipalGrantScope = {
  __typename?: 'PrincipalGrantScope';
  key: Scalars['ID']['output'];
  kind: GrantScopeKind;
  target?: Maybe<PrincipalGrantScopeTarget>;
};

export type PrincipalGrantScopeTarget = Concept | GrantTenant | OrganizationalUnit;

export enum PrincipalKind {
  Group = 'group',
  Service = 'service',
  Unknown = 'unknown',
  User = 'user'
}

/** Governance facts about a principal record. */
export type PrincipalMetadata = {
  __typename?: 'PrincipalMetadata';
  archivedAt?: Maybe<Scalars['Time']['output']>;
  kind: PrincipalKind;
};

/**
 * The viewer's own settings in this tenant, held on their principal. Only user
 * principals have preferences; service and group principals have none.
 */
export type PrincipalPreferences = {
  __typename?: 'PrincipalPreferences';
  /** Product-analytics consent: on unless the viewer turns it off. */
  tracking: TrackingConsent;
};

/**
 * A reference to a principal by its key — the input-side shape of a Principal
 * entity reference (inputs cannot carry entity types).
 */
export type PrincipalRefInput = {
  key: Scalars['ID']['input'];
};

export type Principals = {
  __typename?: 'Principals';
  meta: OffsetPageInfo;
  nodes: Array<Principal>;
};

export type PrincipalsFilter = {
  archived?: InputMaybe<ArchivedFilter>;
  key?: InputMaybe<IdFilter>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<PrincipalKind>;
  /**
   * Principals who are members of the selected scope — the authz service's
   * grant-derived membership projection (a principal is a member while they
   * hold at least one ACTIVE grant anchored at the scope). Anchors are
   * organizational_unit only (subtree with includeDescendants), and the
   * caller must hold ou:read over the anchor. Ancestor- and tenancy-wide
   * holders are NOT included — use users(filter: { resourceAccess }) for
   * effective can-do-action intersection.
   */
  memberOfScope?: InputMaybe<GrantScopeSelector>;
};

export type PrincipalsParams = {
  filter?: InputMaybe<PrincipalsFilter>;
  pagination?: InputMaybe<OffsetPagination>;
  sort?: InputMaybe<PrincipalsSortInput>;
};

export enum PrincipalsSortField {
  CreatedAt = 'CREATED_AT',
  Key = 'KEY',
  Kind = 'KIND',
  /** Orders by the principal's user email (principals without a user sort last). */
  UserEmail = 'USER_EMAIL',
  /** Orders by the principal's user display name (principals without a user sort last). */
  UserFullName = 'USER_FULL_NAME'
}

export type PrincipalsSortInput = {
  field: PrincipalsSortField;
  order: SortOrder;
};

/**
 * Display-tier identity for a user key: enough to render a name and a face.
 * Resolution is guarded by profile:read on the tenancy; full principal data
 * stays on User behind principal read access.
 */
export type Profile = {
  __typename?: 'Profile';
  /** URL to the avatar image. */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Display name for rendering: first name and last initial. */
  displayName: Scalars['String']['output'];
  /** A unique identifier for the profile; shares the user key space. */
  key: Scalars['ID']['output'];
  /** The full user record when the viewer holds principal read access. */
  user?: Maybe<User>;
};

/** A Project. */
export type Project = {
  __typename?: 'Project';
  amplifyDemoImports: AmplifyDemoImports;
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** Whether the current user can download project deliverables. */
  canDownload: Scalars['Boolean']['output'];
  clientAccount: ClientAccount;
  clientBrand: ClientBrand;
  /** @deprecated Retained for existing clients; no replacement field is currently available. */
  collaborators: ProjectCollaborators;
  /**
   * The Project's Concepts the viewer can read, each once, whatever the request
   * searched or paged. Omitted, null or false counts the Concepts that are not
   * archived; true counts every one, archived Concepts included. Null with an
   * error when the Project is not readable.
   */
  conceptCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The Project's Concepts the viewer can read, by workflow stage, each once,
   * under the filter's archive option and whatever the request searched, paged
   * or matched by membership. total is their count, the conceptCount of the same
   * archive option. stages lists every stage once, zero included, in workflow
   * order with UNSPECIFIED (a Concept with no stage, or one the workflow does not
   * recognise) last, so their counts sum to total. Null with an error when the
   * Project is not readable.
   */
  conceptStatusSummary?: Maybe<ConceptStatusSummary>;
  concepts: Concepts;
  /** The prompt used to generate the project brief via the brief assistant. */
  copilotPrompt?: Maybe<Scalars['String']['output']>;
  creativeXEnabled: Scalars['Boolean']['output'];
  /**
   * Stored custom property values for this project. Definitions are federated
   * from the custom-properties subgraph as `customPropertyDefinitions`; clients
   * join the two lists on `definition.key == value.definitionKey`.
   */
  customProperties: Array<CustomPropertyCheckbox | CustomPropertyDate | CustomPropertyNumber | CustomPropertyRichText | CustomPropertySelect | CustomPropertyText | CustomPropertyUser>;
  /**
   * Applicable custom property definitions for this project: active PROJECT
   * definitions whose availability scopes resolve to the project's
   * organizational unit or one of its ancestors.
   */
  customPropertyDefinitions: Array<CustomPropertyDefinition>;
  /**
   * The project's deliverables — every version, every status, archived
   * excluded; the viewer's heads alone under `filter.latestOnly` — filtered
   * and paginated per project. Hero deliverables order first, then creation
   * order (oldest first). `meta.recordCount` is the exact count of matches
   * past the page window. Rows the caller may not read are absent and
   * uncounted. Not fence-capable yet: the page's
   * `convergence` is the constant no-claim meta (the upload page reloads
   * through `DeliverableSpecification.deliverables(atLeast:)`).
   */
  deliverables: Deliverables;
  dueDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Constant for every live project. */
  effectiveState: OrderState;
  /** External URL associated with this project, when one exists. */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /**  The generative AI preferences currently applicable for this project.  */
  generativeAIPreferences: Array<GenerativeAiPreference>;
  /**
   * The HubSpot deal associated with this project. This will be null until a deal or the no deal assigned option is
   * selected.
   *
   * Requires authorization and will be null without the correct permissions.
   */
  hubspotDeal?: Maybe<HubspotDealSelection>;
  /** @deprecated Use 'key' instead */
  integrationKey: Scalars['ID']['output'];
  /** @deprecated Constant for every live project. */
  isFinalStep: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  lastActivity?: Maybe<AttributedTime>;
  /** @deprecated Use Project instead. Fields to be moved to Project. */
  legacyOrder?: Maybe<Order>;
  members?: Maybe<Array<ProjectMember>>;
  name: Scalars['String']['output'];
  /**
   * The organizational unit persisted on this Project. Null for legacy Projects
   * without a persisted organizational-unit association.
   */
  organizationalUnit?: Maybe<OrganizationalUnit>;
  regionKey?: Maybe<Scalars['ID']['output']>;
  serialId: Scalars['String']['output'];
  /** @deprecated Use concepts instead. */
  specificationConcepts: Array<SpecificationConcept>;
  /**
   * The Project's physical specification rows under its Concepts the viewer can
   * read, each row once. Omitted, null or false counts the rows that are not
   * archived, by their own status or their Concept's; true counts every row,
   * archived rows and archived Concepts included. Null with an error when the
   * Project is not readable.
   */
  specificationCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Constant for every live project. */
  state: OrderState;
  totalSpecificationsOrdered?: Maybe<Scalars['Int']['output']>;
  /**
   * Advisory operation answers for this project. Nullable by contract (the
   * OrganizationalUnit viewer-action precedent): the surface is a UX guard,
   * not enforcement, so a consumer that cannot get an answer treats null as
   * not-permitted and degrades — a failed check hop must never take the page
   * data down with it.
   */
  viewerOperationChecks?: Maybe<Array<ProjectOperationCheck>>;
};


/** A Project. */
export type ProjectAmplifyDemoImportsArgs = {
  params?: InputMaybe<AmplifyDemoImportsParams>;
};


/** A Project. */
export type ProjectConceptCountArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Project. */
export type ProjectConceptStatusSummaryArgs = {
  filter?: InputMaybe<ConceptStatusFilter>;
};


/** A Project. */
export type ProjectConceptsArgs = {
  params?: InputMaybe<ConceptsParams>;
};


/** A Project. */
export type ProjectDeliverablesArgs = {
  params?: InputMaybe<DeliverablesParams>;
};


/** A Project. */
export type ProjectSpecificationCountArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Project. */
export type ProjectViewerOperationChecksArgs = {
  operations: Array<ProjectOperation>;
};

export type ProjectAccessSettings = {
  __typename?: 'ProjectAccessSettings';
  id: Scalars['ID']['output'];
  integrationKey: Scalars['ID']['output'];
  visibility: ProjectVisibility;
};

export type ProjectBrief = {
  __typename?: 'ProjectBrief';
  /** The concepts that make up this brief. */
  concepts: Array<Concept>;
  /** The notes for the CS review. */
  csReviewNote?: Maybe<Scalars['String']['output']>;
  /** HACK: Apollo Client cache key */
  id: Scalars['ID']['output'];
  /** The next action that should be taken on this brief. */
  pendingAction: PendingBriefAction;
  /** The integration key of the project this brief belongs to. */
  projectIntegrationKey: Scalars['ID']['output'];
};

/** An answer to a CES question. */
export type ProjectCesAnswerInput = {
  /** CES comment for the question. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** CES question text the user was asked. */
  question: Scalars['String']['input'];
  /** CES rating for the question. */
  rating: CesRating;
};

export type ProjectCesAnswersInput = {
  creativeQuality: ProjectCesAnswerInput;
  deliveryTime: ProjectCesAnswerInput;
  gettingStarted: ProjectCesAnswerInput;
  platform: ProjectCesAnswerInput;
  supportAndServices: ProjectCesAnswerInput;
};

/** Project CES mutation input. */
export type ProjectCesInput = {
  /** CES answers for the given project. */
  answers?: InputMaybe<ProjectCesAnswersInput>;
  /** Client integration key. */
  clientIntegrationKey: Scalars['ID']['input'];
  /** Client name. */
  clientName: Scalars['String']['input'];
  /**
   * CES comment for the given project.
   * @deprecated Use `answers` instead.
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Client Partner email. */
  cpEmail?: InputMaybe<Scalars['String']['input']>;
  /** Customer Success Manager email. */
  csmEmail?: InputMaybe<Scalars['String']['input']>;
  /** Hubspot Company ID. */
  hubspotCompanyId?: InputMaybe<Scalars['Uint64']['input']>;
  /** Project integration key. */
  projectIntegrationKey: Scalars['ID']['input'];
  /** Project name. */
  projectName: Scalars['String']['input'];
  /**
   * CES rating for the given project.
   * @deprecated Use `answers` instead.
   */
  rating?: InputMaybe<CesRating>;
  /** Contact email for who submitted the project. */
  submittedByEmail: Scalars['String']['input'];
  /** Name of who submitted the project. */
  submittedByName: Scalars['String']['input'];
};

/** The people on a project: its owner and the merged project team. */
export type ProjectCollaborators = {
  __typename?: 'ProjectCollaborators';
  /** The owner of the project. */
  owner?: Maybe<Profile>;
  /** Internal-only project key for federation. */
  projectKey: Scalars['ID']['output'];
  /**
   * Everyone on the project besides the owner: explicitly added members and the
   * brand's assigned team, merged and deduplicated.
   */
  projectTeam: Array<ProjectTeamMember>;
};

/** Project CSAT mutation input. */
export type ProjectCsatInput = {
  /** Client integration key. */
  clientIntegrationKey: Scalars['ID']['input'];
  /** Client name. */
  clientName: Scalars['String']['input'];
  /** CSAT comment for the given project. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Client Partner email. */
  cpEmail?: InputMaybe<Scalars['String']['input']>;
  /** Customer Success Manager email. */
  csmEmail?: InputMaybe<Scalars['String']['input']>;
  /** Hubspot Company ID. */
  hubspotCompanyId?: InputMaybe<Scalars['Uint64']['input']>;
  /** Project integration key. */
  projectIntegrationKey: Scalars['ID']['input'];
  /** Project name. */
  projectName: Scalars['String']['input'];
  /** CSAT rating for the given project. */
  rating: CsatRating;
  /** CSAT reason for the given rating. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Reviewer contact email. */
  reviewerEmail: Scalars['String']['input'];
  /** Reviewer name. */
  reviewerName: Scalars['String']['input'];
};

export type ProjectDueDatePayload = {
  __typename?: 'ProjectDueDatePayload';
  changed: Scalars['Boolean']['output'];
  project: Project;
};

export type ProjectFilters = {
  /** Indicates whether archived projects can be retrieved. Defaults to FALSE. */
  includeArchived?: InputMaybe<ArchivedFilter>;
};

export type ProjectMember = {
  __typename?: 'ProjectMember';
  principal: Principal;
  removal: ProjectMemberRemoval;
};

export type ProjectMemberRemoval = {
  __typename?: 'ProjectMemberRemoval';
  /** Viewer may remove the ordinary assignment; property assignments can retain membership. */
  allowed: Scalars['Boolean']['output'];
  retainedBy: Array<MemberPropertyAssignment>;
};

/**
 * Semantic operations on a project. Values are user-intent affordance verbs
 * (the viewerActionChecks re-keying, docs/viewer-operation-checks/SCOPE.md),
 * never ACL action IDs: the enforcement actions are the authz subgraph's
 * registry concern while the state predicates live here. The enum is declared
 * identically in both subgraphs.
 */
export enum ProjectOperation {
  CreateUgcOrder = 'CREATE_UGC_ORDER',
  /**
   * Capability to edit the project itself (its own fields, such as its name or
   * custom property values): preflights the same project:write decision those
   * writes enforce at the project.
   */
  Edit = 'EDIT',
  InviteCollaborators = 'INVITE_COLLABORATORS',
  ManageCollaborators = 'MANAGE_COLLABORATORS',
  NavigateToBrand = 'NAVIGATE_TO_BRAND',
  ProductionBrief = 'PRODUCTION_BRIEF',
  UploadDeliverables = 'UPLOAD_DELIVERABLES',
  ViewCollaborators = 'VIEW_COLLABORATORS',
  WriteCommercials = 'WRITE_COMMERCIALS'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * extends Project with `viewerOperationChecks`); this subgraph contributes the
 * `validation` leg — the domain's registered state invariants.
 */
export type ProjectOperationCheck = {
  __typename?: 'ProjectOperationCheck';
  authorization: ActionCheckResult;
  operation: ProjectOperation;
  projectKey: Scalars['ID']['output'];
  /**
   * Pure domain leg: does project state admit this operation. Caller-blind —
   * every project operation is access-gated only today, so each answers its
   * registered trivially-true predicate (the fleet contract's P4 staging);
   * a domain gate promoted later lands here without a wire change.
   */
  validation: ActionCheckResult;
};

export type ProjectSortOptionsInput = {
  conceptCount?: InputMaybe<ConceptCountSortInput>;
  /** Archive option of the specificationCount sort. */
  specificationCount?: InputMaybe<SpecificationCountSortInput>;
  /** Archive option of the whole-Project status sort. */
  status?: InputMaybe<ConceptStatusFilter>;
};

/** One person on a project's team. */
export type ProjectTeamMember = {
  __typename?: 'ProjectTeamMember';
  profile: Profile;
  /**
   * Whether removing this person from the project fully detaches them. False for
   * people whose access derives from the brand's assigned team.
   */
  removable: Scalars['Boolean']['output'];
};

export enum ProjectVisibility {
  Private = 'Private',
  Public = 'Public'
}

export type Projects = {
  __typename?: 'Projects';
  /**
   * Facet option lists of the search dialect (`Query.projects(search:)`).
   * Selection-driven: no aggregation runs unless selected. Selecting it
   * without `search` fails with a bad-request error. `mode` picks the
   * population every facet is computed over; absent = REACTIVE, the
   * disjunctive faceting searchVersion V1 serves. The mode argument is
   * searchVersion V2 only.
   */
  facets: ProjectsFacets;
  /**
   * Page metadata of the legacy dialect (`params`). Selecting it with
   * `search` fails with a bad-request error.
   */
  meta: OffsetPageInfo;
  nodes: Array<Project>;
  /**
   * Page metadata of the search dialect (`Query.projects(search:)`).
   * Selecting it without `search` fails with a bad-request error.
   */
  searchMeta: ProjectsSearchMeta;
};


export type ProjectsFacetsArgs = {
  mode?: InputMaybe<ProjectsFacetMode>;
};

/**
 * Forward-only cursor paging. A cursor binds the request's sort: a malformed
 * token, or one replayed under another sort, fails with a bad-request error.
 */
export type ProjectsCursorPagination = {
  /** Opaque resumption cursor from a prior page's searchMeta.endCursor. Absent = the first page. */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page size. A server default applies when absent; a size below one or
   * beyond the server cap fails with a bad-request error.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** searchVersion V2 only. Presence selects numbered mode; omit after entirely. Requires an explicit limit. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * One facet's option list plus the completeness signal that drives the
 * client's option-search mode. `match`: case-insensitive text predicate over
 * option values (additionally accent-insensitive on the folded clientNames
 * and brandNames facets); prefix matches rank before contains matches.
 */
export type ProjectsFacet = {
  __typename?: 'ProjectsFacet';
  /**
   * True when options holds every distinct value for this facet under the
   * query that produced it (any match included); false when the list was
   * truncated at the server cap. Complete ⇒ refine locally; incomplete ⇒
   * re-query with match.
   */
  isComplete: Scalars['Boolean']['output'];
  options: Array<ProjectsFacetOption>;
};

/**
 * The population a Projects facet is computed over (the facets field's
 * `mode`). searchVersion V2 only; absent = REACTIVE.
 */
export enum ProjectsFacetMode {
  /**
   * The archive lens population, before the keyword and every filter, so
   * options do not narrow as filters are chosen. brandNames is the one
   * coupling: its options are the Brands under the selected clientNames, and
   * empty unless filter.clientNames is set, as on the Concept collection.
   */
  Broad = 'BROAD',
  /**
   * Each facet under the keyword and every active filter except its own
   * selections (disjunctive faceting). The default, and what searchVersion V1
   * serves.
   */
  Reactive = 'REACTIVE'
}

export type ProjectsFacetOption = {
  __typename?: 'ProjectsFacetOption';
  /**
   * Number of projects in the facet's population carrying this value: under
   * REACTIVE, the matches of every active filter except this facet's own
   * selections.
   */
  count: Scalars['Int']['output'];
  /** The facet value (for clientNames and brandNames: a representative original casing of the folded label). */
  value: Scalars['String']['output'];
};

/**
 * Facet option lists over the population the facets field's mode names.
 * Under REACTIVE, the default, each facet is computed under the keyword and
 * every active filter except its own selections (disjunctive faceting), so
 * every option has at least one match under everything else selected; under
 * BROAD, over the archive lens population. Options are in ascending order and
 * capped server-side.
 */
export type ProjectsFacets = {
  __typename?: 'ProjectsFacets';
  /** Brand name options: folded label classes with a representative original casing. */
  brandNames: ProjectsFacet;
  /** Client account name options: folded label classes with a representative original casing. */
  clientNames: ProjectsFacet;
  /** Brand industry vertical options. searchVersion V1 only. */
  industryNames: ProjectsFacet;
  /** Sales territory options. searchVersion V1 only. */
  salesTerritories: ProjectsFacet;
};


/**
 * Facet option lists over the population the facets field's mode names.
 * Under REACTIVE, the default, each facet is computed under the keyword and
 * every active filter except its own selections (disjunctive faceting), so
 * every option has at least one match under everything else selected; under
 * BROAD, over the archive lens population. Options are in ascending order and
 * capped server-side.
 */
export type ProjectsFacetsBrandNamesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the population the facets field's mode names.
 * Under REACTIVE, the default, each facet is computed under the keyword and
 * every active filter except its own selections (disjunctive faceting), so
 * every option has at least one match under everything else selected; under
 * BROAD, over the archive lens population. Options are in ascending order and
 * capped server-side.
 */
export type ProjectsFacetsClientNamesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the population the facets field's mode names.
 * Under REACTIVE, the default, each facet is computed under the keyword and
 * every active filter except its own selections (disjunctive faceting), so
 * every option has at least one match under everything else selected; under
 * BROAD, over the archive lens population. Options are in ascending order and
 * capped server-side.
 */
export type ProjectsFacetsIndustryNamesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Facet option lists over the population the facets field's mode names.
 * Under REACTIVE, the default, each facet is computed under the keyword and
 * every active filter except its own selections (disjunctive faceting), so
 * every option has at least one match under everything else selected; under
 * BROAD, over the archive lens population. Options are in ascending order and
 * capped server-side.
 */
export type ProjectsFacetsSalesTerritoriesArgs = {
  match?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectsFilter = {
  key?: InputMaybe<IdFilter>;
  /**
   * Exclude projects in the provided states.
   * @deprecated Project state is retired.
   */
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectsParams = {
  filter?: InputMaybe<ProjectsFilter>;
  pagination?: InputMaybe<OffsetPagination>;
};

/**
 * Search dialect filters. All are optional: values within one list OR,
 * distinct filters AND. A list filter distinguishes absent from empty —
 * absent applies no predicate, an empty list matches nothing.
 */
export type ProjectsSearchFilter = {
  /**
   * Archived lens. Absent = FALSE: live projects only. TRUE = archived
   * projects only; INCLUDE = both.
   */
  archived?: InputMaybe<ArchivedFilter>;
  /** Brand display names. Folded label predicate, as for clientNames. */
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Client account display names. Folded (case- and accent-insensitive)
   * equality against the client's name — a label predicate over the corpus,
   * NOT an entity selection: every client sharing the folded name matches.
   * Values need not come from the facet; unknown names match nothing.
   */
  clientNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** searchVersion V2 only. UNSPECIFIED is a summary fallback and a bad request here. */
  conceptStages?: InputMaybe<Array<WorkflowStageCode>>;
  /** Bounds on the project's creation time. */
  createdAt?: InputMaybe<TimeFilter>;
  /** searchVersion V2 only. */
  dueDate?: InputMaybe<DateFilter>;
  /** Brand industry verticals. Exact equality. searchVersion V1 only. */
  industryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Project key predicate; eq and in combine with AND. */
  key?: InputMaybe<IdFilter>;
  /**
   * Free-text predicate that never reorders results: a project matches when
   * ANY word matches in ANY of project name, serial id, client account name,
   * brand name and sales territory; the final word may match as a prefix
   * (type-ahead); case-insensitive, and accent-insensitive where the
   * underlying text is folded. searchVersion V1 only.
   */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /**
   * Tracker name search, searchVersion V2 only. Terms split on whitespace and on
   * separating punctuation such as hyphens; case, Latin-script accents and
   * apostrophes inside names are ignored (the folding and its limits are stated
   * once, in the W19 query contract's "Normalization and null inputs"). Every
   * term must match a whole word, or the start of one,
   * in the Project's name, its Client or Brand name, the names of its readable
   * non-archived Concepts, or the Platform or Format names of their
   * non-archived specifications; different Concepts may supply different terms.
   * Blank text removes only the text restriction and is still an input. Never
   * reorders results. Not with keyword.
   */
  keyword_v2?: InputMaybe<Scalars['String']['input']>;
  /** searchVersion V2 only. */
  lastActivity?: InputMaybe<TimeComparisonFilter>;
  /** searchVersion V2 only. */
  members?: InputMaybe<MemberFilter>;
  /** @deprecated Use keyword_v2 with searchVersion V2. */
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Sales territory (project region) display names. Exact equality. searchVersion V1 only. */
  salesTerritories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Project visibility. */
  visibility?: InputMaybe<ProjectVisibility>;
};

/**
 * Page metadata of the search dialect. Cursor-paged: resume with
 * pagination.after = the previous page's endCursor.
 */
export type ProjectsSearchMeta = {
  __typename?: 'ProjectsSearchMeta';
  /**
   * Opaque cursor resuming after this page; null when hasNextPage is false.
   * A cursor is a sort boundary, not a page number or server-side context:
   * it never expires and carries no scope authority.
   */
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  /** Numbered-mode navigation at PROJECT grain. Null in cursor mode. */
  numberedPage?: Maybe<TrackerNumberedPage>;
  /** Exact total of matching projects. Computed only when selected. */
  recordCount: Scalars['Int']['output'];
};

/** The search dialect of Query.projects. */
export type ProjectsSearchParams = {
  filter?: InputMaybe<ProjectsSearchFilter>;
  pagination?: InputMaybe<ProjectsCursorPagination>;
  /**
   * Search implementation. Omitted or null is V1, the current path; V2 is the
   * Tracker path. An input described as one version's only is a bad request
   * under the other.
   */
  searchVersion?: InputMaybe<SearchVersion>;
  /**
   * Result order. Field vocabulary: createdAt, name, serialId; searchVersion
   * V2 adds clientName, brandName, status, conceptCount, specificationCount,
   * lastActivity and dueDate. Absent = createdAt DESC. The server appends key
   * ASC as the terminal tie-break, so every order is total; a project missing
   * a sort value sorts last. Unsupported fields fail with a bad-request error.
   */
  sort?: InputMaybe<Array<SortInput>>;
  /**
   * Sort populations, searchVersion V2 only. An option shapes its own sort,
   * never which results return; an option for a sort the request does not
   * order by is a bad request.
   */
  sortOptions?: InputMaybe<ProjectSortOptionsInput>;
};

export type QualityAssuranceReport = {
  __typename?: 'QualityAssuranceReport';
  id: Scalars['ID']['output'];
  results?: Maybe<QualityAssuranceReportResults>;
  status: QualityAssuranceReportStatus;
};

export type QualityAssuranceReportCategory = {
  __typename?: 'QualityAssuranceReportCategory';
  category: ReportItemCategory;
  items: Array<QualityAssuranceReportItem>;
  score: ReportItemCategoryScore;
};

export type QualityAssuranceReportItem = {
  __typename?: 'QualityAssuranceReportItem';
  feedback?: Maybe<Scalars['String']['output']>;
  key: Scalars['ID']['output'];
  score: ReportItemScore;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export enum QualityAssuranceReportResultState {
  Fail = 'FAIL',
  Pass = 'PASS',
  Review = 'REVIEW'
}

export type QualityAssuranceReportResults = {
  __typename?: 'QualityAssuranceReportResults';
  id: Scalars['ID']['output'];
  reportTopics: Array<QualityAssuranceReportTopic>;
  resultState: QualityAssuranceReportResultState;
};

export enum QualityAssuranceReportStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type QualityAssuranceReportTopic = {
  __typename?: 'QualityAssuranceReportTopic';
  categories: Array<QualityAssuranceReportCategory>;
  topic: ReportItemTopic;
};

export type Query = {
  __typename?: 'Query';
  _conceptBriefSection: ConceptBriefSection;
  _ugcBrief: UgcBrief;
  accessControl: AccessControlQuery;
  adverts: Adverts;
  amplifyMultiformatTemplate: AmplifyMultiformatTemplate;
  /** Retrieve analytics dashboards for the current user. */
  analyticsDashboards: AnalyticsDashboards;
  audience?: Maybe<Audience>;
  audienceDefaultForBrand?: Maybe<Audience>;
  audienceSubstitutions: Array<Maybe<AudienceSubstitution>>;
  audiences: Array<Audience>;
  brandProfile: BrandProfile;
  /** Check whether the current user can update a brief's CS review notes. */
  canUpdateCsReviewNotes: Scalars['Boolean']['output'];
  /** Classification administration (cohorts & treatments). */
  classification: ClassificationQuery;
  /**  Get the client account for the current user.  */
  clientAccount: ClientAccount;
  /** Get the client account for the current user. */
  clientBrand: ClientBrand;
  /** Get information for a specific Concept. */
  conceptV2: Concept;
  /**
   * The concepts collection. Scope is derived from the caller's
   * authorization plan; there is no caller-supplied scope input. Search is
   * not a mode — keyword and every other predicate are optional filter
   * args — and neither is grouping: groupBy: PROJECT turns the page into
   * one group per project (pagination then operates on groups). The
   * filter.approval lens picks the corpus — absent = APPROVED (the
   * creative-library default), ANY = every non-archived concept. Flat
   * default order: approvalTime descending with key as a stable tiebreak;
   * grouped default: groups by projectCreatedAt descending, concepts
   * within a group by serialNumber ascending.
   */
  concepts: ConceptsCollection;
  copySuggestions: Array<CopySuggestion>;
  /**
   * The CreativeX accounts the viewer can read within the active tenant: the
   * in-tenant account rows filtered per key by the same creativex_account:read
   * decision every account read carries. A viewer with no reach sees an empty
   * list.
   */
  creativeXAccounts: Array<CreativeXAccount>;
  /** Retrieve an individual creator by its Key. */
  creator: Creator;
  creatorAttributes: CreatorAttributes;
  creatorOffer: CreatorOffer;
  /**
   * Public profile tier of an approved creator. Nullable by design: an
   * absent key, an unapproved or archived profile, and a refused lookup
   * all render null — none is distinguishable from the others.
   */
  creatorProfile?: Maybe<CreatorProfile>;
  /** Search creators. */
  creators: CreatorSearchResult;
  /** Return custom property definitions for the selected record kind. */
  customPropertyDefinitions: Array<CustomPropertyDefinition>;
  /**
   * One deliverable by key. An archived deliverable is served, reading
   * `archivedAt`, under the same access rule as a live one: a reference by key
   * resolves after the row it names is archived
   * (docs/deliverable-keyed-reads-archived/SCOPE.md). A row still awaiting
   * placement — holding no specification, its current attempt unanswered or
   * refused — is not found here until it is placed
   * (docs/deliverable-status-seam/SCOPE.md, D-B0-6-D (a)); the save that parked
   * it returns it in its own payload.
   */
  deliverable: Deliverable;
  deliverableFormats: DeliverableFormats;
  deliverableFormatsByKeys: DeliverableFormats;
  /**
   * The project-fenced deliverables collection — the graph replacement for
   * search-api's deliverables msearch lane, served from the CDC-projected
   * deliverables_v2 index. Scope is derived from the caller's
   * deliverable:read authorization plan; there is no caller-supplied scope
   * input. The plan also owns the row-visibility and latest-version
   * semantics the retired lane derived from roles: which rows a caller sees
   * (whether not-yet-review-stage versions are reachable, public-project
   * reach) and which latest-version head `latestVersionOnly` follows ride
   * the plan's conditions. Facet work is selection-driven server-side.
   * Result order is fixed and deterministic: concept position ascending,
   * then deliverable key ascending. A row still awaiting placement is
   * outside the collection's corpus — its page, total and facets alike
   * (docs/deliverable-status-seam/SCOPE.md, D-B0-6-D (a)); only the
   * uploader's own read names such rows, through
   * `DeliverablesFilter.placementOutcomes` on `Project.deliverables`.
   */
  deliverables: DeliverablesCollection;
  dimensionOptions: Dimensions;
  dimensions: Dimensions;
  generativeAIOptions: Array<GenerativeAiModelOptions>;
  generativeEditResultsForDeliverable: Array<GenerativeEditResult>;
  /** Has a CSAT rating for a project. */
  hasProjectCsat: Scalars['Boolean']['output'];
  /** Retrieve an invitation by its key (internal). */
  invitation: Invitation;
  /** Retrieve the login params for a given invitation (claim code). */
  invitationParams: InvitationParams;
  /** Search for invitations. */
  invitations: Invitations;
  /** A constrained list of languages supported for use in creative */
  languages: Array<Language>;
  /** A filtered list of locales based on the unicode CLDR dataset */
  locales: Locales;
  /** List all available markets */
  markets: Array<Market>;
  me?: Maybe<Me>;
  /** Get the details of a multipart upload for a particular file. */
  multipartUpload: MultipartUpload;
  /** Queries the presigned URL to use for uploading the given part of a multipart upload. */
  multipartUploadURL: MultipartUploadUrlResponse;
  order: Order;
  /** @deprecated Serves an empty context for every order. */
  orderWorkflowContext: OrderWorkflowContext;
  orders: Orders;
  /** Get a single organizational unit */
  organizationalUnit?: Maybe<OrganizationalUnit>;
  /** Get a list of organizational units */
  organizationalUnits: OrganizationalUnits;
  platforms: Array<Platform>;
  /** Search for principals. */
  principals: Principals;
  /**
   * Get information for a specific Project.
   *
   * Requires authorization.
   */
  project: Project;
  /**
   * Get access settings for a given Project.
   *
   * Requires authorization.
   */
  projectAccessSettings?: Maybe<ProjectAccessSettings>;
  /** Retrieve the brief for a given project integration key. */
  projectBrief?: Maybe<ProjectBrief>;
  /**
   * Get a list of Projects, in one of two dialects per call.
   *
   * `params` is the legacy dialect: offset pages over the project store,
   * answered in `meta`.
   *
   * `search` is the search dialect: the projects collection from the search
   * index, scoped by the caller's authorization plan (there is no
   * caller-supplied scope input), paged by cursor and answered in
   * `searchMeta` and `facets`. Keyword and every other predicate are optional
   * filters; results never reorder by relevance. Refused with
   * search.read_path_disabled where the environment's projects search read
   * path is not enabled.
   *
   * Passing both arguments, or selecting one dialect's result fields under
   * the other, fails with a bad-request error.
   */
  projects: Projects;
  questionDefinitions: Array<QuestionDefinition>;
  questionSections?: Maybe<QuestionSections>;
  /** Get a single region by key. */
  region?: Maybe<Region>;
  /** Get a list of available regions. */
  regions: Array<Region>;
  revision: Revision;
  /** Get a specification by its key. */
  specification: DeliverableSpecification;
  specificationConcept: SpecificationConcept;
  /** Retrieve a project (specification view). */
  specificationProject: Project;
  /** Get a specific template brief by key. */
  templateBrief?: Maybe<TemplateBrief>;
  /** Get template briefs available to the current user. */
  templateBriefs: TemplateBriefsConnection;
  tiptapConfig: TiptapConfigResult;
  /** Retrieve a ugcOrder by its Key. */
  ugcOrder: UgcOrder;
  /** Retrieve a ugcOrder by a Concept Key. */
  ugcOrderByConceptKey?: Maybe<UgcOrder>;
  /** Retrieve a user by their key. */
  user: User;
  /** Search for users. */
  users: Users;
  /** Get a single vertical by key. */
  vertical?: Maybe<Vertical>;
  /** Get verticals. */
  verticals: Verticals;
  /** All configured workflow stages. */
  workflowStages: WorkflowStages;
  workingFiles: WorkingFiles;
};


export type Query_ConceptBriefSectionArgs = {
  conceptBriefKey: Scalars['ID']['input'];
  sectionKey: Scalars['String']['input'];
};


export type Query_UgcBriefArgs = {
  conceptKey: Scalars['ID']['input'];
};


export type QueryAdvertsArgs = {
  includeArchived?: InputMaybe<ArchivedFilter>;
  key?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderKey?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rootOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAmplifyMultiformatTemplateArgs = {
  id: Scalars['String']['input'];
};


export type QueryAudienceArgs = {
  key: Scalars['ID']['input'];
};


export type QueryAudienceDefaultForBrandArgs = {
  organizationalUnitKey: Scalars['ID']['input'];
};


export type QueryAudienceSubstitutionsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organizationalUnitKey: Scalars['ID']['input'];
};


export type QueryAudiencesArgs = {
  organizationalUnitKey: Scalars['ID']['input'];
};


export type QueryBrandProfileArgs = {
  asOf?: InputMaybe<Scalars['Time']['input']>;
  organizationalUnitKey: Scalars['ID']['input'];
};


export type QueryCanUpdateCsReviewNotesArgs = {
  projectIntegrationKey: Scalars['ID']['input'];
};


export type QueryClientAccountArgs = {
  key: Scalars['ID']['input'];
};


export type QueryClientBrandArgs = {
  key: Scalars['ID']['input'];
};


export type QueryConceptV2Args = {
  filter?: InputMaybe<ConceptFilters>;
  key: Scalars['ID']['input'];
};


export type QueryConceptsArgs = {
  params?: InputMaybe<ConceptsCollectionParams>;
};


export type QueryCopySuggestionsArgs = {
  audienceKey?: InputMaybe<Scalars['ID']['input']>;
  conceptIdea?: InputMaybe<Scalars['String']['input']>;
  conceptName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCreatorArgs = {
  key: Scalars['ID']['input'];
};


export type QueryCreatorOfferArgs = {
  key: Scalars['ID']['input'];
};


export type QueryCreatorProfileArgs = {
  key: Scalars['ID']['input'];
};


export type QueryCreatorsArgs = {
  params?: InputMaybe<CreatorSearchParams>;
};


export type QueryCustomPropertyDefinitionsArgs = {
  input?: InputMaybe<CustomPropertyDefinitionsInput>;
};


export type QueryDeliverableArgs = {
  key: Scalars['ID']['input'];
};


export type QueryDeliverableFormatsArgs = {
  archived?: InputMaybe<ArchivedFilter>;
  availability?: InputMaybe<DeliverableFormatAvailability>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryDeliverableFormatsByKeysArgs = {
  keys: Array<Scalars['ID']['input']>;
};


export type QueryDeliverablesArgs = {
  params: DeliverablesCollectionParams;
};


export type QueryDimensionOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDimensionsArgs = {
  keys: Array<Scalars['ID']['input']>;
};


export type QueryGenerativeEditResultsForDeliverableArgs = {
  input: GenerativeEditResultsForDeliverableInput;
};


export type QueryHasProjectCsatArgs = {
  integrationKey: Scalars['ID']['input'];
};


export type QueryInvitationArgs = {
  key: Scalars['String']['input'];
};


export type QueryInvitationParamsArgs = {
  claimCode: Scalars['String']['input'];
};


export type QueryInvitationsArgs = {
  params?: InputMaybe<InvitationsParams>;
};


export type QueryLocalesArgs = {
  input: LocaleInput;
};


export type QueryMultipartUploadArgs = {
  fileKey: Scalars['ID']['input'];
};


export type QueryMultipartUploadUrlArgs = {
  params: MultipartUploadUrlParams;
};


export type QueryOrderArgs = {
  key?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrderWorkflowContextArgs = {
  orderKey: Scalars['ID']['input'];
};


export type QueryOrdersArgs = {
  conceptWorkflow?: InputMaybe<OrdersConceptWorkflowFilter>;
  effectiveState?: InputMaybe<OrderState>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationalUnits?: InputMaybe<OrdersOrganizationalUnitFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
  state?: InputMaybe<OrderState>;
};


export type QueryOrganizationalUnitArgs = {
  key?: InputMaybe<Scalars['ID']['input']>;
  resourceKey?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationalUnitsArgs = {
  params?: InputMaybe<OrganizationalUnitsParams>;
};


export type QueryPlatformsArgs = {
  archived?: InputMaybe<ArchivedFilter>;
  availability?: InputMaybe<PlatformAvailability>;
};


export type QueryPrincipalsArgs = {
  params?: InputMaybe<PrincipalsParams>;
};


export type QueryProjectArgs = {
  filter?: InputMaybe<ProjectFilters>;
  key: Scalars['ID']['input'];
};


export type QueryProjectAccessSettingsArgs = {
  project_key: Scalars['ID']['input'];
};


export type QueryProjectBriefArgs = {
  projectIntegrationKey: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  params?: InputMaybe<ProjectsParams>;
  search?: InputMaybe<ProjectsSearchParams>;
};


export type QueryQuestionDefinitionsArgs = {
  archived?: InputMaybe<ArchivedFilter>;
  clientFilters?: InputMaybe<Array<QuestionClientFilter>>;
  copyVariation?: InputMaybe<Scalars['Boolean']['input']>;
  creativeGroups?: InputMaybe<Array<CreativeGroup>>;
  fixed?: InputMaybe<Scalars['Boolean']['input']>;
  hasFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
  kept?: InputMaybe<Scalars['Boolean']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  kinds?: InputMaybe<Array<QuestionKind>>;
  languageDetection?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sectionKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Array<SortInput>>;
  translatable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRegionArgs = {
  key: Scalars['ID']['input'];
};


export type QueryRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpecificationArgs = {
  key: Scalars['ID']['input'];
};


export type QuerySpecificationConceptArgs = {
  key: Scalars['ID']['input'];
};


export type QuerySpecificationProjectArgs = {
  key: Scalars['ID']['input'];
};


export type QueryTemplateBriefArgs = {
  allowArchived?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['ID']['input'];
};


export type QueryTemplateBriefsArgs = {
  params?: InputMaybe<TemplateBriefsParams>;
};


export type QueryUgcOrderArgs = {
  key: Scalars['ID']['input'];
};


export type QueryUgcOrderByConceptKeyArgs = {
  conceptKey: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  key: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  params?: InputMaybe<UsersParams>;
};


export type QueryVerticalArgs = {
  key: Scalars['ID']['input'];
};


export type QueryVerticalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryWorkingFilesArgs = {
  atLeast?: InputMaybe<Scalars['String']['input']>;
  orderKey: Scalars['ID']['input'];
};

/** Common query parameters for filtering and sorting. */
export type QueryParams = {
  /** Search matching results. */
  keyword?: InputMaybe<StringFilter>;
  /** Search matching results. Deprecated: use keyword StringFilter instead. */
  search: Scalars['String']['input'];
  /** Sort the results by the given fields. */
  sort?: InputMaybe<Array<SortInput>>;
  /** Direction to sort results. Deprecated: use SortInput instead. */
  sortDirection: SortDirection;
  /** Field to sort results by. Deprecated: use SortInput instead. */
  sortField: Scalars['String']['input'];
};

/**
 * Question is the brief tier of the question catalogue: what a brief reader needs
 * to render and answer a question, and nothing else. The authoring fields — copilot
 * prompts, client targeting, deliverable-format bindings, timestamps — live on
 * QuestionDefinition behind reference_data:read_definitions.
 *
 * Read-only. No mutation returns this type; the catalogue mutations return
 * QuestionDefinition.
 */
export type Question = {
  __typename?: 'Question';
  canHaveNotes: Scalars['Boolean']['output'];
  category: QuestionCategory;
  description?: Maybe<Scalars['String']['output']>;
  fixed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: QuestionKind;
  label?: Maybe<Scalars['String']['output']>;
  /**
   * Brief-tier despite being an authoring flag: Advert.answers(q:
   * {question_language_detection_eq}) filters server-side on the hydrated
   * question's value, and briefing's own GetConceptLanguageDetectionAnswers
   * operation uses that filter. Discloses nothing about clients or prompts.
   */
  languageDetection: Scalars['Boolean']['output'];
  minRows?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  questionId: Scalars['ID']['output'];
  questionOption?: Maybe<QuestionOption>;
  questionOptions: Array<QuestionOption>;
  required: Scalars['Boolean']['output'];
  sectionKey?: Maybe<Scalars['String']['output']>;
  shortLabel?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export enum QuestionCategory {
  Advert = 'advert'
}

export enum QuestionClientFilter {
  Disabled = 'DISABLED',
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED'
}

export type QuestionClientTarget = {
  __typename?: 'QuestionClientTarget';
  organizationalUnitKey: Scalars['ID']['output'];
};

/**
 * QuestionDefinition is the catalogue (authoring) tier: every brief-tier field plus
 * the fields only the catalogue's authors and the copilot service may see. Guarded
 * by reference_data:read_definitions, which — unlike reference_data:read — no
 * tenant access policy may carry.
 *
 * Its options are QuestionDefinitionOption, so the tier is closed: no path from a
 * QuestionDefinition reaches the brief tier.
 */
export type QuestionDefinition = {
  __typename?: 'QuestionDefinition';
  canHaveNotes: Scalars['Boolean']['output'];
  category: QuestionCategory;
  clientFilter: QuestionClientFilter;
  clientTargets: Array<QuestionClientTarget>;
  copilotPrompt?: Maybe<Scalars['String']['output']>;
  copyVariation: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['BigInt']['output']>;
  fixed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: QuestionKind;
  label?: Maybe<Scalars['String']['output']>;
  languageDetection: Scalars['Boolean']['output'];
  minRows?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  questionDeliverableFormats: Array<QuestionDeliverableFormat>;
  questionId: Scalars['ID']['output'];
  questionOption?: Maybe<QuestionDefinitionOption>;
  questionOptions: Array<QuestionDefinitionOption>;
  required: Scalars['Boolean']['output'];
  sectionKey?: Maybe<Scalars['String']['output']>;
  shortLabel?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  translatable: Scalars['Boolean']['output'];
  updatedAt: Scalars['Time']['output'];
};

/**
 * QuestionDefinitionOption is QuestionOption's catalogue-tier counterpart. It
 * exists so the definition tier stays closed under its own relations: a follow-up
 * reached from a QuestionDefinition is itself a QuestionDefinition, not a
 * brief-tier Question.
 */
export type QuestionDefinitionOption = {
  __typename?: 'QuestionDefinitionOption';
  followUpQuestions: Array<QuestionDefinition>;
  key: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};


/**
 * QuestionDefinitionOption is QuestionOption's catalogue-tier counterpart. It
 * exists so the definition tier stays closed under its own relations: a follow-up
 * reached from a QuestionDefinition is itself a QuestionDefinition, not a
 * brief-tier Question.
 */
export type QuestionDefinitionOptionFollowUpQuestionsArgs = {
  q?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QuestionDeliverableFormat = {
  __typename?: 'QuestionDeliverableFormat';
  deliverableFormatKey: Scalars['String']['output'];
  formatLength: FormatLength;
  id: Scalars['ID']['output'];
};

export type QuestionDeliverableFormatInput = {
  deliverableFormatKey: Scalars['ID']['input'];
  formatLengths: Array<FormatLength>;
};

export enum QuestionKind {
  Canvas = 'canvas',
  Checkbox = 'checkbox',
  Date = 'date',
  Dropdown = 'dropdown',
  Message = 'message',
  Radio = 'radio',
  Text = 'text',
  Textarea = 'textarea',
  Translatable = 'translatable'
}

export type QuestionOption = {
  __typename?: 'QuestionOption';
  followUpQuestions: Array<Question>;
  key: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};


export type QuestionOptionFollowUpQuestionsArgs = {
  q?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QuestionOptionInput = {
  key?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionReorderInput = {
  key: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type QuestionSectionV2 = {
  __typename?: 'QuestionSectionV2';
  /** Whether the section should be a fixed part of a brief */
  fixed: Scalars['Boolean']['output'];
  /** Icon for the section */
  icon?: Maybe<Scalars['String']['output']>;
  /** lower_snake_case unique identifier */
  key: Scalars['String']['output'];
  /** Position of the section in a brief */
  position: Scalars['Int']['output'];
  /** Subtitle or description of the section */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the section */
  title: Scalars['String']['output'];
};

export type QuestionSections = {
  __typename?: 'QuestionSections';
  nodes: Array<QuestionSectionV2>;
};

export type Region = {
  __typename?: 'Region';
  key: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Input for rejecting a revision and adding a new comment. */
export type RejectRevisionInput = {
  /** Deliverable ID that the new revision + comment is being added to. */
  deliverableId: Scalars['ID']['input'];
  /** Revision ID that is being rejected. */
  id: Scalars['ID']['input'];
  /** The body text of the rejection comment */
  message: Scalars['String']['input'];
};

/** Result of `removeComment`. */
export type RemoveCommentPayload = {
  __typename?: 'RemoveCommentPayload';
  /** ID of the removed comment. */
  removedCommentId: Scalars['ID']['output'];
  /**
   * The revisions whose rendered comment threads contained the comment, in
   * creation order. Members the viewer may not read are omitted; null when
   * no affected members remain for the viewer — whether none exist or none
   * are readable.
   */
  revisions?: Maybe<Array<Revision>>;
  /**
   * Opaque authenticated write-token for this removal's committed write —
   * the same contract, mint provenance, and null semantics as
   * `AddCommentPayload.writeToken` (removal is a soft archive, so the
   * token covers the row's post-increment tombstone version and lets a
   * follow-up read happen-after the removal's projection;
   * docs/state-distribution/rywf-fence-pilot/SCOPE.md, producer slice).
   */
  writeToken?: Maybe<Scalars['String']['output']>;
};

export type RemoveConceptLocalisationInput = {
  /** Key of the concept for which to remove the localisation.. */
  conceptKey: Scalars['ID']['input'];
};

export type RemoveDeliverableFormatsFromConceptInput = {
  advertKey: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formatIds: Array<Scalars['ID']['input']>;
};

export type RemoveDeliverableFormatsFromConceptPayload = {
  __typename?: 'RemoveDeliverableFormatsFromConceptPayload';
  advert?: Maybe<Advert>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/**
 * The answer of `removeDeliverableSpecification`. Exactly one of `removed`
 * and `refusal` holds.
 */
export type RemoveDeliverableSpecificationPayload = {
  __typename?: 'RemoveDeliverableSpecificationPayload';
  /**
   * The specification the concept's hero flag moved to, when the removed one
   * held it: the one other row this write changed. Null otherwise.
   */
  electedHero?: Maybe<DeliverableSpecification>;
  /** Why the specification was not removed; null when `removed`. */
  refusal?: Maybe<DeliverableSpecificationRemovalRefusal>;
  /**
   * True when the specification is removed: archived by this call, or
   * archived already (the call is idempotent and then writes nothing).
   */
  removed: Scalars['Boolean']['output'];
  /**
   * The specification as it stands after the call: the archived tombstone
   * (`progressStatus: ARCHIVED`) when removed, the live row when refused.
   */
  specification?: Maybe<DeliverableSpecification>;
};

/** Which owner produced a render session. */
export enum RenderOrigin {
  /** A point-and-shoot Amplify editor session render (AmplifyEditorSession-owned). */
  EditorSession = 'EDITOR_SESSION',
  /** A templated-production render (render-template-owned). */
  Template = 'TEMPLATE'
}

export type RenderTemplate = {
  __typename?: 'RenderTemplate';
  amplifyTemplateId?: Maybe<Scalars['String']['output']>;
  formats: Array<RenderTemplateFormat>;
  name?: Maybe<Scalars['String']['output']>;
  renderSessions: Array<RenderTemplateSession>;
};

export type RenderTemplateAssetMapping = {
  __typename?: 'RenderTemplateAssetMapping';
  file?: Maybe<RenderTemplateFile>;
  isDefault: Scalars['Boolean']['output'];
  layerName: Scalars['String']['output'];
  type: RenderTemplateAssetMappingType;
};

export type RenderTemplateAssetMappingInput = {
  fileKey?: InputMaybe<Scalars['ID']['input']>;
  /** Is this a default mapping? If so, it will ignore the incoming text value. */
  isDefault: Scalars['Boolean']['input'];
  layerName: Scalars['String']['input'];
};

export enum RenderTemplateAssetMappingType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type RenderTemplateFile = BuiltInFile | File;

export type RenderTemplateFormat = {
  __typename?: 'RenderTemplateFormat';
  code: Scalars['String']['output'];
  format: DeliverableFormat;
  isFound: Scalars['Boolean']['output'];
  mappings?: Maybe<Array<RenderTemplateSpecificationMapping>>;
  preview?: Maybe<RenderTemplateFormatPreview>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type RenderTemplateFormatPreview = {
  __typename?: 'RenderTemplateFormatPreview';
  framesPerSecond: Scalars['Float']['output'];
  thumbnailUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RenderTemplateSession = {
  __typename?: 'RenderTemplateSession';
  sessionId: Scalars['String']['output'];
  specification: Specification;
  status: RenderTemplateSessionStatus;
};

export enum RenderTemplateSessionStatus {
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type RenderTemplateSpecificationMapping = {
  __typename?: 'RenderTemplateSpecificationMapping';
  assetMappings: Array<RenderTemplateAssetMapping>;
  isBase: Scalars['Boolean']['output'];
  isDirty: Scalars['Boolean']['output'];
  specification: Specification;
  textMappings: Array<RenderTemplateTextMapping>;
};

export type RenderTemplateTextMapping = {
  __typename?: 'RenderTemplateTextMapping';
  isDefault: Scalars['Boolean']['output'];
  layerName: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type RenderTemplateTextMappingInput = {
  /** Is this a default mapping? If so, it will ignore the incoming text value. */
  isDefault: Scalars['Boolean']['input'];
  layerName: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type RenewInvitationInput = {
  /** Invitation key (internal) for the invitation to renew. */
  key: Scalars['String']['input'];
  /** Set to true to renew without sending an email. */
  skipEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReplaceTenantAccessPolicyStatementsInput = {
  statements: Array<TenantAccessPolicyStatementInput>;
};

export enum ReportItemCategory {
  AsteriskUsage = 'ASTERISK_USAGE',
  BitrateMode = 'BITRATE_MODE',
  ColorSetting = 'COLOR_SETTING',
  Copy = 'COPY',
  CopyMatching = 'COPY_MATCHING',
  CustomPlatformSpecification = 'CUSTOM_PLATFORM_SPECIFICATION',
  DeliverableFileNaming = 'DELIVERABLE_FILE_NAMING',
  Dimension = 'DIMENSION',
  DisclaimerCopy = 'DISCLAIMER_COPY',
  DisclaimerUsage = 'DISCLAIMER_USAGE',
  FileSize = 'FILE_SIZE',
  FrameRatePerSecond = 'FRAME_RATE_PER_SECOND',
  Grammar = 'GRAMMAR',
  LanguageApplied = 'LANGUAGE_APPLIED',
  LetterCase = 'LETTER_CASE',
  LineSpacing = 'LINE_SPACING',
  Spelling = 'SPELLING',
  TextAlignment = 'TEXT_ALIGNMENT',
  TextLegibility = 'TEXT_LEGIBILITY',
  VideoDuration = 'VIDEO_DURATION',
  VideoTotalBitrate = 'VIDEO_TOTAL_BITRATE'
}

export enum ReportItemCategoryScore {
  Fail = 'FAIL',
  Pass = 'PASS',
  Review = 'REVIEW'
}

export enum ReportItemScore {
  Fail = 'FAIL',
  Pass = 'PASS',
  Review = 'REVIEW'
}

export enum ReportItemTopic {
  Copy = 'COPY',
  Design = 'DESIGN',
  Technical = 'TECHNICAL'
}

export type ResourceAccessFilter = {
  action: Scalars['String']['input'];
  mode?: InputMaybe<ResourceAccessMode>;
  resourceKey: Scalars['ID']['input'];
  resourceKind: Scalars['String']['input'];
};

export enum ResourceAccessMode {
  Current = 'CURRENT',
  Potential = 'POTENTIAL'
}

/**
 * The answer of `restoreDeliverableSpecification`. Exactly one of `restored`
 * and `refusal` holds.
 */
export type RestoreDeliverableSpecificationPayload = {
  __typename?: 'RestoreDeliverableSpecificationPayload';
  /** Why the specification was not restored; null when `restored`. */
  refusal?: Maybe<DeliverableSpecificationRestoreRefusal>;
  /** True when this call restored the specification. */
  restored: Scalars['Boolean']['output'];
  /**
   * The specification as it stands after the call: the restored
   * specification, or the row a refusal left as it was.
   */
  specification?: Maybe<DeliverableSpecification>;
};

/** Enacting sends deliverables back for revision. */
export type ReviseDeliverablesEffect = WorkflowTransitionEffect & {
  __typename?: 'ReviseDeliverablesEffect';
  /** How many deliverables would be sent back for revision if the transition were enacted now; null when the count cannot be determined right now. */
  deliverables?: Maybe<Scalars['Int']['output']>;
  kind: WorkflowTransitionEffectKind;
};

/**
 * The `@key` publishes the revision as a federated entity so the authz
 * subgraph can extend it with the operation-check entry
 * (`viewerOperationChecks`), exactly like the sibling viewer-action-check
 * families; `resolvable: false` because revision data only ever enters
 * through this subgraph's own fields — nothing resolves Revision
 * representations here. The wire `id` VALUE is the revision's integration key
 * (docs/revision-ownership/SCOPE.md Phase 1).
 */
export type Revision = {
  __typename?: 'Revision';
  annotations: Array<Annotation>;
  appliesToConcept: Scalars['Boolean']['output'];
  attachments: Array<Attachment>;
  /**
   * The author of this revision, as a `Principal` reference; select `profile`
   * for display identity. Null when the revision has no author principal.
   */
  author?: Maybe<Principal>;
  /** Revision category supplied by the user on creation. */
  category: RevisionCategory;
  changeRequestIntegrationKey: Scalars['ID']['output'];
  comment: Scalars['String']['output'];
  /**
   * The revision's rendered comment thread — one governed read. Pass a
   * mutation payload's `writeToken` as `atLeast` to fence the read on your
   * own write: the read waits (bounded) until the authorization projection
   * provably includes the token's writes, and the result's `convergence`
   * discloses whether it converged. Without `atLeast` the read is unfenced
   * and serves today's row set with the constant no-claim meta.
   */
  comments: RevisionComments;
  createdAt: Scalars['Time']['output'];
  date: Scalars['String']['output'];
  /**
   * The key of the revision's own governing deliverable — the exact target
   * the comment write/tier preflights and mutations enforce at, whichever
   * lane (deliverable or specification) listed the revision. Always present
   * on the two lane listings and on the rejectRevision echo (the clone
   * carries its deliverable edge out of the transaction — pinned
   * server-side as the stable identity clients can key post-commit
   * refreshes off); null on surfaces that do not resolve the deliverable
   * edge (the requestRevision echoes, the single-revision lookup).
   */
  deliverableKey?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  intent: RevisionIntent;
  isRejected: Scalars['Boolean']['output'];
  /** Qualified category derived from LLM Classification. Distinct from the user-supplied category & subCategory values. */
  qualifiedCategory?: Maybe<Scalars['String']['output']>;
  resolved: Scalars['Boolean']['output'];
  sequenceID: Scalars['Int']['output'];
  /** Revision sub-category supplied by the user on creation. */
  subCategory?: Maybe<RevisionSubCategory>;
  /** Apply revision on a video format to a specific point in time. Also used to track the primary frame for annotations. */
  timestamp?: Maybe<Scalars['Float']['output']>;
  /** End point in time for applying a time range to a revision. */
  timestampEnd?: Maybe<Scalars['Float']['output']>;
  /** Starting point in time for applying a time range to a revision. */
  timestampStart?: Maybe<Scalars['Float']['output']>;
  /** Type of timestamp that is applied to a revision. */
  timestampType: TimestampType;
  viewerOperationChecks: Array<RevisionOperationCheck>;
};


/**
 * The `@key` publishes the revision as a federated entity so the authz
 * subgraph can extend it with the operation-check entry
 * (`viewerOperationChecks`), exactly like the sibling viewer-action-check
 * families; `resolvable: false` because revision data only ever enters
 * through this subgraph's own fields — nothing resolves Revision
 * representations here. The wire `id` VALUE is the revision's integration key
 * (docs/revision-ownership/SCOPE.md Phase 1).
 */
export type RevisionCommentsArgs = {
  atLeast?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `@key` publishes the revision as a federated entity so the authz
 * subgraph can extend it with the operation-check entry
 * (`viewerOperationChecks`), exactly like the sibling viewer-action-check
 * families; `resolvable: false` because revision data only ever enters
 * through this subgraph's own fields — nothing resolves Revision
 * representations here. The wire `id` VALUE is the revision's integration key
 * (docs/revision-ownership/SCOPE.md Phase 1).
 */
export type RevisionViewerOperationChecksArgs = {
  operations: Array<RevisionOperation>;
};

export enum RevisionCategory {
  Audio = 'Audio',
  Imagery = 'Imagery',
  Other = 'Other',
  Text = 'Text',
  Timing = 'Timing',
  Transition = 'Transition'
}

/**
 * Visibility tier of a revision comment. The tier is a domain attribute of the
 * comment row; read-side enforcement arrives with the ACLv2 cutover
 * (docs/access-control/revision-comment-visibility/SCOPE.md).
 */
export enum RevisionCommentVisibility {
  /** Visible to every audience that can read comments at all. */
  Everyone = 'EVERYONE',
  /** Visible only to audiences whose comment-read grants are unconditioned (in practice: Shuttlerock-side roles). */
  Limited = 'LIMITED'
}

/**
 * The governed comment-thread read: the rows the viewer's plan admits, plus
 * the convergence disclosure for the fence this read was asked to hold. A
 * convergence miss is disclosed, never an error and never a null — rows the
 * projection has not admitted yet are simply absent from `items`, and a
 * fail-closed consumer treats an absent convergence claim as PENDING, never
 * as deletion or denial (staleness ≠ denial).
 */
export type RevisionComments = {
  __typename?: 'RevisionComments';
  /** Convergence disclosure for this read's answer. */
  convergence: ConvergenceMeta;
  /** The admitted comment rows, in creation order. */
  items: Array<Comment>;
};

/**
 * Represents a concept in the Revision domain: the revision-owned concept notes.
 *
 * This type will be superseded by the Concept type in the Concept domain.
 */
export type RevisionConcept = {
  __typename?: 'RevisionConcept';
  additionalNotes: Scalars['String']['output'];
  heroNotes: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  project: Project;
};

export type RevisionInputV2 = {
  annotations?: InputMaybe<Array<AnnotationInput>>;
  appliesToConcept: Scalars['Boolean']['input'];
  attachments?: InputMaybe<Array<AttachmentInput>>;
  category: RevisionCategory;
  comment: Scalars['String']['input'];
  date: Scalars['String']['input'];
  deliverableKey: Scalars['ID']['input'];
  intent: RevisionIntent;
  /**
   * The revision's key, minted by the client (a UUID); it becomes the created
   * revision's `id`. Resubmitting with the same key returns the revision it
   * already created instead of creating another.
   */
  key: Scalars['ID']['input'];
  revisionSource?: InputMaybe<RevisionSourceInput>;
  specificationKey: Scalars['ID']['input'];
  subCategory?: InputMaybe<RevisionSubCategory>;
  /** Apply revision on a video format to a specific point in time. Also used to track the primary frame for annotations. */
  timestamp?: InputMaybe<Scalars['Float']['input']>;
  /** End point in time for applying a time range to a revision. */
  timestampEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Starting point in time for applying a time range to a revision. */
  timestampStart?: InputMaybe<Scalars['Float']['input']>;
  /** Type of the timestamp that is applied to a revision. */
  timestampType: TimestampType;
};

export enum RevisionIntent {
  Corrective = 'CORRECTIVE',
  Variation = 'VARIATION'
}

/**
 * Semantic operations on a revision. Values mirror the mutation verbs
 * (`editRevision` / `archiveRevision` / `unarchiveRevision`), never ACL action
 * IDs: the enforcement actions are owner-or-grant-checked while the state
 * predicates live here.
 */
export enum RevisionOperation {
  Archive = 'ARCHIVE',
  Edit = 'EDIT',
  Unarchive = 'UNARCHIVE'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * extends Revision with `viewerOperationChecks`); this subgraph contributes
 * the `validation` leg — the domain's registered state invariants.
 */
export type RevisionOperationCheck = {
  __typename?: 'RevisionOperationCheck';
  authorization: ActionCheckResult;
  operation: RevisionOperation;
  revisionKey: Scalars['ID']['output'];
  /**
   * Pure domain leg: does the revision's state admit this operation.
   * A deliverable that refuses a request of the revision's intent admits
   * nothing — the deliverable domain's request rule, answered for the
   * viewer: the viewer's head, not archived, not approved for a corrective
   * request; approved for a variation — and archived-ness selects the
   * archive direction: ARCHIVE requires the row live, UNARCHIVE requires it
   * archived. EDIT binds to the deliverable's answer alone — rejected
   * revisions stay author-manageable by ruling.
   */
  validation: ActionCheckResult;
};

export type RevisionSourceInput = {
  externalKey: Scalars['ID']['input'];
  type: RevisionSourceType;
};

export enum RevisionSourceType {
  /** Revision comment was first created by a quality assurance report. */
  QaReportItem = 'QA_REPORT_ITEM'
}

export enum RevisionSubCategory {
  Animation = 'Animation',
  Colour = 'Colour',
  Font = 'Font',
  Layout = 'Layout',
  Music = 'Music',
  Other = 'Other',
  Size = 'Size',
  SoundEffects = 'SoundEffects',
  TextChange = 'TextChange',
  Voiceover = 'Voiceover'
}

export type Revisions = {
  __typename?: 'Revisions';
  count: Scalars['Int']['output'];
  nodes: Array<Revision>;
};

export type RevisionsFilter = {
  createdAt?: InputMaybe<TimeFilter>;
};

export type RevisionsParams = {
  filter?: InputMaybe<RevisionsFilter>;
};

export type RevokeCreatorOfferInput = {
  key: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RevokeInvitationsInput = {
  /** Invitation keys (internal) for the invitations to revoke. */
  keys: Array<Scalars['String']['input']>;
};

/** Mutation payload for revokeRoleFromPrincipal. */
export type RevokeRoleInput = {
  grantKey: Scalars['ID']['input'];
};

/** A role defines a set of permissions that can be assigned to users and other principals. */
export type Role = {
  __typename?: 'Role';
  audiences: Array<RoleAudience>;
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grantChannels: Array<RoleGrantChannel>;
  grantScopeKinds: Array<GrantScopeKind>;
  key: Scalars['ID']['output'];
  /**
   * System-managed role: seeded from the code template by the reconciler and
   * converged on every pass. Human write lanes reject managed roles.
   */
  managed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  statements: Array<RoleStatement>;
  updatedAt: Scalars['Time']['output'];
};

export enum RoleAudience {
  Admin = 'ADMIN',
  System = 'SYSTEM',
  User = 'USER'
}

export type RoleConnection = {
  __typename?: 'RoleConnection';
  nodes: Array<Role>;
  pageInfo: OffsetPageInfo;
};

export type RoleFilter = {
  audiences?: InputMaybe<Array<RoleAudience>>;
  grantChannels?: InputMaybe<Array<RoleGrantChannel>>;
  grantScopeKinds?: InputMaybe<Array<GrantScopeKind>>;
};

export enum RoleGrantChannel {
  AdminUi = 'ADMIN_UI',
  Invitation = 'INVITATION',
  System = 'SYSTEM'
}

export type RoleMutation = {
  __typename?: 'RoleMutation';
  archiveRole: Scalars['Boolean']['output'];
  createRole: Role;
  restoreRole: Role;
  updateRole: Role;
};


export type RoleMutationArchiveRoleArgs = {
  id: Scalars['ID']['input'];
};


export type RoleMutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type RoleMutationRestoreRoleArgs = {
  id: Scalars['ID']['input'];
};


export type RoleMutationUpdateRoleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRoleInput;
};

export type RoleQuery = {
  __typename?: 'RoleQuery';
  role?: Maybe<Role>;
  roles: RoleConnection;
};


export type RoleQueryRoleArgs = {
  key: Scalars['ID']['input'];
};


export type RoleQueryRolesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RoleFilter>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<RoleSort>;
};

export enum RoleSort {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type RoleStatement = {
  __typename?: 'RoleStatement';
  actions: Array<Action>;
  condition?: Maybe<RoleStatementCondition>;
  effect: RoleStatementEffect;
  sid?: Maybe<Scalars['String']['output']>;
};

export type RoleStatementCondition = {
  __typename?: 'RoleStatementCondition';
  allOf: Array<RoleStatementConditionClause>;
};

export type RoleStatementConditionClause = {
  __typename?: 'RoleStatementConditionClause';
  key: Scalars['String']['output'];
  operator: RoleStatementConditionOperator;
  values: Array<Scalars['String']['output']>;
};

export type RoleStatementConditionClauseInput = {
  key: Scalars['String']['input'];
  operator: RoleStatementConditionOperator;
  values: Array<Scalars['String']['input']>;
};

export type RoleStatementConditionInput = {
  allOf: Array<RoleStatementConditionClauseInput>;
};

export enum RoleStatementConditionOperator {
  StringIn = 'STRING_IN'
}

export enum RoleStatementEffect {
  Allow = 'ALLOW'
}

export type RoleStatementInput = {
  actionIds: Array<Scalars['ActionKey']['input']>;
  condition?: InputMaybe<RoleStatementConditionInput>;
  effect?: InputMaybe<RoleStatementEffect>;
  sid?: InputMaybe<Scalars['String']['input']>;
};

export type Scene = {
  __typename?: 'Scene';
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  questionKey: Scalars['String']['output'];
};

/**
 * The search implementation a collection request runs on, chosen by searchVersion
 * alone. One index answers the request's hits, filters, sort, facets, groups and
 * pages.
 */
export enum SearchVersion {
  /** The current search path, unchanged. */
  V1 = 'V1',
  /** The Tracker search path. */
  V2 = 'V2'
}

export type SendInvitationEmailInput = {
  /** Invitation key (internal) for the invitation. */
  key: Scalars['String']['input'];
};

export type SetBriefingAssetNoteInput = {
  key: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type SetConceptDueDateInput = {
  conceptKey: Scalars['ID']['input'];
  /** Omit to leave unchanged, null to clear, Date to set. No input default. */
  dueDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SetConceptLanguageInput = {
  /** Integration key of the concept to update. */
  integrationKey: Scalars['ID']['input'];
  /** ISO-639 language code. */
  languageCode: Scalars['String']['input'];
};

/**
 * Input for setting a custom property value on a record. Provide the value field
 * that matches the definition's type.
 */
export type SetCustomPropertyValueInput = {
  /** Value for CHECKBOX definitions. */
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date-only value for DATE definitions when allowTime is false. */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Date-time value for DATE definitions when allowTime is true. */
  dateTime?: InputMaybe<Scalars['Time']['input']>;
  /** Definition key for the value being set. */
  definitionKey: Scalars['ID']['input'];
  /** Value for NUMBER definitions. */
  number?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Keys of SELECT options to assign. Keys must reference active options, except
   * that keys already stored on this value are always accepted (retained) even
   * if their option has since been archived — a read value can be echoed back
   * verbatim. Once removed from the value, an archived option's key cannot be
   * re-added.
   */
  optionKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Key of the record receiving this value. */
  ownerKey: Scalars['ID']['input'];
  /** Principal keys for USER definitions. */
  principalKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Value for RICH_TEXT definitions. */
  richText?: InputMaybe<Scalars['JSON']['input']>;
  /** Value for TEXT definitions. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Input for setting a deal for a project. */
export type SetDealForProjectInput = {
  /** HubSpot deal ID to associate with the project. */
  dealId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether no deal should be assigned to the project. If false, the dealId field must be provided.
   * @deprecated Use noDealOption.
   */
  noDealAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Selection of reasons for why no HubSpot deal is assigned. */
  noDealOption?: InputMaybe<NoHubspotDealOptions>;
  /** Key of the project to be updated. */
  projectKey: Scalars['ID']['input'];
};

export type SetEnableUgcOrderingInput = {
  clientAccountKey: Scalars['ID']['input'];
  enableUgcOrdering: Scalars['Boolean']['input'];
};

/** Mutation payload for setPrincipalRoles. */
export type SetPrincipalRolesInput = {
  principalKey: Scalars['ID']['input'];
  roleKeys: Array<Scalars['ID']['input']>;
  scope: GrantScopeInput;
};

export type SetProjectAccessInput = {
  projectKey: Scalars['ID']['input'];
  visibility: ProjectVisibility;
};

export type SetProjectDueDateInput = {
  /** Omit to leave unchanged, null to clear, Date to set. No input default. */
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  projectKey: Scalars['ID']['input'];
};

export type SetProjectExternalUrlInput = {
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  projectKey: Scalars['ID']['input'];
};

export type SetUgcAssetNoteInput = {
  /** Integration key of the UGC Asset to update notes for */
  key: Scalars['ID']['input'];
  /** The new asset notes */
  note: Scalars['String']['input'];
};

export enum SortDirection {
  /** Sort results in ascending order. */
  Asc = 'ASC',
  /** Sort results in descending order. */
  Desc = 'DESC'
}

export type SortInput = {
  /** Field to sort results by. */
  field: Scalars['String']['input'];
  /** Direction to sort results. */
  order: SortOrder;
};

export enum SortOrder {
  /** Ascending order. */
  Asc = 'ASC',
  /** Descending order. */
  Desc = 'DESC'
}

/** Centralized entity stub for Specification (template/spec object). */
export type Specification = {
  __typename?: 'Specification';
  key: Scalars['ID']['output'];
};

/**
 * Represents a concept in the Specification domain.
 *
 * This type will be superseded by the Concept type.
 */
export type SpecificationConcept = {
  __typename?: 'SpecificationConcept';
  createdAt: Scalars['Time']['output'];
  deliverableSpecifications: Array<DeliverableSpecification>;
  description?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  key: Scalars['ID']['output'];
  languageCode?: Maybe<Scalars['String']['output']>;
  languageVariationCodes: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  source?: Maybe<SpecificationConcept>;
};

/** Archive option for a Specification count sort. It chooses what is counted, never which results return. */
export type SpecificationCountSortInput = {
  /** Omitted, null or false counts active Specifications; true also counts archived ones. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpecificationDimension = {
  __typename?: 'SpecificationDimension';
  height: Scalars['Float']['output'];
  isCustom: Scalars['Boolean']['output'];
  ratio: Scalars['Float']['output'];
  unit: MeasurementUnit;
  width: Scalars['Float']['output'];
};

export type StringArrayFilter = {
  all?: InputMaybe<Array<Scalars['String']['input']>>;
  any?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum StringEncoding {
  Base64 = 'base64',
  None = 'none'
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SubmissionState {
  Error = 'error',
  New = 'new',
  Touched = 'touched',
  Valid = 'valid'
}

/** Input for submitting creator registration (public). */
export type SubmitCreatorRegistrationInput = {
  /** Address city. */
  addressCity: Scalars['String']['input'];
  /** Address country code. */
  addressCountryCode: Scalars['String']['input'];
  /** Address line 1. */
  addressLine1: Scalars['String']['input'];
  /** Address line 2. */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Address state. */
  addressState: Scalars['String']['input'];
  /** Address zip code. */
  addressZipCode: Scalars['String']['input'];
  /** Year of birth. */
  birthYear: Scalars['Int']['input'];
  /** Email. */
  email: Scalars['String']['input'];
  /** Ethnicity. */
  ethnicity: Scalars['String']['input'];
  /** First name. */
  firstName: Scalars['String']['input'];
  /** Gender identifier. */
  genderID: Scalars['ID']['input'];
  /** Hobby / Interest identifiers. */
  hobbyInterestIDs: Array<Scalars['ID']['input']>;
  /** Optional integration key for the creator. */
  key?: InputMaybe<Scalars['ID']['input']>;
  /** Languages. */
  languages: Array<Scalars['String']['input']>;
  /** Last name. */
  lastName: Scalars['String']['input'];
  /** Media input. */
  media: Array<MediaInput>;
  /** Post ads answer. */
  postAds: CreatorPostAd;
  /** Profile / bio. */
  profile: Scalars['String']['input'];
  /** Social media links. */
  socialMediaLinks: Array<Scalars['String']['input']>;
  /** Specialty vertical identifiers. */
  specialtyVerticalIDs: Array<Scalars['ID']['input']>;
};

export type SubmitGenerativeEditDeliverableInput = {
  generativeEditKey: Scalars['ID']['input'];
};

export type SubmitGenerativeEditRequestInput = {
  attachmentFileKey?: InputMaybe<Scalars['ID']['input']>;
  deliverableKey: Scalars['ID']['input'];
  generativeEditKey?: InputMaybe<Scalars['ID']['input']>;
  prompt: Scalars['String']['input'];
};

export type SubmitGenerativeVariationRequestInput = {
  applyToAllStatics: Scalars['Boolean']['input'];
  generativeEditKey: Scalars['ID']['input'];
  languageCode: Scalars['String']['input'];
  variationName: Scalars['String']['input'];
};

export type SubmitProjectForTemplatedProductionInput = {
  projectKey: Scalars['ID']['input'];
};

export type SubmitUgcDeliverablesInput = {
  /** Integration key of the UGC order to submit deliverables */
  ugcOrderKey: Scalars['ID']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Streams the current demo-import status snapshot for the requested imports.
   * Each frame carries the full current set for the project (filtered to the
   * requested keys) — a snapshot stream, not deltas — so a client diffs
   * frame-to-frame and self-heals across reconnects. Carries `status` and the
   * federated `file`, so the import dialog drops both its poll and any follow-up
   * query.
   */
  amplifyDemoImportsUpdated: AmplifyDemoImports;
  /**
   * Streams the current render-session status snapshot for the given concepts.
   * Each frame carries the full current set for the requested concepts (a
   * snapshot stream, not deltas), so a client that diffs frame-to-frame
   * self-heals across reconnects.
   *
   * Carries both render origins. `origins` scopes the stream to one audience:
   * the delivery/revision "applying edits" surfaces pass [EDITOR_SESSION] (the
   * point-and-shoot flow); the templated-production editor passes [TEMPLATE].
   * Omitting it streams both.
   */
  amplifyRenderStatusUpdated: AmplifyRenderStatus;
  deliverableUpdatedForProject: Deliverable;
  generativeEditUpdated: GenerativeEditResult;
};


export type SubscriptionAmplifyDemoImportsUpdatedArgs = {
  params?: InputMaybe<AmplifyDemoImportsParams>;
  projectKey: Scalars['ID']['input'];
};


export type SubscriptionAmplifyRenderStatusUpdatedArgs = {
  conceptKeys: Array<Scalars['ID']['input']>;
  origins?: InputMaybe<Array<RenderOrigin>>;
};


export type SubscriptionDeliverableUpdatedForProjectArgs = {
  projectKey: Scalars['ID']['input'];
};


export type SubscriptionGenerativeEditUpdatedArgs = {
  deliverableKey: Scalars['ID']['input'];
};

export enum TargetGender {
  All = 'All',
  Female = 'Female',
  Male = 'Male'
}

/** A template brief that can be used to create concept briefs. */
export type TemplateBrief = {
  __typename?: 'TemplateBrief';
  /** The time this template was archived, if applicable. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The time this template was created. */
  createdAt: Scalars['Time']['output'];
  /** Preselected deliverable formats for this template brief. */
  defaultFormats: Array<TemplateBriefFormat>;
  /** Preselected sections for this template brief. */
  defaultSections: Array<QuestionSectionV2>;
  /** Optional description of the template brief. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique key of the template brief. */
  key: Scalars['ID']['output'];
  /** The name of the template brief. */
  name: Scalars['String']['output'];
  /** Organizational unit keys that this template filter applies to (for INCLUDE/EXCLUDE modes). */
  ouFilterKeys: Array<Scalars['ID']['output']>;
  /** OU filtering mode for this template. */
  ouFilterMode: OuFilterMode;
  /** Organizational units that this template filter applies to (for INCLUDE/EXCLUDE modes). */
  ouFilterNodes: Array<OrganizationalUnit>;
  /** Position of the template brief for ordering. */
  position: Scalars['Int']['output'];
  /** The time this template was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type TemplateBriefFormat = {
  __typename?: 'TemplateBriefFormat';
  /** The format type. */
  format: DeliverableFormat;
  /** The length option for this format. */
  formatLength: FormatLength;
};

export type TemplateBriefFormatInput = {
  /** The format type. */
  formatKey: Scalars['ID']['input'];
  /** The length option for this format. */
  formatLength: FormatLength;
};

/** Connection type for paginated template brief results. */
export type TemplateBriefsConnection = {
  __typename?: 'TemplateBriefsConnection';
  /** The template briefs in this page. */
  nodes: Array<TemplateBrief>;
  /** Pagination metadata. */
  pageInfo: OffsetPageInfo;
};

/** Filter options for template briefs. */
export type TemplateBriefsFilter = {
  /** Filter by archived status. */
  archived?: InputMaybe<ArchivedFilter>;
  /** Search by name. */
  name?: InputMaybe<StringFilter>;
  /** Filter to only templates available to a specific organizational unit. */
  ouKey?: InputMaybe<IdFilter>;
};

/** Parameters for querying template briefs. */
export type TemplateBriefsParams = {
  /** Filter criteria. */
  filter?: InputMaybe<TemplateBriefsFilter>;
  /** Pagination options. */
  pagination?: InputMaybe<OffsetPagination>;
  /** Sort options. */
  sort?: InputMaybe<Array<SortInput>>;
};

export type Tenancy = {
  __typename?: 'Tenancy';
  key: Scalars['ID']['output'];
};

export type TenantAccessPolicy = {
  __typename?: 'TenantAccessPolicy';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  principalClass: TenantAccessPolicyPrincipalClass;
  statements: Array<TenantAccessPolicyStatement>;
  updatedAt: Scalars['Time']['output'];
};

export type TenantAccessPolicyMutation = {
  __typename?: 'TenantAccessPolicyMutation';
  replacePolicyStatements: TenantAccessPolicy;
};


export type TenantAccessPolicyMutationReplacePolicyStatementsArgs = {
  input: ReplaceTenantAccessPolicyStatementsInput;
  principalClass: TenantAccessPolicyPrincipalClass;
};

export enum TenantAccessPolicyPrincipalClass {
  AnonymousUser = 'ANONYMOUS_USER',
  AuthenticatedUser = 'AUTHENTICATED_USER'
}

export type TenantAccessPolicyQuery = {
  __typename?: 'TenantAccessPolicyQuery';
  policies: Array<TenantAccessPolicy>;
  policy: TenantAccessPolicy;
};


export type TenantAccessPolicyQueryPolicyArgs = {
  principalClass: TenantAccessPolicyPrincipalClass;
};

export type TenantAccessPolicyStatement = {
  __typename?: 'TenantAccessPolicyStatement';
  actions: Array<Action>;
  condition?: Maybe<TenantAccessPolicyStatementCondition>;
  effect: TenantAccessPolicyStatementEffect;
  fixed: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  sequence: Scalars['Int']['output'];
  sid?: Maybe<Scalars['String']['output']>;
};

export type TenantAccessPolicyStatementCondition = {
  __typename?: 'TenantAccessPolicyStatementCondition';
  allOf: Array<TenantAccessPolicyStatementConditionClause>;
};

export type TenantAccessPolicyStatementConditionClause = {
  __typename?: 'TenantAccessPolicyStatementConditionClause';
  key: Scalars['String']['output'];
  operator: TenantAccessPolicyStatementConditionOperator;
  values: Array<Scalars['String']['output']>;
};

export type TenantAccessPolicyStatementConditionClauseInput = {
  key: Scalars['String']['input'];
  operator: TenantAccessPolicyStatementConditionOperator;
  values: Array<Scalars['String']['input']>;
};

export type TenantAccessPolicyStatementConditionInput = {
  allOf: Array<TenantAccessPolicyStatementConditionClauseInput>;
};

export enum TenantAccessPolicyStatementConditionOperator {
  StringIn = 'STRING_IN'
}

export enum TenantAccessPolicyStatementEffect {
  Allow = 'ALLOW'
}

export type TenantAccessPolicyStatementInput = {
  actionIds: Array<Scalars['ActionKey']['input']>;
  condition?: InputMaybe<TenantAccessPolicyStatementConditionInput>;
  effect?: InputMaybe<TenantAccessPolicyStatementEffect>;
  sid?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a three-valued logic, or indeterminate state. */
export enum Ternary {
  No = 'NO',
  Unsure = 'UNSURE',
  Yes = 'YES'
}

export type TimeComparisonFilter = {
  eq?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
};

export type TimeFilter = {
  eq?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  in?: InputMaybe<Array<Scalars['Time']['input']>>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
};

export enum TimestampType {
  None = 'None',
  Point = 'Point',
  Range = 'Range'
}

export type TiptapConfigResult = {
  __typename?: 'TiptapConfigResult';
  token: Scalars['String']['output'];
};

/** Numbered-mode navigation only. Exact counts remain uncapped and access-scoped. */
export type TrackerNumberedPage = {
  __typename?: 'TrackerNumberedPage';
  exactCount: Scalars['Int']['output'];
  grain: TrackerPageGrain;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  reachableCount: Scalars['Int']['output'];
  returnedCount: Scalars['Int']['output'];
};

export enum TrackerPageGrain {
  Concept = 'CONCEPT',
  Project = 'PROJECT',
  ProjectGroup = 'PROJECT_GROUP'
}

/** The viewer's own product-analytics choice. */
export enum TrackingChoice {
  /** Product analytics turned off. */
  Denied = 'DENIED',
  /** Product analytics allowed. */
  Granted = 'GRANTED'
}

/** The viewer's product-analytics consent: on unless they turn it off in Preferences. */
export type TrackingConsent = {
  __typename?: 'TrackingConsent';
  /** Whether product analytics may run for the viewer: true unless the choice is DENIED. */
  allowed: Scalars['Boolean']['output'];
  /** The viewer's own choice; null until they first use the Preferences switch. */
  choice?: Maybe<TrackingChoice>;
  /** When the server recorded the choice; null exactly when the choice is. */
  decidedAt?: Maybe<Scalars['Time']['output']>;
};

/**
 * A platform trait: a person-fact in the bounded code catalog that cohort
 * membership rules select over. Traits are derived from their owning
 * aggregates at compile time; they carry values, not verdicts.
 */
export enum Trait {
  /** email.domain — the domain part of the user's email address, lower-cased. */
  EmailDomain = 'EMAIL_DOMAIN'
}

/**
 * One condition of a cohort's membership rule: a comparison over a catalogued
 * platform trait. The predicate is tenant-authored cohort data; the trait it
 * names is the platform-owned fact. Values are a set because ops are
 * set-shaped (the industry predicate-row shape): EQ reads exactly one, IN any
 * of them — arity is the op's contract.
 */
export type TraitPredicate = {
  __typename?: 'TraitPredicate';
  op: TraitPredicateOp;
  trait: Trait;
  values: Array<Scalars['String']['output']>;
};

/**
 * One authored condition of a membership rule. The document is bounded and
 * canonical, rejected (never silently normalized) when it is not: at most 20
 * predicates per rule, ONE predicate per trait (a rule is a conjunction —
 * alternatives belong in one IN), at most 100 values per predicate, each at
 * most 200 characters, non-blank, never repeated, carrying no surrounding
 * whitespace, and in the trait's canonical form (EMAIL_DOMAIN derives
 * lower-cased, so values must be lower-case).
 */
export type TraitPredicateInput = {
  op: TraitPredicateOp;
  trait: Trait;
  values: Array<Scalars['String']['input']>;
};

/**
 * The comparison a membership-rule predicate applies to a trait's value. The
 * set is deliberately tiny and closed — expressiveness grows by adding
 * operators to the platform catalog, never by open expressions in tenant data.
 */
export enum TraitPredicateOp {
  /** The trait's value equals the predicate's single value exactly (exactly one value). */
  Eq = 'EQ',
  /** The trait's value equals ANY of the predicate's values (at least one value). */
  In = 'IN'
}

export type TransitionConceptWorkflowInput = {
  /** One request per concept. Naming the same concept twice fails the whole call. */
  requests: Array<ConceptWorkflowTransitionRequest>;
};

export type TransitionConceptWorkflowResult = {
  __typename?: 'TransitionConceptWorkflowResult';
  /** One result per request, in request order. */
  results: Array<ConceptWorkflowTransitionResult>;
};

/**
 * A platform treatment: a granular, product-focused switch-point declared in
 * the code catalog with a platform-owned default, toggled per viewer by cohort
 * bindings under the combination algebra.
 */
export enum Treatment {
  /** ces.brief_banners — client-instruction banners on the concept brief. */
  CesBriefBanners = 'CES_BRIEF_BANNERS',
  /** crm.tracking — HubSpot script load, identify, and chat. */
  CrmTracking = 'CRM_TRACKING',
  /** csat.concept_quality — post-approval concept-quality survey trigger. */
  CsatConceptQuality = 'CSAT_CONCEPT_QUALITY',
  /** nps.lottery — NPS random-attempt eligibility. */
  NpsLottery = 'NPS_LOTTERY'
}

export type UgcAsset = {
  __typename?: 'UGCAsset';
  file: File;
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type UgcAssetLink = {
  __typename?: 'UGCAssetLink';
  note?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UgcAssetLinkInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UgcBrief = {
  __typename?: 'UGCBrief';
  additionalInstructions?: Maybe<Scalars['String']['output']>;
  approach?: Maybe<ConceptApproach>;
  audience?: Maybe<Audience>;
  brandAssets: Array<UgcAsset>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  brandLogoUrl?: Maybe<Scalars['String']['output']>;
  brandName: Scalars['String']['output'];
  brandProductPositioning?: Maybe<Scalars['String']['output']>;
  brandRelevantSocialChannels?: Maybe<Scalars['String']['output']>;
  concept: ConceptLite;
  conceptDirection?: Maybe<Scalars['String']['output']>;
  conceptName: Scalars['String']['output'];
  conceptObjective?: Maybe<Scalars['String']['output']>;
  creatorAdditionalRequirements?: Maybe<Scalars['String']['output']>;
  creatorAge?: Maybe<AgeRangePreference>;
  creatorEthnicity?: Maybe<Scalars['String']['output']>;
  creatorGender?: Maybe<GenderPreference>;
  creatorInterestsAndHobbies?: Maybe<Scalars['String']['output']>;
  creatorLocation?: Maybe<Scalars['String']['output']>;
  deliverable?: Maybe<Scalars['String']['output']>;
  dosAndDonts?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languages: Array<Language>;
  legalRequirements?: Maybe<Scalars['String']['output']>;
  productProcurement?: Maybe<Scalars['String']['output']>;
  projectName: Scalars['String']['output'];
  referenceAssets: Array<UgcAsset>;
  referenceLinks: Array<UgcAssetLink>;
  scriptOrVoiceOverInstructions?: Maybe<Scalars['String']['output']>;
  sections: Array<UgcBriefSection>;
  theHook?: Maybe<Scalars['String']['output']>;
  ugcOrderKey: Scalars['ID']['output'];
  uniqueSellingPoints?: Maybe<Scalars['String']['output']>;
};

export enum UgcBriefSection {
  AdditionalInstructions = 'additionalInstructions',
  BrandDetails = 'brandDetails',
  DosAndDonts = 'dosAndDonts',
  Language = 'language',
  LegalRequirements = 'legalRequirements',
  ProductProcurement = 'productProcurement',
  ScriptOrVoiceOverInstructions = 'scriptOrVoiceOverInstructions',
  TheHook = 'theHook',
  UniqueSellingPoints = 'uniqueSellingPoints'
}

export type UgcDeliverable = {
  __typename?: 'UGCDeliverable';
  file?: Maybe<File>;
  key: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  state: UgcDeliverableState;
  submitted_time?: Maybe<Scalars['Time']['output']>;
};

export enum UgcDeliverableState {
  Approved = 'APPROVED',
  Inactive = 'INACTIVE',
  InReview = 'IN_REVIEW',
  Pending = 'PENDING'
}

export type UgcOrder = {
  __typename?: 'UGCOrder';
  activeOffer?: Maybe<CreatorOffer>;
  brief: UgcBrief;
  conceptKey: Scalars['ID']['output'];
  creator?: Maybe<Creator>;
  creatorShortlist: Array<Creator>;
  deliverableLinks: Array<UgcAssetLink>;
  deliverables: Array<UgcDeliverable>;
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  projectKey: Scalars['ID']['output'];
  state: UgcOrderState;
  /**
   * Per-operation affordance checks. Each check answers from both fronts:
   * `validation` (pure order-state predicate, resolved here) and
   * `authorization` (pure access decision, federated from the authz
   * subgraph). A call site treats an operation as permitted only when both
   * legs pass.
   */
  viewerOperationChecks: Array<UgcOrderOperationCheck>;
};


export type UgcOrderViewerOperationChecksArgs = {
  operations: Array<UgcOrderOperation>;
};

export type UgcOrderInput = {
  conceptKey: Scalars['ID']['input'];
  deliverableLinks?: InputMaybe<Array<UgcAssetLinkInput>>;
  projectKey: Scalars['ID']['input'];
};

/**
 * Semantic operations on a UGC order. Values mirror the mutation verbs, never
 * ACL action IDs: several operations share one enforcement action while their
 * state predicates differ.
 */
export enum UgcOrderOperation {
  Approve = 'APPROVE',
  Archive = 'ARCHIVE',
  CreateOffer = 'CREATE_OFFER',
  RevokeOffer = 'REVOKE_OFFER',
  SelectCreator = 'SELECT_CREATOR',
  SetShortlist = 'SET_SHORTLIST',
  UpdateBrief = 'UPDATE_BRIEF',
  WriteDeliverables = 'WRITE_DELIVERABLES'
}

export type UgcOrderOperationCheck = {
  __typename?: 'UGCOrderOperationCheck';
  authorization: ActionCheckResult;
  operation: UgcOrderOperation;
  ugcOrderKey: Scalars['ID']['output'];
  /** Pure domain leg: does the order's state admit this operation. Caller-blind. */
  validation: ActionCheckResult;
};

export enum UgcOrderState {
  Archived = 'ARCHIVED',
  Complete = 'COMPLETE',
  Ideation = 'IDEATION',
  InProduction = 'IN_PRODUCTION',
  InReview = 'IN_REVIEW',
  Pending = 'PENDING'
}

export type UgcOrders = {
  __typename?: 'UGCOrders';
  count: Scalars['Int']['output'];
  nodes: Array<UgcOrder>;
};

/**
 * Some of the concept's specifications have nothing delivered against them.
 * Product copy may call these deliverables; the unit here is specifications.
 */
export type UndeliveredSpecificationsBlocker = WorkflowTransitionBlocker & {
  __typename?: 'UndeliveredSpecificationsBlocker';
  reason: WorkflowTransitionBlockedReason;
  /** How many of the concept's specifications have nothing delivered against them. */
  specifications: Scalars['Int']['output'];
};

/** Some delivered deliverables are unreviewed: neither approved nor under an open revision request. */
export type UnreviewedDeliverablesBlocker = WorkflowTransitionBlocker & {
  __typename?: 'UnreviewedDeliverablesBlocker';
  /** How many delivered deliverables are unreviewed. A specification with nothing delivered against it is not counted here; see UndeliveredSpecificationsBlocker. */
  deliverables: Scalars['Int']['output'];
  reason: WorkflowTransitionBlockedReason;
};

export type UpdateAdvertInput = {
  advert: AdvertUpdateInput;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdvertPayload = {
  __typename?: 'UpdateAdvertPayload';
  advert?: Maybe<Advert>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateAudienceInput = {
  ageRanges?: InputMaybe<Array<AgeRange>>;
  gender?: InputMaybe<TargetGender>;
  incomeLifestyle?: InputMaybe<Scalars['String']['input']>;
  interestsAndBehaviours?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  key: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationalUnitKey: Scalars['ID']['input'];
};

export type UpdateBriefingConceptSpecificationsInput = {
  /** The key of the concept to update. */
  conceptKey: Scalars['ID']['input'];
  /** The briefing formats: the complete replacement set under REPLACE, the formats to add under ADD. */
  formats: Array<BriefingConceptFormatInput>;
  /** How the formats apply to the concept's briefing specifications. */
  mode?: BriefingFormatsMode;
  /** Temporarily preserve legacy original creative BRIEFING specifications while the original creative format flow still uses legacy format events. */
  preserveOriginalCreativeSpecifications?: Scalars['Boolean']['input'];
};

/**  Input for updating a client account.  */
export type UpdateClientAccountInput = {
  /**  The new value for the enableGenerativeAI property.  */
  enableGenerativeAI: Scalars['Boolean']['input'];
  /**  The new value for the enablePlatformAI property.  */
  enablePlatformAI: Scalars['Boolean']['input'];
  /**  The new value for the enableUgcOrdering property.  */
  enableUgcOrdering: Scalars['Boolean']['input'];
  /**  The organizational unit key of the client account to update.  */
  key: Scalars['ID']['input'];
  /**  The new value for the requireHubspotDeals property.  */
  requireHubspotDeals: Scalars['Boolean']['input'];
};

export type UpdateClientBrandInput = {
  defaultProjectVisibility?: InputMaybe<ProjectVisibility>;
  /** The organizational unit key of the client brand */
  key: Scalars['ID']['input'];
  productionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCohortInput = {
  /**
   * When provided, replaces the treatment bindings wholesale (an empty list
   * clears them; at most one binding per treatment; treatments outside the
   * catalog are rejected). Absent means bindings are unchanged.
   */
  bindings?: InputMaybe<Array<CohortTreatmentBindingInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * When provided, replaces the exclusion set wholesale with exactly these
   * principals (an empty list clears it; at most 1000 exclusions). An
   * exclusion bars the principal from membership regardless of source, and
   * cannot coexist with an explicit membership for the same principal —
   * whether both sides arrive in this save or one side is already
   * persisted. Absent means exclusions are unchanged. The save triggers
   * the cohort's membership recompute, like membershipRule.
   */
  memberExclusions?: InputMaybe<Array<PrincipalRefInput>>;
  /**
   * When provided, replaces the membership wholesale with exactly these
   * principals (an empty list clears the membership; at most 1000 explicit
   * members; v1 admits USER-kind principals). Absent means membership is
   * unchanged. Principals are the membership currency end to end — the
   * admin surface uses user attributes to FIND people, but what it binds
   * is the principal.
   */
  memberPrincipals?: InputMaybe<Array<PrincipalRefInput>>;
  /**
   * When provided, replaces the rule-based membership source wholesale (an
   * empty list removes the rule, which converges its compiled member rows
   * away; predicates outside the trait catalog are rejected). Absent means
   * the rule is unchanged. The save triggers the membership compiler's
   * cohort-scoped recompute, so compiled rows reconverge shortly after the
   * save commits.
   */
  membershipRule?: InputMaybe<Array<TraitPredicateInput>>;
  name: Scalars['String']['input'];
};

export type UpdateConceptNotesInput = {
  additionalNotes: Scalars['String']['input'];
  heroNotes: Scalars['String']['input'];
  integrationKey: Scalars['ID']['input'];
};

export type UpdateConceptWorkflowInput = {
  /** The key of the concept to update. */
  key: Scalars['ID']['input'];
  /** The new workflow stage to set for the concept. */
  workflowStageCode?: InputMaybe<WorkflowStageCode>;
  /** The new workflow step to set for the concept. */
  workflowStepKey?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCreativeXBrandInput = {
  /** The organizational unit key of the client brand */
  clientBrandKey: Scalars['ID']['input'];
  /** The CreativeX brand ID */
  externalBrandID: Scalars['Int']['input'];
};

export type UpdateCreativeXIntegrationInput = {
  /** The client's own CreativeX API key: required when enabling on OWN_ACCOUNT, refused otherwise (on SHARED_WORKSPACE, or when disabling) */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** The organizational unit key of the client account — the account itself, not a brand or group beneath it */
  clientAccountKey: Scalars['ID']['input'];
  /** Whether CreativeX operates for the client account. Disabling keeps the existing workspace selection (still readable as `selection`); enabling always names one. */
  enabled: Scalars['Boolean']['input'];
  /**
   * Which CreativeX workspace the client account uses. Required when enabling
   * (a find-or-create selection: the tenant-shared workspace, or the client's
   * own account placed under this unit); refused when disabling, which keeps
   * the existing selection.
   */
  selection?: InputMaybe<CreativeXAccountSelection>;
};

export type UpdateCsReviewNotesInput = {
  /** Notes for CS review. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Integration key of the project brief to update. */
  projectIntegrationKey: Scalars['ID']['input'];
};

/** Input for updating a custom property definition. Omitted fields are unchanged. */
export type UpdateCustomPropertyDefinitionInput = {
  /** Updated configuration for this definition. */
  config?: InputMaybe<CustomPropertyConfigInput>;
  /**
   * The icon to keep or set: an https image URL or inline SVG markup. Null
   * returns it to the UI's default glyph for the type, so send the current icon
   * to keep it.
   */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Updated display label for this property. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Updated options for SELECT definitions. */
  options?: InputMaybe<Array<CustomPropertyOptionInput>>;
  /** Updated header pin for a PROJECT definition. */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Updated display order for this definition. Other definitions of the same
   * owner type shift to make room.
   */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Updated organizational unit keys where this definition applies. */
  scopes?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Input for updating an active user-created SELECT option. The option keeps its
 * key and exact organizational-unit scope; neither scope nor an owning record is
 * accepted from the caller.
 */
export type UpdateCustomPropertyOptionInput = {
  color?: CustomPropertyOptionColor;
  definitionKey: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  optionKey: Scalars['ID']['input'];
};

export type UpdateDeliverableApprovalInput = {
  action: DeliverableApprovalAction;
  keys: Array<Scalars['ID']['input']>;
};

export type UpdateDeliverableFormatInput = {
  creativeGroup?: InputMaybe<CreativeGroup>;
  dimensionId?: InputMaybe<Scalars['ID']['input']>;
  filenameCode?: InputMaybe<Scalars['String']['input']>;
  heroPriority?: InputMaybe<Scalars['Int']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  platformCode: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  trelloLabelName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeliverablesDeliverableInput = {
  /**
   * The Amplify template binding for this create; carries the check
   * `createDeliverableAmplifyIntegrations` carries today. PROPOSED (single-save
   * contract); refused until built.
   */
  amplifyIntegration?: InputMaybe<DeliverableAmplifyIntegrationInput>;
  /** The audio asset associated to the Deliverable asset. */
  audio?: InputMaybe<DeliverableAudioInput>;
  /** The bitrate for a Deliverable asset, if it is a video. */
  bitrate?: InputMaybe<Scalars['Int64']['input']>;
  /** The bitrate mode for a Deliverable asset if it is a video. */
  bitrateMode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Placement by concept: the slot this deliverable lands in when the caller
   * holds no specification key, named by this concept and by
   * `copyVariationNumber` (absent or 0: the concept's original variant). The
   * slot's identity is otherwise the item's own attributes — `deliverableFormatKey`
   * (the platform, the format name and the custom-dimension flag resolve from
   * it), `formatLength`, `formatWidth`, `formatHeight`, `measurementUnit`,
   * `languageCode`, `localeKey`, `unitNumber`. `hero` is not part of that
   * identity: it is a creation attribute the specification service sets on a
   * specification it creates, and it never selects an existing one. Exclusive
   * with `specificationKey`. Today a create placed by concept lands with no
   * specification; once the single-save contract is built
   * (docs/uploader-single-save-mutation/SCOPE.md) the specification service
   * ensures the slot (find-or-create on that identity) and the variant as
   * asynchronous commands after the batch commits — a create inserted
   * concept-placed, an update keeping its current placement — and the row takes
   * its specification when the reply lands, promised by the payload's
   * `writeToken`; the specification service may instead REFUSE the ensure
   * with its own reason, which the row records (`placement`). On an update
   * this field re-attempts the row's OWN placement (erratum D-RC-A): it must
   * be the row's concept, and it never moves the row — a saved deliverable
   * moves to another concept by naming a specification of that concept in
   * `specificationKey` (the upload page ensures that slot first), and takes
   * the specification's concept with it (D-B0-3-H (a)). The re-attempt
   * runs for a row that holds no specification — one the lane refused —
   * under a fresh attempt, and for any row whose placement reply is still
   * outstanding, which asks again under the SAME attempt (a reply that never
   * arrives would otherwise leave the row PENDING for good; D-9377-A); while
   * that reply is outstanding the slot's identity — format, length,
   * dimensions, unit, language, locale, unit number, variation — cannot
   * change, and a save that changes it is refused until the reply lands. A
   * placed row whose attempt was answered is left alone.
   */
  conceptKey?: InputMaybe<Scalars['ID']['input']>;
  /** Indication of whether the deliverable contains AI. */
  containsAi?: InputMaybe<Ternary>;
  /** The Copy Variation Number associated to the Deliverable asset. */
  copyVariationNumber?: InputMaybe<Scalars['Int']['input']>;
  /** The key of the deliverable format to be attached by this deliverable. */
  deliverableFormatKey?: InputMaybe<Scalars['ID']['input']>;
  /** The duration of the deliverable. */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** A secondary file name for the Deliverable when exporting. */
  exportFileName?: InputMaybe<Scalars['String']['input']>;
  /** The key of the File to be associated to this deliverable. */
  fileKey?: InputMaybe<Scalars['ID']['input']>;
  /** The original name of the Deliverable file when it was uploaded. */
  fileName: Scalars['String']['input'];
  /** The file size of the Deliverable file in bytes. */
  fileSize?: InputMaybe<Scalars['Int64']['input']>;
  /** The file type of the deliverable. */
  fileType?: InputMaybe<DeliverableFileType>;
  /** The height of the format requested. */
  formatHeight: Scalars['Float']['input'];
  /** The format length category for the Deliverable. */
  formatLength?: InputMaybe<FormatLength>;
  /** The width of the format requested. */
  formatWidth: Scalars['Float']['input'];
  /** The Frame rate of the Deliverable asset, if it is a video. */
  framesPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** The actual height of the Deliverable, extracted from the file when uploaded. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Flags the Deliverable asset as the hero Deliverable for that order. */
  hero: Scalars['Boolean']['input'];
  /** The key of the target deliverable. */
  key?: InputMaybe<Scalars['ID']['input']>;
  /** The Language associated to the Deliverable asset. */
  languageCode: Scalars['String']['input'];
  /** The locale associated with the Deliverable asset. */
  localeKey?: InputMaybe<Scalars['ID']['input']>;
  /** The measurement unit the format dimensions are represented in. */
  measurementUnit: MeasurementUnit;
  /** The key of the Deliverable Specification to be associated to this deliverable. */
  specificationKey?: InputMaybe<Scalars['ID']['input']>;
  /** Unit number associated to the Deliverable asset to prevent it being detected as a duplicate. */
  unitNumber: Scalars['Int']['input'];
  /**
   * The name for the variant `copyVariationNumber` names when that variant does
   * not exist yet; ignored when it does, and ignored for the original creative
   * (no `copyVariationNumber`). Only with `conceptKey`, on a create or update. The batch
   * stages the concept service's ensure for that (concept, sequence) ahead of
   * the item's slot ensure, so the variant exists when the slot resolves it,
   * and carries `concept:write` on the concept as `createVariant` does. A name
   * at a sequence a REMOVED variant still holds is refused (`INVALID_ARGUMENT`):
   * the sequence cannot be reused, as `createVariant` refuses it. Needs the
   * command lane: a deployment without it refuses the batch (`INVALID_STATE`)
   * rather than dropping the name.
   */
  variantName?: InputMaybe<Scalars['String']['input']>;
  /** The actual width of the Deliverable, extracted from the file when uploaded. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDeliverablesInput = {
  deliverables: Array<UpdateDeliverablesDeliverableInput>;
  projectKey: Scalars['ID']['input'];
  /**
   * Deliverables to delete in the same batch, ahead of the writes. Disjoint from
   * every `key` in the batch. Each key carries the check
   * `removeDeliverable` carries today — `deliverable:write` on the deliverable —
   * and a refused check refuses the batch. Absent or empty: nothing is deleted.
   * PROPOSED (single-save contract); refused until built.
   */
  removeKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The specifications (slots) the save asks the specification service to
   * remove (docs/specification-delivery-and-removal/SCOPE.md, "The member on
   * the save"). Absent or empty: no removal. BUILT.
   */
  specifications?: InputMaybe<UpdateDeliverablesSpecificationsInput>;
  /**
   * The page's explicit variant edits, carried with the save. A variant an item
   * creates implicitly is its `copyVariationNumber` and `variantName`, not
   * this. Absent or empty: no variant edit. Needs the command lane: a
   * deployment without it refuses the batch (`INVALID_STATE`) rather than
   * dropping the edits.
   */
  variants?: InputMaybe<UpdateDeliverablesVariantsInput>;
  /**
   * The project's working-file changes carried with the save. Absent or empty:
   * no working-file change. One asynchronous command applies both sets atomically
   * in the project service. Adding an already-discarded file rejects this whole
   * working-file batch with a durable conflict and no partial roster changes.
   * workingFilesResult identifies this save's pending or terminal batch result;
   * writeToken promises its completion to workingFiles(atLeast:). A terminal
   * conflict is converged, but not applied. Other save participants may already
   * have committed. Accepted only where the atomic command lane is on;
   * otherwise the save is refused as INVALID_STATE.
   */
  workingFiles?: InputMaybe<UpdateDeliverablesWorkingFilesInput>;
};

export type UpdateDeliverablesResponse = {
  __typename?: 'UpdateDeliverablesResponse';
  /**
   * Convergence disclosure for this mutation's own promise (D-PL-A): after
   * the commit the mutation waits, bounded (the deliverable module's own
   * budget, inside the request's deadline), for placement/removal attempts and
   * variant edits to receive terminal answers, and discloses what it saw.
   * `fenced` true for every save that committed a version; `converged` true
   * when every attempt was answered before the payload's rows were read (so
   * they carry the answers), false with the project's entry in `uncovered`
   * when the budget expired first. `converged` true: reload plainly. False:
   * reload with `atLeast` set to `writeToken` and act on that read's
   * disclosure. A save with no promise to wait on (no tenancy, no committed
   * version) claims nothing.
   */
  convergence: ConvergenceMeta;
  /**
   * The rows this save wrote, read back after the bounded wait below. This
   * is the uploader's own read (docs/deliverable-status-seam/SCOPE.md,
   * D-B0-6-D (a)): a row the save parked awaiting its placement reply, or
   * one the reply refused, is here with its `placement` outcome, although
   * every other read leaves it out until it is placed.
   */
  deliverables: Array<Deliverable>;
  /** Exact working-file attempt from this save; null when no member was sent. */
  workingFilesResult?: Maybe<WorkingFileBatchResult>;
  /**
   * Opaque authenticated write-token for this mutation's committed write — the
   * caller's causal anchor ("a read presenting this token happens-after these
   * writes"). Minted at commit with the project's deliverables version,
   * promising placement and removal attempts, and the project variant
   * prefix when this save has variant obligations. Its entries are
   * subject versions, never transport offsets. Present it back verbatim as
   * `atLeast` on fence-aware read surfaces to ask for read-your-writes; a
   * projection that cannot honour it serves its current answer and discloses
   * the miss in that surface's convergence meta. Null when the serving
   * deployment holds no signing material or the request carries no tenancy —
   * treat null as "no anchor available" and read unfenced.
   */
  writeToken?: Maybe<Scalars['String']['output']>;
};

/**
 * The slots a save asks to remove — the uploader's "Delete format" items,
 * staged in its draft and sent on the existing Save. Each key names a
 * specification of the batch's project; the batch is refused before any write
 * when a key is any item's `specificationKey` (a replacing create's family is
 * its item's specification), appears twice, or is not the project's. Each key
 * carries the concept service's `concept:write` on the specification's
 * concept, checked before the transaction; a refused check refuses the batch.
 * No admission predicate here: the deliverable service stages one
 * RemoveDeliverableSpecificationCommand per key after the items' slot
 * ensures — behind the same lane switch the placement commands use, so a
 * deployment whose lane is dark refuses the member — and the specification
 * service decides at apply (phase 1 admits only a slot with no deliverable
 * rows at all, archived included) and answers a refusal fact or archives the
 * slot. The payload's `writeToken` promises the removals beside the
 * placements; `DeliverableSpecification.removal` on the reload says what
 * happened.
 */
export type UpdateDeliverablesSpecificationsInput = {
  removeKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateDeliverablesVariantCreateInput = {
  conceptKey: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  /** Positive and unique within the concept; a retry with the same sequence converges. */
  sequence: Scalars['Int']['input'];
};

export type UpdateDeliverablesVariantRenameInput = {
  key: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/**
 * Explicit variant edits carried by a save. Creates name their sequence, so a
 * retry converges on the same variant (the concept service's ensure finds it
 * and writes nothing); renames and removals name the variant by key and are
 * idempotent the same way. Each edit carries the concept service's
 * `concept:write` check on the variant's concept — on the concept a create
 * names, on the concept resolved from the variant for a rename and a removal
 * — as `createVariant`, `updateVariant` and `removeVariant` carry it today; a
 * refused check refuses the batch, as does a variant the concept service does
 * not know or one of another project. The batch is refused (`INVALID_ARGUMENT`)
 * when a variant key appears in both `rename` and `removeKeys`, when a create
 * names a sequence twice for one concept, when one (concept, sequence) is
 * named with two different names across `create` and the items' `variantName`,
 * when a create names a sequence a REMOVED variant still holds (the sequence
 * cannot be reused, as `createVariant` refuses it), or when a variant removed
 * here is the one an item's `conceptKey` and `copyVariationNumber` name.
 * Applied independently by the concept service as asynchronous commands —
 * creates, then renames, then removals — with durable terminal replies for every
 * edit. Specification dispatch waits for those replies before releasing the
 * save's placement and removal commands, preserving dispatch order across saves.
 * Terminal completion includes accepted edits, no-ops and refusals; convergence
 * does not mean every edit applied, and no cross-edit rollback is promised.
 * The payload's `writeToken` covers the project variant prefix; present it as
 * `atLeast` on the concept's variants roster read.
 */
export type UpdateDeliverablesVariantsInput = {
  create?: InputMaybe<Array<UpdateDeliverablesVariantCreateInput>>;
  removeKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  rename?: InputMaybe<Array<UpdateDeliverablesVariantRenameInput>>;
};

/**
 * Working-file additions and discards form one atomic project-service batch.
 * Requires project:write before Save and again when the command applies. A key
 * in both sets is INVALID_ARGUMENT. An active attachment is already satisfied;
 * adding a discarded attachment conflicts and leaves the complete batch unchanged.
 * Discarding an already-discarded or unknown attachment is a no-op. The receiver
 * persists an immutable applied/conflict/rejected answer; command redelivery
 * replays that answer without reapplying the batch. The payload's exact-attempt
 * workingFilesResult and writeToken, followed by workingFiles(atLeast:), disclose
 * completion and outcome. A working-file conflict does not roll back other
 * participants' already-committed work.
 */
export type UpdateDeliverablesWorkingFilesInput = {
  addKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  discardKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateDimensionInput = {
  height: Scalars['Float']['input'];
  unit: MeasurementUnit;
  width: Scalars['Float']['input'];
};

export type UpdateOrderInput = {
  order: OrderUpdateInput;
};

export type UpdateOrganizationalUnitInput = {
  /**
   * Archive or unarchive the organizational unit.
   * When true, server sets archivedAt to now. When false, clears archivedAt.
   */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<OrganizationalUnitConfigInput>;
  /** Optional hero balance instruction (not persisted on the organizational unit). */
  heroBalance?: InputMaybe<Scalars['Int']['input']>;
  /** Organizational unit integration key. */
  key: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  platformCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceAttributes?: InputMaybe<Scalars['Map']['input']>;
};

export type UpdatePlatformInput = {
  clientFilter?: InputMaybe<PlatformClientFilter>;
  name: Scalars['String']['input'];
  platformTrelloLabel?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A partial update of the viewer's own settings: an omitted field is left as it
 * is, and at least one field must be given.
 */
export type UpdatePrincipalPreferencesInput = {
  /** true to allow product analytics, false to turn it off; omit to leave it unchanged. */
  trackingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateQuestionInput = {
  canHaveNotes: Scalars['Boolean']['input'];
  clientFilter: QuestionClientFilter;
  copilotPrompt?: InputMaybe<Scalars['String']['input']>;
  copyVariation: Scalars['Boolean']['input'];
  deliverableFormats: Array<QuestionDeliverableFormatInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  fixed: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  kind?: InputMaybe<QuestionKind>;
  label?: InputMaybe<Scalars['String']['input']>;
  languageDetection: Scalars['Boolean']['input'];
  minRows?: InputMaybe<Scalars['Int']['input']>;
  options: Array<QuestionOptionInput>;
  organizationalUnitKeys: Array<Scalars['ID']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  required: Scalars['Boolean']['input'];
  sectionKey?: InputMaybe<Scalars['String']['input']>;
  shortLabel?: InputMaybe<Scalars['String']['input']>;
  tooltip?: InputMaybe<Scalars['String']['input']>;
  translatable: Scalars['Boolean']['input'];
};

export type UpdateRenderTemplateSpecificationMappingsInput = {
  assetMappings: Array<RenderTemplateAssetMappingInput>;
  specificationKeys: Array<Scalars['ID']['input']>;
  textMappings: Array<RenderTemplateTextMappingInput>;
};

export type UpdateRoleInput = {
  audiences?: InputMaybe<Array<RoleAudience>>;
  description?: InputMaybe<Scalars['String']['input']>;
  grantChannels?: InputMaybe<Array<RoleGrantChannel>>;
  grantScopeKinds: Array<GrantScopeKind>;
  name: Scalars['String']['input'];
  statements: Array<RoleStatementInput>;
};

export type UpdateUgcBriefInput = {
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  approach?: InputMaybe<ConceptApproach>;
  brandDescription?: InputMaybe<Scalars['String']['input']>;
  brandProductPositioning?: InputMaybe<Scalars['String']['input']>;
  brandRelevantSocialChannels?: InputMaybe<Scalars['String']['input']>;
  conceptDirection?: InputMaybe<Scalars['String']['input']>;
  creatorAdditionalRequirements?: InputMaybe<Scalars['String']['input']>;
  creatorAge?: InputMaybe<AgeRangePreference>;
  creatorEthnicity?: InputMaybe<Scalars['String']['input']>;
  creatorGender?: InputMaybe<GenderPreference>;
  creatorInterestsAndHobbies?: InputMaybe<Scalars['String']['input']>;
  creatorLocation?: InputMaybe<Scalars['String']['input']>;
  deliverable?: InputMaybe<Scalars['String']['input']>;
  dosAndDonts?: InputMaybe<Scalars['String']['input']>;
  languageCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  legalRequirements?: InputMaybe<Scalars['String']['input']>;
  productProcurement?: InputMaybe<Scalars['String']['input']>;
  referenceLinks?: InputMaybe<Array<UgcAssetLinkInput>>;
  scriptOrVoiceOverInstructions?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<UgcBriefSection>>;
  theHook?: InputMaybe<Scalars['String']['input']>;
  ugcOrderKey: Scalars['ID']['input'];
  uniqueSellingPoints?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUgcDeliverableInput = {
  key: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  /** Email address belonging to the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Given name of the user */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Integration key of the user to update */
  key: Scalars['ID']['input'];
  /** ABAC labels attached to the user. */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Family name of the user */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVariantInput = {
  /** The key of the variant to update. */
  key: Scalars['ID']['input'];
  /** The name of the variant. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVariantSpecificationsInput = {
  /** The key of the parent concept for this variant. */
  conceptKey: Scalars['ID']['input'];
  /** New formats to add as variation specifications for the variant. */
  formats?: InputMaybe<Array<InputMaybe<FormatInput>>>;
  /** Language code to apply to all specifications managed by this mutation. */
  languageCode: Scalars['String']['input'];
  /** Base specification keys to vary for this variant. */
  sourceSpecificationKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The key of the variant grouping. */
  variantKey: Scalars['ID']['input'];
};

export type UpdateWorkingFilesInput = {
  input: WorkingFilesUpdateInput;
};

/** A user account. */
export type User = {
  __typename?: 'User';
  /** The UTC timestamp when the user was archived */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The Auth0 user associated with this user. */
  auth0User?: Maybe<Auth0User>;
  /** The UTC timestamp when the user was created */
  createdAt?: Maybe<Scalars['Time']['output']>;
  /** Email address belonging to the user */
  email?: Maybe<Scalars['String']['output']>;
  /** Given name of the user */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Full name of the user (first name + last name) */
  fullName?: Maybe<Scalars['String']['output']>;
  /**
   * Principal grants assigned to this user. Optional filters mirror
   * grantsByPrincipal for consistency.
   */
  grants: PrincipalGrantConnection;
  /** A unique identifier for the user. */
  key: Scalars['ID']['output'];
  /** ABAC labels attached to the user. */
  labels: Array<Scalars['String']['output']>;
  /** Family name of the user */
  lastName?: Maybe<Scalars['String']['output']>;
  /** URL to the users avatar/profile picture */
  picture?: Maybe<Scalars['String']['output']>;
  /** The UTC timestamp when the user was last updated */
  updatedAt?: Maybe<Scalars['Time']['output']>;
};


/** A user account. */
export type UserGrantsArgs = {
  atScopes?: InputMaybe<Array<GrantScopeInput>>;
  pagination?: InputMaybe<OffsetPagination>;
};

export type Users = {
  __typename?: 'Users';
  meta: OffsetPageInfo;
  nodes: Array<User>;
};

export type UsersFilter = {
  /**
   * Filter to active/archived users, or both
   * Default: FALSE
   */
  archived?: InputMaybe<ArchivedFilter>;
  key?: InputMaybe<IdFilter>;
  /** Substring search over email, name and auth0 user id */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Users with any matching label. */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Intersect with users authorized for this action/resource. */
  resourceAccess?: InputMaybe<ResourceAccessFilter>;
};

export type UsersParams = {
  filter?: InputMaybe<UsersFilter>;
  pagination?: InputMaybe<OffsetPagination>;
  sort?: InputMaybe<SortInput>;
};

/** A variant represents a named grouping of content (specifications and deliverables) within a concept. */
export type Variant = {
  __typename?: 'Variant';
  /** The key of the concept the variant belongs to. */
  conceptKey: Scalars['ID']['output'];
  /**
   * The number of active deliverables under this variant, counting the latest
   * deliverable per specification (if it exists).
   */
  deliverableCount: Scalars['Int']['output'];
  /** The unique identifier for the variant. */
  key: Scalars['ID']['output'];
  /** The name of the variant. */
  name: Scalars['String']['output'];
  /** The immutable sequence number of the variant within its concept. */
  sequence: Scalars['Int']['output'];
  /** The list of deliverable specifications associated with the variant. */
  specifications: DeliverableSpecifications;
  /** The type of the variant. */
  type: VariantType;
  /**
   * Advisory operation-check answers for this variant. Nullable by contract
   * (fleet rule P1): the surface is a UX guard, not enforcement, so a
   * consumer that cannot get an answer treats null as not-permitted and
   * degrades — a failed check hop must never take the page data down with it.
   */
  viewerOperationChecks?: Maybe<Array<VariantOperationCheck>>;
};


/** A variant represents a named grouping of content (specifications and deliverables) within a concept. */
export type VariantSpecificationsArgs = {
  params?: InputMaybe<DeliverableSpecificationsParams>;
};


/** A variant represents a named grouping of content (specifications and deliverables) within a concept. */
export type VariantViewerOperationChecksArgs = {
  operations: Array<VariantOperation>;
};

/**
 * Semantic operations on a variant. Values are user-intent affordance verbs
 * (the fleet contract, docs/viewer-operation-checks/SCOPE.md), never ACL
 * action IDs: the enforcement actions are the authz subgraph's concern —
 * documented on its declaration's value doc strings — while the state
 * predicates live here. Declared identically in both subgraphs.
 */
export enum VariantOperation {
  /**
   * Capability to remove this variant: preflights the same concept:write
   * decision at the variant's concept that removeVariant enforces, where the
   * mutation resolves the variant to its concept itself.
   */
  Remove = 'REMOVE'
}

/**
 * The clearable obstacles behind a refused REMOVE validation (fleet rule P3):
 * each names a fact about the variant the caller can change, rendered as the
 * disabled item's reason. A refusal nothing clears — a variant that does not
 * resolve or is already archived, or the ORIGINAL — names none.
 */
export enum VariantOperationBlocker {
  /** The variant's concept is archived. */
  ConceptArchived = 'CONCEPT_ARCHIVED',
  /**
   * A file is landing on a live format of the variant: a placement the
   * specification service answered with the format whose reply the
   * deliverable service has not applied yet.
   */
  FileLanding = 'FILE_LANDING',
  /**
   * A live format of the variant holds a live file: any version, any status,
   * whoever can see it.
   */
  HoldsFiles = 'HOLDS_FILES'
}

/**
 * The check entry and its `authorization` leg are the authz subgraph's (which
 * declares Variant with `viewerOperationChecks`); this subgraph contributes
 * the `validation` leg and the blockers disclosure. Its resolvable key is the
 * sanctioned hop for the domain half of the two-leg check.
 */
export type VariantOperationCheck = {
  __typename?: 'VariantOperationCheck';
  authorization: ActionCheckResult;
  /**
   * The clearable obstacles refusing the operation, in the vocabulary's
   * order. Empty when validation passes, and when the variant itself refuses
   * (it does not resolve, it is archived, or it is the ORIGINAL).
   */
  blockers: Array<VariantOperationBlocker>;
  operation: VariantOperation;
  /**
   * Pure domain leg, caller-blind: whether the variant's current state admits
   * the operation. A variant the read cannot resolve, one already archived,
   * and the ORIGINAL are refused.
   */
  validation: ActionCheckResult;
  variantKey: Scalars['ID']['output'];
};

export enum VariantType {
  /** The base or master version of a concept's content. */
  Original = 'ORIGINAL',
  /** A derivative version of existing content, often adapted for different audiences or purposes. */
  Variation = 'VARIATION'
}

export type Variants = {
  __typename?: 'Variants';
  /** The bounded variant-roster read's convergence disclosure. */
  convergence: ConvergenceMeta;
  nodes: Array<Variant>;
};

export type Vertical = {
  __typename?: 'Vertical';
  key: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Verticals = {
  __typename?: 'Verticals';
  metadata: Metadata;
  nodes: Array<Vertical>;
};

export type WorkflowStage = {
  __typename?: 'WorkflowStage';
  /** The unique identifier for the workflow stage. */
  code: WorkflowStageCode;
  /** The name of the workflow stage. */
  name: Scalars['String']['output'];
  /** The position of the workflow stage within the tenant workflow catalogue. */
  position: Scalars['Int']['output'];
  /** The list of steps that can be selected in this stage. */
  steps: WorkflowSteps;
};

export enum WorkflowStageCode {
  Approved = 'APPROVED',
  Briefing = 'BRIEFING',
  DeliveryReview = 'DELIVERY_REVIEW',
  Preproduction = 'PREPRODUCTION',
  Production = 'PRODUCTION',
  /** Summary fallback for unrecognized stages; never a transition destination. */
  Unspecified = 'UNSPECIFIED'
}

export type WorkflowStages = {
  __typename?: 'WorkflowStages';
  /** The list of workflow stages. */
  nodes: Array<WorkflowStage>;
};

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  /** The unique identifier for the workflow step. */
  key: Scalars['ID']['output'];
  /** The name of the workflow step. */
  name: Scalars['String']['output'];
  /** The position of the workflow step within its workflow stage. */
  position: Scalars['Int']['output'];
};

export type WorkflowSteps = {
  __typename?: 'WorkflowSteps';
  /** The list of workflow steps. */
  nodes: Array<WorkflowStep>;
};

/**
 * A UI surface that offers a single recommended transition, used to choose
 * workflowTransitionOffer. Which transitions belong to which surface is
 * configured on the server; some transitions belong to no surface.
 */
export enum WorkflowSurface {
  /**
   * No particular surface: the recommendation across every transition the
   * concept has, including those that belong to no surface.
   */
  All = 'ALL',
  /** The brief's submit action. */
  BriefSubmission = 'BRIEF_SUBMISSION',
  /** The delivery page's prompt after additional formats are confirmed. */
  Delivery = 'DELIVERY',
  /** The finish-review action on review surfaces. */
  ReviewCompletion = 'REVIEW_COMPLETION'
}

/** Why a transition is blocked. Each value corresponds to one WorkflowTransitionBlocker implementation. */
export enum WorkflowTransitionBlockedReason {
  /** The concept's brief is incomplete — BriefInvalidBlocker. */
  BriefInvalid = 'BRIEF_INVALID',
  /** The concept already has deliverables — ExistingDeliverablesBlocker. */
  ExistingDeliverables = 'EXISTING_DELIVERABLES',
  /** Nothing has been delivered yet — NoDeliverablesBlocker. */
  NoDeliverables = 'NO_DELIVERABLES',
  /** Deliverables have open revision requests — OpenRevisionsBlocker. */
  OpenRevisions = 'OPEN_REVISIONS',
  /** Specifications have nothing delivered against them — UndeliveredSpecificationsBlocker. */
  UndeliveredSpecifications = 'UNDELIVERED_SPECIFICATIONS',
  /** Delivered deliverables are awaiting review — UnreviewedDeliverablesBlocker. */
  UnreviewedDeliverables = 'UNREVIEWED_DELIVERABLES'
}

/**
 * Something that currently prevents a transition from being enacted and that
 * the user can fix. reason identifies the kind of blocker; each implementation
 * carries exactly the data its reason needs, so a client can switch on reason
 * or __typename and select the typed fields with fragments.
 */
export type WorkflowTransitionBlocker = {
  reason: WorkflowTransitionBlockedReason;
};

/**
 * Something enacting a transition will do besides moving the concept,
 * previewed with the count it would act on as things stand. kind identifies
 * the effect; each implementation carries the count that effect is about.
 * AUTO_APPROVE_DELIVERABLES and REVISE_DELIVERABLES describe work performed
 * when the transition is enacted; BEGIN_PRODUCTION is informational.
 */
export type WorkflowTransitionEffect = {
  kind: WorkflowTransitionEffectKind;
};

/** The effects a transition can report. Each value corresponds to one WorkflowTransitionEffect implementation. */
export enum WorkflowTransitionEffectKind {
  /** Unreviewed deliverables are approved — AutoApproveDeliverablesEffect. */
  AutoApproveDeliverables = 'AUTO_APPROVE_DELIVERABLES',
  /** The concept goes into production on its unproduced specifications — BeginProductionEffect. Informational only. */
  BeginProduction = 'BEGIN_PRODUCTION',
  /** Deliverables are sent back for revision — ReviseDeliverablesEffect. */
  ReviseDeliverables = 'REVISE_DELIVERABLES'
}

export enum WorkflowTransitionOutcome {
  /** The transition was applied. */
  Applied = 'APPLIED',
  /** The transition was not applied because something blocks it; blockedReasons says what. */
  Blocked = 'BLOCKED',
  /**
   * The transition is not available to this concept as it stands: the viewer
   * may not enact it, its preconditions are no longer met, or the concept has
   * moved since the transitions were read. These cases are deliberately not
   * distinguished; refetch workflowTransitions.
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * A condition on the transition could not be checked, so nothing was
   * applied. Retrying may succeed.
   */
  Unevaluated = 'UNEVALUATED'
}

export type WorkingFile = {
  __typename?: 'WorkingFile';
  file: File;
  id: Scalars['ID']['output'];
  /** @deprecated Use `file` instead. */
  integrationKey: Scalars['ID']['output'];
  uploader?: Maybe<Principal>;
};

export type WorkingFileBatchResult = {
  __typename?: 'WorkingFileBatchResult';
  attemptKey: Scalars['ID']['output'];
  /** Stable batch reason. Unavailable files disclose no foreign ownership. */
  reason?: Maybe<Scalars['String']['output']>;
  status: WorkingFileBatchStatus;
};

/** The whole working-file member's result, independent of other save participants. */
export enum WorkingFileBatchStatus {
  Applied = 'APPLIED',
  Conflict = 'CONFLICT',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type WorkingFiles = {
  __typename?: 'WorkingFiles';
  /** Result of the exact working-file version requested by atLeast; never the latest attempt. */
  batchResult?: Maybe<WorkingFileBatchResult>;
  convergence: ConvergenceMeta;
  nodes: Array<WorkingFile>;
};

export type WorkingFilesUpdateInput = {
  projectKey: Scalars['ID']['input'];
  workingFileKeys: Array<Scalars['ID']['input']>;
};

export type Join__ContextArgument = {
  context: Scalars['String']['input'];
  name: Scalars['String']['input'];
  selection: Scalars['join__FieldValue']['input'];
  type: Scalars['String']['input'];
};

export enum Join__Graph {
  Authz = 'AUTHZ',
  AutoDelivery = 'AUTO_DELIVERY',
  Briefing = 'BRIEFING',
  Concept = 'CONCEPT',
  Copilot = 'COPILOT',
  CreativeX = 'CREATIVE_X',
  Creator = 'CREATOR',
  Customer = 'CUSTOMER',
  CustomProperties = 'CUSTOM_PROPERTIES',
  Deliverable = 'DELIVERABLE',
  GenerativeEditor = 'GENERATIVE_EDITOR',
  Organization = 'ORGANIZATION',
  ProductCatalog = 'PRODUCT_CATALOG',
  Project = 'PROJECT',
  QualityAssurance = 'QUALITY_ASSURANCE',
  Revision = 'REVISION',
  Specification = 'SPECIFICATION',
  Storage = 'STORAGE',
  User = 'USER'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type UpdateCreativeXNotesInput = {
  deliverableKey: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};
